<template>
  <div  v-resize="onResize"> 
    <div>
     <v-snackbar
        top
        app
        :max-width="1200"
        color ="warning"
        :timeout="-1"
        v-model="snackbar_expired"
      >
        <v-alert
          class="float-left mb-0"
          :max-width="1200"
          textda Turin
          dense
          transition="scale-transition"
          type="error"
        >
          <v-row
            align="center"
            no-gutters
            v-if="expired"
          >
            <v-col v-if="expired.expired" class="grow font-weight-bold">
              Modulo Scaduto il {{expired.expiry}}: Vai al carrello per riattivarlo
            </v-col>
            <v-col v-else class="font-weight-bold">
              Questo Modulo scade il {{expired.expiry}}: <br />Vai al carrello per Estenderne la durata
            </v-col>
            <v-col class="shrink font-weight-bold pl-8">
              <v-btn
                small
                to='/settings/?pageId=services'
                color="info"                            
              >
                Estendi
              </v-btn>
            </v-col>
          </v-row>
          
        </v-alert>
  
        <template v-slot:action="{ attrs }">
          <v-btn
            color="black"
            text
            v-bind="attrs"
            @click="snackbar_expired = false"
          >
            OK
          </v-btn>
        </template>
      </v-snackbar>      
      <div class="mt-6">
				<v-row v-if="settings.level>=40">
          <v-spacer></v-spacer>
					<div class="d-flex justify-space-around my-0">          
            <div class="pl-2">
              <template v-if="settings.level>=40">
                <v-btn-toggle v-model="mealId" active-class="info">
                  <v-btn 
                    v-for="(m,m2) in meals" :key="m2"
                    v-bind="attrs" v-on="on"
                    :x-large="$vuetify.breakpoint.lg"
                    :small="$vuetify.breakpoint.xs"
                    :class="$vuetify.breakpoint.mdAndDown?'px-2 neu-glow':'px-6 neu-glow'"
                    :height="55"
                    :min-width="130"
                    :value="m.mealId"
                  >
                    <v-badge
                      v-if="m2%2"
                      :content="bookings.filter(b=>b.active&&b.confirmed).reduce((a,c) => a + c.covers + c.children,0)"
                      color="info"
                      top
                      class="mr-1"
                      :left="m2%2"
                      offset-y="-22"
                      offset-x="-22" 
                      :value="bookings.filter(b=>b.active&&b.confirmed).reduce((a,c) => a + c.covers + c.children,0)!=0"
                    >
                    </v-badge> 
                    <!--
                    <v-badge
                      :content="bookings.filter(b=>b.active&&b.confirmed&&b.mealId==m.mealId).reduce((a,c) => a + c.covers+c.children,0)"
                      color="black"
                      bottom
                      :left="!m2%2"
                      :value="bookings.filter(b=>b.active&&b.confirmed&&b.mealId==m.mealId).reduce((a,c) => a + c.covers+c.children,0)!=0"
                    >
                    </v-badge> 
                    -->
                    <span>
                      <div>
                        {{m.name}}
                      </div>
                      <div class="d-flex justify-center mt-1">
                          <!--<div style="max-width: 50px;min-width:28px;background-color: white;border-radius: 50%;color: black;font-weight: 800;" class="pa-1">-->
                            {{bookings.filter(b=>b.active&&b.confirmed&&b.mealId==m.mealId).reduce((a,c) => a + c.covers+c.children,0)}}
                          <!--</div>-->
                      </div>                       
                    </span>
                                       
                  </v-btn>
                </v-btn-toggle>
              </template>
            </div>         
          </div>
          <v-spacer></v-spacer>
          <div>
            <v-tooltip top v-if="settings.level>=40">
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="GetDate(0)" :small="$vuetify.breakpoint.xs" v-bind="attrs" fab :class="$vuetify.breakpoint.xs?'neu-glow mr-5 mt-5':'neu-glow mr-5'" active-class="neu-glow-inset" v-on="on" :loading="loading">
                  <v-icon 
                    large
                    color="info"
                    class="mx-3"
                    active-class="neu-glow-inset"
                    >
                      mdi-sync-circle
                  </v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>  
          </div>
          <v-spacer></v-spacer>
          <div  class="d-flex justify-space-around" :style="$vuetify.breakpoint.xs?'width:100%':''">
						<div class="text-h5 ml-3">
              <v-btn
                @pointerdown="startPress"
                @pointerup="cancelPress"
                @pointerleave="cancelPress"
                @contextmenu.prevent
                @click="handleClick"
                :loading="loading" 
                fab 
                :small="$vuetify.breakpoint.xs" 
                class="neu-glow mr-3" 
                active-class="neu-glow-inset"
                v-if="settings.level>60||(new Date(date)>new Date())"
              >              
                <v-icon large color="info" >mdi-arrow-left-bold</v-icon>
              </v-btn>
              <v-btn v-if="$vuetify.breakpoint.xlOnly" x-large text @click="getMonthlyBookings()" class="text-h6 mt-1 " style="text-align:center;min-width:260px" >
                {{dateString}}
              </v-btn>
              <v-btn v-else x-large text @click="getMonthlyBookings()" class="text-h6 mt-1" style="text-align:center;max-width:160px" >
                {{dateString2}}
              </v-btn>
              <v-btn :loading="loading" fab :small="$vuetify.breakpoint.xs" class="neu-glow ml-3" active-class="neu-glow-inset" @click="GetDate(1)" v-if="settings.level>=40">
                <v-icon large color="info">mdi-arrow-right-bold</v-icon>
              </v-btn>
						</div>
          </div>
          <v-spacer></v-spacer>
          <div :class="$vuetify.breakpoint.mdAndDown?'d-flex flex justify-space-around my-3':'d-flex justify-end'"  v-if="settings.level>=50">   
            <div class="d-flex flex-wrap mx-3 pb-4 justify-center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="openDialogWalkIn()" fab :small="$vuetify.breakpoint.xs" class="neu-glow mr-4" :class="dialog_walkIn?'success--text':''" v-bind="attrs" v-on="on" active-class="neu-glow-inset">
                    <v-icon large color="info">mdi-account-plus</v-icon>
                  </v-btn>
                </template>
                <span>Nuova Prenotazione</span>
              </v-tooltip>


              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="openDialog_autoAssign()" fab :small="$vuetify.breakpoint.xs" class="neu-glow mr-4" :class="dialog_autoAssign?'success--text':''" v-bind="attrs" v-on="on" active-class="neu-glow-inset">
                    <v-icon large color="success">mdi-auto-fix</v-icon>
                  </v-btn>
                </template>
                <span>Assegnazione Automatica Tavoli</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="openDialog_DisableTables()" fab :small="$vuetify.breakpoint.xs" class="neu-glow mr-4" :class="dialog_disableTable?'error--text':''"  v-bind="attrs" v-on="on" active-class="neu-glow-inset">
                    <v-icon large color="purple">mdi-table-furniture</v-icon>
                  </v-btn>
                </template>
                <span>Disabilita Tavoli</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="openDialogPanView()" fab :small="$vuetify.breakpoint.xs" class="neu-glow" :loading="loading_panView" :class="dialog_assignedHalls?'success--text mr-4':'mr-4'"  v-bind="attrs" v-on="on" active-class="neu-glow-inset">
                    <v-icon large color="warning">mdi-table-clock</v-icon>
                  </v-btn>
                </template>
                <span>Occupazione Sale</span>
              </v-tooltip>
              <!--
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="ShowiManagerMap()" v-model="iManagerMapSwitch" fab :small="$vuetify.breakpoint.xs" class="neu-glow mr-4" :class="mapDiv?'success--text':''" :disabled="!activeLocationId&&!activeHallId" v-bind="attrs" v-on="on" active-class="neu-glow-inset">
                    <v-icon large color="info" >mdi-view-grid</v-icon>
                  </v-btn>
                </template>
                <span>Visualizza Mappa</span>
              </v-tooltip>   
              -->  

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="getDataPDF()" fab :small="$vuetify.breakpoint.xs" class="neu-glow mr-4" :disabled="statusPDF==1" v-bind="attrs" v-on="on" active-class="neu-glow-inset">
                    <v-icon large :color="clrPDF[statusPDF]" >mdi-download</v-icon>
                  </v-btn>
                </template>
                <span>{{txtPDF[statusPDF]}}</span>
              </v-tooltip>                     

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="showCancelledBooking()" fab :small="$vuetify.breakpoint.xs" class="neu-glow mr-4" :class="showCancelled?'error--text':''" v-bind="attrs" v-on="on" active-class="neu-glow-inset">
                    <v-icon large >mdi-delete-restore</v-icon>
                  </v-btn>
                </template>
                <span>Visualizza Cancellati</span>
              </v-tooltip>

              <template>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn :small="$vuetify.breakpoint.xs" v-bind="attrs" v-on="on" fab class="neu-glow mr-4" @click="dialog_DirectBookingLock=true" active-class="neu-glow-inset">
                      <v-icon 
                        large
                        :color="settings.options.disableSameDayDirectBooking!=dsddb?'success':'error'"
                        >
                          mdi-lock
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{settings.options.disableSameDayDirectBooking!=dsddb?'Online Booking Attivo':'Online Booking Disabilitato'}}</span>
                </v-tooltip>
              </template>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="dialog_helpGlobal=true" fab :small="$vuetify.breakpoint.xs" class="neu-glow" :class="dialog_helpGlobal?'neu-glow-inset success--text mr-8':'mr-8'"  v-bind="attrs" v-on="on" active-class="neu-glow-inset">
                    <v-icon large color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>

              <template v-if="$vuetify.breakpoint.smAndDown&&showiManagerMap">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn  @click="$vuetify.goTo($refs.volanteSlim, {duration: 500,offset: 0,easing: 'easeInOutCubic'})" fab :small="$vuetify.breakpoint.xs" class="neu-glow" :class="dialog_helpGlobal?'neu-glow-inset success--text mr-8':'mr-8'"  v-bind="attrs" v-on="on" active-class="neu-glow-inset">
                      <v-icon large color="info">mdi-flash</v-icon>
                    </v-btn>
                  </template>
                  <span>Vai a Volante Veloce</span>
                </v-tooltip>
              </template>              

            </div>
					</div>
				</v-row>
        <!--
				<v-row v-else>
					<v-col class="d-flex justify-space-around" cols="12" md="6" lg="2">          
            <div class="mr-5">
              <template v-if="settings.level>=40">
                <v-btn-toggle v-model="mealId" mandatory active-class="">
                  <v-btn 
                    v-for="(m,m2) in meals" :key="m2"
                    v-bind="attrs" v-on="on"
                    :x-large="$vuetify.breakpoint.lg"
                    :small="$vuetify.breakpoint.xs"
                    :class="$vuetify.breakpoint.mdAndDown?'px-2 neu-glow':'px-6 neu-glow'"
                    :value="m.mealId"            
                  >
                    <v-badge
                      v-if="m2%2"
                      :content="bookings.filter(b=>b.active&&b.confirmed).reduce((a,c) => a + c.covers + c.children,0)"
                      color="info"
                      top
                      class="mr-1"
                      :left="m2%2"
                      :value="bookings.filter(b=>b.active&&b.confirmed).reduce((a,c) => a + c.covers + c.children,0)!=0"
                    >
                    </v-badge> 

                    <v-badge
                      :content="bookings.filter(b=>b.active&&b.confirmed&&b.mealId==m.mealId).reduce((a,c) => a + c.covers+c.children,0)"
                      color="black"
                      bottom
                      :left="!m2%2"
                      :value="bookings.filter(b=>b.active&&b.confirmed&&b.mealId==m.mealId).reduce((a,c) => a + c.covers+c.children,0)!=0"
                    >
                      {{m.name}}
                    </v-badge>
                  </v-btn>
                </v-btn-toggle>
              </template>
              <v-spacer></v-spacer>
              <v-tooltip top v-if="settings.level>=40">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="GetDate(0)" :small="$vuetify.breakpoint.xs" v-bind="attrs" fab class="neu-glow float-left mr-5" active-class="neu-glow-inset" v-on="on" :loading="loading">
                    <v-icon 
                     large
                      color="info"
                      class="mx-3"
                      active-class="neu-glow-inset"
                      >
                        mdi-sync-circle
                    </v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>              
            </div>
          </v-col>
          <v-col cols="12" md="6" lg="4" :class="$vuetify.breakpoint.mdAndDown?'d-flex justify-center':''">
						<div class="text-h5 ml-3">
              <v-btn :loading="loading" fab :small="$vuetify.breakpoint.xs" class="neu-glow float-left mr-3" active-class="neu-glow-inset" @click="GetDate(-1)" v-if="settings.level>60">
                <v-icon large color="info" >mdi-arrow-left-bold</v-icon>
              </v-btn>
              <v-btn v-if="$vuetify.breakpoint.lgAndUp" x-large text @click="getMonthlyBookings()" class="text-h6 mt-1 float-left" style="text-align:center;min-width:260px" >
                {{dateString}}
              </v-btn>
              <v-btn v-else x-large text @click="getMonthlyBookings()" class="text-h6 float-left" style="text-align:center" >
                {{dateString2}}
              </v-btn>
              <v-btn :loading="loading" fab :small="$vuetify.breakpoint.xs" class="neu-glow ml-3" active-class="neu-glow-inset" @click="GetDate(1)" v-if="settings.level>=40">
                <v-icon large color="info">mdi-arrow-right-bold</v-icon>
              </v-btn>
						</div>
            <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
          </v-col>
				</v-row>
        -->        
				<v-row dense class="mt-1">
					<v-col cols="12">
						<v-card class="neu-glow">
              <v-card-text v-if="!shifts||!halls">
                <v-card :height="wHeight-248" class="text-center mt-14">
                    <v-progress-circular
                      :size="wHeight-500"
                      width="30"
                      color="info"
                      indeterminate
                    ></v-progress-circular>
                </v-card>                
              </v-card-text>
							<v-card-text v-else>
								<v-row dense>
                  <v-col cols="12">
                    <v-row no-gutters ref="canvas_FreeTables">
                      <v-col cols="12" sm="12" md="12" :lg="showiManagerMap||showManualAssignMap?12-mapWidth:12">
                        <v-row no-gutters :class="showiManagerMap||showManualAssignMap?'d-block':''">
                          <v-col>
                            <v-card-title class="pa-0">
                              <template v-if="settings.level>=40">
                                <v-btn-toggle v-model="activeLocationId" active-class="info white--text" class="background ml-3 float-left flex-wrap justify-center" v-if="locations.length>1" style="display:inline">
                                  <v-btn 
                                    v-for="(l,l2) in locations" :key="l2"
                                    :height="55"                                          
                                    :loading="loading"
                                    :value="l.locationId"
                                  >           
                                    <span>
                                      <div>
                                        {{l.name}}
                                      </div>
                                      <div class="d-flex justify-center mt-1">
                                          <!--<div style="max-width: 50px;min-width:28px;background-color: white;border-radius: 50%;color: black;font-weight: 800;" class="pa-1">-->
                                            {{bookings.filter(b=>b.active&&b.confirmed&&b.locationId==l.locationId&&b.mealId==mealId).reduce((a,c) => a + c.covers +c.children,0)}} 
                                          <!--</div>-->
                                      </div>                                      
                                    </span>                                      
                                  </v-btn>
                                </v-btn-toggle>
                                
                                <template v-if="$vuetify.breakpoint.mdAndUp">
                                  <v-btn-toggle v-model="activeHallId"  active-class="info white--text" class="background ml-3 flex-wrap justify-center" v-if="halls&&(locations.length==1&&!activeLocationId||halls.filter(h=>h.locationId==activeLocationId).length>1)" style="display:inline">
                                    <v-btn 
                                      v-for="(m,m2) in halls.filter(h=>(activeLocationId&&h.locationId==activeLocationId)||!activeLocationId)" :key="m2"
                                      v-bind="attrs" v-on="on"
                                      :height="55"
                                      :loading="loading"
                                      :value="m.hallId"
                                    >
                                    <span>
                                      <div>
                                        {{m.hallName}}{{m.name}}
                                      </div>
                                      <div class="d-flex justify-center mt-1">
                                          <!--<div style="max-width: 50px;min-width:28px;background-color: white;border-radius: 50%;color: black;font-weight: 800;" class="pa-1">-->
                                            {{bookings.filter(b=>b.active&&b.confirmed&&b.hallId==m.hallId&&b.mealId==mealId).reduce((a,c) => a + c.covers +c.children,0)}} 
                                          <!--</div>-->
                                      </div>                                      
                                    </span>                                      
                                    </v-btn>
                                  </v-btn-toggle>   
                                  <div>
                                    <v-btn-toggle v-model="activeSlotId" mandatory active-class="info white--text'" :class="$vuetify.breakpoint.xs?'pt-3':''" class="background ml-3 flex-wrap justify-center" v-if="showiManagerMap">  
                                      <v-btn 
                                        v-for="(c,c1) in slots.filter(s=>s.mealId==mealId)" :key="c1"                                      
                                        :height="55"
                                        :loading="loading"
                                        :value="c.slotId"
                                      >
                                        <span>
                                          <div>
                                            {{c.name}}
                                          </div>
                                          <!--
                                          <div class="d-flex justify-center mt-1">
                                              <div style="max-width: 50px;min-width:28px;background-color: white;border-radius: 50%;color: black;font-weight: 800;" class="pa-1">
                                                {{bookings.filter(b=>b.active&&b.confirmed&&b.hallId==activeHallId&&b.mealId==mealId&&b.slotId==activeSlotId).reduce((a,c) => a + c.covers +c.children,0)}} 
                                              </div>
                                          </div>  
                                          -->                                    
                                        </span>                                        
                                      </v-btn>
                                    </v-btn-toggle>
                                    </div>
                                  </template>
                              </template>
                              <v-spacer></v-spacer>
                              <v-text-field
                                v-if="settings.level>=50&&(!showiManagerMap)"
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Cerca:"
                                color="info"
                                single-line
                                hide-details
                                class="float-right"
                                :style="$vuetify.breakpoint.mdAndDown?'max-width:100px':'max-width:250px'"
                              ></v-text-field>
                              
                            </v-card-title>
                          </v-col>
                        </v-row>

                          <v-row v-if="$vuetify.breakpoint.smAndUp" class="mt-0">
                            <v-expand-transition>
                              <div v-if="walkIn.tablesId&&walkIn.tablesId.length" class="v-card neu-glow mt-5 pt-3 mx-6 grey darken-3">
                                <v-alert v-if="userDetails&&userDetails.rating" class="mb-2" dense dismissible :type="userDetails.rating>3?'success':userDetails.rating>0?'warning':'error'">
                                  L'ultima valutazione di questo numero è <span class="font-weight-bold black--text">{{userDetails.rating}}</span>: <span class="font-weight-bold black--text">{{userDetails.ratingRemarks}}</span>
                                </v-alert>
                                <div class="text-h6 pl-4 pb-3">Volante Veloce</div>
                                    <v-row class="mb-0 mx-3">
                                      <v-col class="px-1" cols="6" md="3" xl="3">
                                        <v-autocomplete
                                          color="info"
                                          outlined
                                          v-model="walkIn.countryCode"
                                          :items="countries"
                                          :label="$t(page+'.Country Code')"
                                          hide-details
                                          :item-text="item => item.name +' '+ item.value"
                                          @focus="$set(walkIn, 'countryCode', null)"
                                        >
                                          <template v-slot:item="slotProps" >
                                            <i :class="['mr-2', 'em', slotProps.item.flag]"></i>
                                            {{slotProps.item.namel}} + {{slotProps.item.value}}
                                          </template>
                                          <template v-slot:selection="data">
                                            <i :class="['mr-2', 'em', data.item.flag]"></i>
                                            {{ data.item.value }}
                                          </template>
                                        </v-autocomplete>
                                      </v-col>
                                      <v-col  class="px-1" cols="6" md="3" xl="3">
                                        <v-text-field
                                          prepend-inner-icon="mdi-whatsapp"
                                          color="info"
                                          label="Cellulare"
                                          v-model="walkIn.phone"
                                          name="phone"
                                          type="number"
                                          autocomplete="off"
                                          reverse
                                          hide-spin-buttons
                                          outlined
                                          hide-details
                                          :success="successPhone_status"
                                          :error="errorPhone_status"
                                          :hint="errorPhone"
                                          ></v-text-field>
                                      </v-col>
                                      <v-col  class="px-1" cols="6" md="3" xl="3">
                                        <v-text-field
                                          prepend-inner-icon="mdi-account"
                                          color="info"
                                          label="Cognome"
                                          v-model="walkIn.lastName"
                                          name="lastName"
                                          autocomplete="off"
                                          outlined
                                          hide-details
                                        ></v-text-field>  
                                      </v-col>
                                      <v-col  class="px-1" cols="6" md="3" xl="3">
                                        <v-text-field
                                          prepend-inner-icon="mdi-account"
                                          color="info"
                                          label="Nome"
                                          v-model="walkIn.firstName"
                                          name="firstName"
                                          autocomplete="off"
                                          outlined
                                          hide-details
                                        ></v-text-field>  
                                      </v-col>
                                      <v-col  class="px-1 pt-3 pb-7" cols="12" md="6" xl="4">
                                        <v-row class="px-3 d-flex justify-center"> 
                                        <!--
                                        <v-text-field 
                                          v-model="walkIn.covers"
                                          append-outer-icon="mdi-plus"
                                          prepend-icon="mdi-minus"
                                          color="info"
                                          type="number"
                                          name="covers"
                                          label="Coperti"
                                          hide-details
                                          dense
                                          reverse
                                          outlined
                                          class="input-group--focused"
                                          @click:append-outer="walkIn.covers+=1"
                                          @click:prepend="walkIn.covers-=1"
                                        ></v-text-field>
                                        -->
                                          <v-btn icon fab dense small class="neu-glow mr-6 float-left" @click="walkIn.covers-=1">
                                            <v-icon class="red--text">mdi-chevron-down</v-icon>
                                          </v-btn>
                                          <div class="text-h5 float-left">Coperti: {{walkIn.covers}}</div>
                                          <v-btn icon fab dense small class="neu-glow ml-6 float-right" @click="walkIn.covers+=1">
                                            <v-icon class="green--text">mdi-chevron-up</v-icon>
                                          </v-btn>
                                        </v-row>

                                      </v-col>
                                      <v-col  class="px-1 pt-3" cols="8" md="4" xl="4">
                                        <v-row class="px-3 d-flex justify-center">  
                                          <v-btn dense large class="neu-glow float-right" @click="dialog_mealDurationSlim=1">
                                            <v-icon color="info">mdi-timer-sand</v-icon>
                                            <span class="ml-3">{{walkIn.mealDuration/60}}'</span>
                                          </v-btn>
                                          <!--
                                            <v-btn-toggle
                                              v-model="walkIn.mealDuration" 
                                              active-class="info white--text"
                                              class="transparent-bg"
                                            >
                                              <v-col class="px-5">
                                                <template v-for="(md,mdi) in mealDurations.filter(m=>m.seconds<=10800)">
                                                <v-btn :value="md.seconds" :key="mdi" icon fab dense small class="neu-glow mr-3 my-3" @click="setMealDuration(md.seconds)">
                                                  {{md.seconds/60}}"
                                                </v-btn>                              
                                              </v-col>
                                            </v-btn-toggle>
                                            -->
                                        </v-row>
                                      </v-col>                                 
                                      <v-col class="d-flex pt-0 pb-3" :class="$vuetify.breakpoint.smAndDown?' justify-center':' justify-end'">
                                        <v-tooltip top>
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-btn @click="saveWalkInSlim()" fab icon small class="neu-glow pa-2" :loading="loading_checkUser" :disabled="!walkIn.covers" v-bind="attrs" v-on="on" active-class="neu-glow-inset">
                                              <v-icon color="warning">mdi-table-furniture</v-icon>
                                            </v-btn>
                                          </template>
                                          <span>Salva Nuovo WalkIn</span>
                                        </v-tooltip>                                                                   
                                      </v-col>
                                    </v-row>                          
                              </div>
                            </v-expand-transition>                            
                          </v-row>
                        <v-row  no-gutters :class="showiManagerMap||showManualAssignMap?'d-block mt-5':'mt-5'" :style="(showiManagerMap||showManualAssignMap)&&$vuetify.breakpoint.mdAndUp?'overflow:auto;max-height:'+(wHeight-290)+'px':'overflow:auto;'">
                          <v-col class="pa-2 neu-glow" cols="12" md="12" :lg="(showiManagerMap||showManualAssignMap?24:12)/(shifts.filter(s =>s.mealId==mealId).length)" v-for="(s,i) in shifts.filter(s =>s.mealId==mealId)" :key="i">
                          <!-- bookings.filter(b=>b.shiftId==s.shiftId&&!cancelledShown&&!b.hideCancelled&&!b.hideUnconfirmed||(b.shiftId==s.shiftId&&!b.active&&cancelledShown))" -->                 
                            <v-data-table
                              :search="search"
                              :key="i"
                              fixed-header
                              :headers="headers"
                              :items="!bookings?[]:bookings.filter(b=>(b.shiftId==s.shiftId&&!showCancelled&&(b.active||!b.active&&!b.oldCancelled)&&(b.locationId==activeLocationId||!activeLocationId))||(b.shiftId==s.shiftId&&showCancelled&&!b.active&&(b.locationId==activeLocationId||!activeLocationId)))"
                              hide-default-footer
                              :items-per-page=500
                              class="mt-2 pb-2"
                              :item-class="itemClass"
                              :loading="loading?settings.options.color:null"
                              no-data-text="Nessun dato presente in archivio"
                              no-results-text="Nessun Risultato estratto"
                              loading-text="Consultazione archivio: attendi..."
                            >
                              
                              <template v-slot:[`item.tables`]="{ item }">
                                <v-tooltip top :disabled="!item.tables">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" icon :disabled="!item.active||!item.confirmed||!item.validated" :color="item.manualAssignement?'accent':(item.tables&&item.tables.length>0?'success':'error')" @click="ShowManualAssignMap(item)">
                                      <v-icon>mdi-table-chair</v-icon>
                                      <span class="ml-2">
                                        {{item.tables&&item.tables.length>0?'':item.location.substring(0,1)}}
                                      </span>
                                    </v-btn>
                                    <span v-if="settings.options.showTableNumber=='1'" class="font-weight-black">{{item.tables?(item.tables.length>3?item.tables.slice(0,3).join(' ')+'...':item.tables.join(' ')):''}}</span>
                                  </template>
                                  <span class="font-weight-black">{{item.tables?item.tables.slice().join(' '):''}}</span>
                                </v-tooltip>
                                <template v-if="item.aiAssigned">
                                  <v-tooltip top :disabled="!item.aiAssigned">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon color="info" class="ml-1"  v-bind="attrs" v-on="on" >mdi-brightness-auto</v-icon>
                                    </template>
                                    <span>Tavolo Assegnato da iManager: non modificare</span>
                                  </v-tooltip>
                                </template>                         
                              </template>

                              <template v-slot:[`item.covers`]="{ item }">
                                
                               <!--
                               <v-tooltip top v-if="item.confirmed&&item.modifiedName">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon  v-bind="attrs" v-on="on" v-if="item.modifiedName=='web'" color="warning" class="float-right">mdi-pencil</v-icon>
                                  </template>
                                  <span>
                                    <div>
                                      IL CLIENTE HA MODIFICATO LA SUA PRENOTAZIONE CONFERMATA:
                                    </div>
                                    <ul>
                                      <li>Data: {{item.previousDate}}</li>
                                      <li>Ore: {{item.previousTime}}</li>
                                      <li>Coperti: {{item.previousCovers}}{{item.previousChildren?'+'+item.previousChildren:''}}</li>
                                      <li>Area: {{item.previousLocation}}</li>
                                      <li>Conferma: {{item.previousConfirmedTime}}</li>
                                    </ul>
                                  </span>
                                </v-tooltip>
                                -->
                                <v-icon @click="showTooltip(item.rowNumber-1)" v-if="item.previousConfirmedTime&&item.modifiedName&&item.modifiedName=='web'" color="warning" class="float-right">mdi-pencil</v-icon>
                                <v-tooltip top v-model="previousConfirmationTooltip[item.rowNumber-1]" >
                                  <template v-slot:activator="{ on, attrs }">
                                    <div v-bind="attrs" v-on="on"></div>
                                  </template>
                                  <span>
                                    <div>
                                      IL CLIENTE HA MODIFICATO LA SUA PRENOTAZIONE CONFERMATA:
                                    </div>
                                    <ul>
                                      <li>Data: {{item.previousDate}} <span v-if="item.previousDate!==item.date">==> {{item.date}}</span></li>
                                      <li>Ore: {{item.previousTime}} <span v-if="item.previousTime!==item.time">==> {{item.time}}</span></li>
                                      <li>Coperti: {{item.previousCovers}}{{item.previousChildren?'+'+item.previousChildren:''}} <span v-if="item.previousCovers!==item.covers || item.previousChildren!==item.children">==> {{item.covers}}{{item.children?'+'+item.children:''}}</span></li>
                                      <li>Area: {{item.previousLocation}} <span v-if="item.previousLocation!==item.location">==> {{item.location}}</span></li>
                                      <li>Conferma: {{item.previousConfirmedTime}} <span v-if="item.previousConfirmedTime!==item.confirmedTime">==> {{item.confirmedTime}}</span></li>
                                    </ul>
                                  </span>
                                </v-tooltip>                                

                                
                                <div 
                                  class="text-subtitle-1 font-weight-black" 
                                  v-html="item.children?item.covers+' + '+item.children+'':item.covers"
                                >
                                </div>
                              </template>                          

                              <template v-slot:[`item.fullName`]="{ item }">

                              <v-tooltip top v-if="item.waRemI&&settings.options.showReminderStatus==='1'" >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon :color="item.waRemIcr" v-bind="attrs" v-on="on">mdi-reminder</v-icon>
                                </template>
                                  <span>Promemoria {{item.waRemIcname}}</span>
                              </v-tooltip>  

                                <v-tooltip top v-if="item.stripeAmount">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" :color="item.stripeStatus=='succeeded'?'success':item.stripeStatus=='requires_capture'?'warning':'error'" v-on="on">{{item.stripeStatus=='succeeded'?'mdi-cash-lock':item.stripeStatus=='requires_capture'?'mdi-cash-lock-open':'mdi-cash-off'}}</v-icon>
                                  </template>
                                  <span>{{item.stripeStatus=='succeeded'?'Versati':item.stripeStatus=='requires_capture'?'PreAutorizzati':'Rimborsati'}} {{item.stripeAmount.toFixed(2)}} €</span>
                                </v-tooltip>

                                <v-tooltip top v-if="settings.options.showBookingChannel=='1'">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon :color="item.visits>0?'info':''" v-bind="attrs" v-on="on">{{item.icon}}</v-icon>
                                  </template>
                                  <!--<span>{{item.bookingChannel}}</span>-->
                                  <span>{{'Ultima Prenotazione: '+item.createdDateString}}<br>
                                    <template v-if="item.visits>0">
                                      Già venuto {{item.visits}} {{item.visits==1?'volta':'volte'}}
                                    </template>
                                    <template v-else>
                                        Nuovo Cliente
                                    </template>
                                  </span>  
                                </v-tooltip>

                                <v-tooltip top v-if="settings.options.showUserReview=='1'&&item.ratingName">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" :color="item.ratingIconColor">{{item.ratingIcon}}</v-icon>
                                  </template>
                                  <span>{{item.ratingName+' : '+item.visits+' Visite'}}</span>
                                </v-tooltip>

                                <v-tooltip top :disabled="item.noShowCount==0">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on"  
                                      @click="openDialogDetails(item)" text 
                                      :style="!item.noShowCount?'' : item.isLatestNoShow==1?'color:#ffa500':'color:#ffdb99'" 
                                      class="font-weight-black no-uppercase"
                                    >
                                      {{showiManagerMap?item.fullName.substring(0,10):item.fullName}}
                                    </v-btn>  
                                  </template>
                                  <span>{{'NoShow: '+item.noShowCount}} | {{'Ultima Prenotazione: '+(item.isLatestNoShow==0?'OK':'No Show')}}</span>
                                </v-tooltip>
                              </template>
                                
                              <template v-slot:[`item.requests`]="{ item }">

                                <v-tooltip top v-if="item.conflicts&&item.conflicts[0].delay>15&&item.reuse">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon @click="changeStatus(item,'conflictAlertDisable',0)" :color="item.conflicts[0].conflictAlertDisabled?'success':'error'" v-bind="attrs" v-on="on">mdi-alert</v-icon>
                                  </template>
                                  <template v-for="(c,ci) in item.conflicts.filter(c=>c.delay>15)">
                                    <span :key="ci" v-if="ci==0" v-html="'Conflitti:<br />'"></span>														
                                    <span :key="ci" v-if="c.delay>0" v-html="'Tavolo: ' + c.table + ' - Ritardo: '+ c.delay +'\' - Residuo: '+c.timeRemaining+' minuti'"></span>
                                    <span :key="ci" v-else v-html="'Tavolo: ' + c.table + ' - Anticipo: '+ Math.abs(c.delay)+' minuti'"></span>
                                    <span :key="ci" v-html="'<br />'"></span>
                                    <span :key="ci" v-if="ci==(item.conflicts.length-1)&&c.delay>0">Anticipare Comanda o Spostare Tavoli in conflitto</span>
                                    <span :key="ci" v-if="ci==(item.conflicts.length-1)&&c.delay<0">Riassegnare o Spostare Tavoli in conflitto</span>
                                  </template>
                                </v-tooltip> 

                                <v-tooltip top v-if="item.reuse" >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon @click="changeStatus(item,'reuseAlertDisable',0)" :color="item.reuse[0].reuseAlertDisabled?'success':'warning'" v-bind="attrs" v-on="on">mdi-rotate-360</v-icon>
                                  </template>
                                  <template v-for="(c,ci) in item.reuse">
                                    <span :key="ci" v-if="ci==0" v-html="'Sparecchiare x '+c.lastName+'<br />'"></span>
                                    <span :key="ci" v-html="'Tavolo: ' + c.table+' - per le '+c.time+'<br>'"></span>
                                  </template>
                                </v-tooltip>
                                
                                <v-tooltip top v-if="item.childrenPresence=='1'" >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="info" v-bind="attrs" v-on="on">mdi-human-child</v-icon>
                                  </template>
                                    <span>Presenza Bambini</span>
                                </v-tooltip>

                                <v-tooltip top v-if="item.bonus" >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon @click="changeStatus(item,'bonusAlertDisable',0)" :color="item.bonus.bonusAlertDisabled?'success':'warning'" v-bind="attrs" v-on="on">mdi-ticket-percent</v-icon>
                                  </template>
                                  <template>
                                    <span v-html="item.bonus"></span>
                                  </template>
                                </v-tooltip>

                                <v-tooltip top v-if="item.couponId">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-if="!item.couponSpentDate" class="ml-2" v-bind="attrs" :color="item.isCouponValid&&item.isCouponActive?'success':'warning'" v-on="on" @click="openDialogCoupon(item)">mdi-gift</v-icon>
                                    <v-icon v-else class="ml-2" v-bind="attrs" color="grey" v-on="on">mdi-gift</v-icon>
                                  </template>
                                  <span v-html="!item.isCouponActive?'<br>Coupon Scaduto':!item.isCouponValid?'<br>Non spendibile oggi':(item.couponSpentDate?'Coupon già Speso il '+new Date(item.couponSpentDate).toLocaleDateString('it-IT', { month: '2-digit', day: '2-digit' }):'Coupon Valido')"></span>
                                </v-tooltip>

                                <template v-if="item.duration!=settings.options.defaultMealDuration/1">
                                  <v-tooltip top :disabled="!item.duration">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon class="mr-1" :color="(item.duration>settings.options.defaultMealDuration/1)?'warning':'success'" v-bind="attrs" v-on="on">{{(item.duration>settings.options.defaultMealDuration/1)?'mdi-clock-plus':'mdi-clock-minus'}}</v-icon>
                                    </template>
                                    <span class="font-weight-black">{{item.duration}} minuti</span>
                                  </v-tooltip>
                                </template>  

                                <template  v-if="item.cancelled&&item.oldCancelled">
                                  <div class="d-flex text-center">
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-icon  v-bind="attrs" v-on="on">mdi-delete-clock</v-icon>
                                      </template>
                                      <span v-html="item.cancelledByName+': '+new Date(item.cancelled).toLocaleDateString('it-IT', { month: '2-digit', day: '2-digit' })+' '+new Date(item.cancelled).toLocaleTimeString('it-IT')"></span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <a :href="'tel:'+item.phone" :disabled="!item.phone" style="text-decoration:none;" class="pt-2 pl-2">
                                          <v-icon class="success--text" v-bind="attrs" v-on="on">mdi-phone</v-icon>
                                        </a>                                
                                      </template>
                                      <span>Chiama</span>
                                    </v-tooltip>                             
                                  </div>
                                </template>

                                <v-tooltip top v-if="item.remarks">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="orange" v-bind="attrs" v-on="on">mdi-chat-processing</v-icon>
                                  </template>
                                  <span>{{item.remarks}}</span>
                                </v-tooltip>

                                <template v-if="requests">
                                  <template v-for="(o, i) in requests.filter(r => item.requests.some(k=>k===r.requestId))">
                                    <v-tooltip top :key="i">
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-icon small class="float-left mr-1" color="info" v-bind="attrs" v-on="on">{{o.icon}}</v-icon>
                                      </template>
                                      <span>{{o.description}}</span>
                                    </v-tooltip>
                                  </template>
                                </template>

                                <template v-if="foodStyles">
                                  <template v-for="(o, i) in foodStyles.filter(r => item.foodStyles.some(k=>k===r.requestId))">
                                    <v-tooltip top  :key="i">
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-icon small class="float-left mr-1" color="info" v-bind="attrs" v-on="on">{{o.icon}}</v-icon>
                                      </template>
                                      <span>{{o.description}}</span>
                                    </v-tooltip>
                                  </template>
                                </template>                        

                              </template>

                              <template v-slot:[`item.actions`]="{ item }">
                                <v-tooltip top v-if="!item.validated&&item.active">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn :loading="loading_unconfirmed" :disabled="!item.active" @click="openDialogEdit(item)" icon v-bind="attrs" v-on="on" class="mr-1">
                                      <v-icon v-bind="attrs" v-on="on">mdi-check-outline</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Cliente nuovo: non ha confermato su WA: <br />Verificare che sia Reale </span>
                                </v-tooltip> 

                                <v-tooltip top v-else-if="item.waiting&&item.active">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn :loading="loading_waitingList" :disabled="!item.active" @click="openWaitingList(item)" icon v-bind="attrs" v-on="on" class="mr-1">
                                      <v-icon v-bind="attrs" v-on="on" :color="item.hoursRemaining-item.waitingListTime>0?'success':'error'">mdi-clipboard-list</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>{{item.waiting?(item.hoursRemaining-item.waitingListTime>0?'Lista Attiva':'Lista Scaduta'):'Confermato'}}</span>
                                </v-tooltip>

                                <v-tooltip top v-else-if="!item.confirmed&&item.active">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn :loading="loading_unconfirmed" :disabled="!item.active" @click="openWaitingList(item)" icon v-bind="attrs" v-on="on" class="mr-1">
                                      <v-icon v-bind="attrs" v-on="on" color="blue-grey">mdi-circle-outline</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Da Confermare</span>
                                </v-tooltip>

                                <v-tooltip top v-else>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn :loading="loading_arrived" @click="changeStatus(item,item.active?'arrived':'oldCancelled',0)" icon v-bind="attrs" v-on="on" class="mr-1">
                                      <v-icon v-if="!item.active&&item.ghost&&settings.level>200" color="blue-grey">mdi-close-thick</v-icon>
                                      <v-icon v-if="!item.active&&(item.noShow||(item.ghost&&settings.level<200))" color="blue-grey">mdi-ghost</v-icon>
                                      <v-icon v-else-if="!item.active" color="error">mdi-delete</v-icon>
                                      <v-icon v-else :color="item.arrived?'info':''">mdi-airplane-landing</v-icon>
                                    </v-btn>
                                  </template>
                                  <!--<span>{{!item.active&&!item.oldCancelled?'Visto':!item.active?'Non Visto':(item.time_arrived?'Arrivato alle '+item.time_arrived:'Arrivato')}}</span>-->
                                  <span>{{!item.active&&!item.oldCancelled?('Cancellato alle '+item.cancelled+' da:'+item.cancelledByName):(!item.active?'Non Visto':'Arrivato')}}</span>
                                </v-tooltip>

                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn small @click="openDialogEdit(item)" :color="itemClass_editButton(item)" class="lighten-1 font-weight-black" v-bind="attrs" v-on="on">
                                      {{item.time_arrived?item.time_arrived.substring(0,5):slots.find(s=>s.slotId==item.slotId).name}}
                                    </v-btn>
                                  </template>
                                  <span v-html="itemClass_editButton(item)=='error'?'Assegna Subito Tavoli':'Modifica Prenotazione'"></span>
                                </v-tooltip>

                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn :loading="loading_departed" :disabled="!item.validated" @click="item.arrived?changeStatus(item,'gone',0):showHistory(item)" icon v-bind="attrs" v-on="on" class="ml-1">
                                      <v-icon v-if="!item.arrived" color="">mdi-history</v-icon>
                                      <v-icon v-else :color="item.gone?'info':''">mdi-airplane-takeoff</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>{{item.gone?'Partito alle '+item.gone:!item.arrived?'Storico Prenotazione':'Partito'}}</span>
                                </v-tooltip>

                                <div class="pt-2 font-weight-black float-right text-right" style="min-width:17px">
                                  {{
                                    bookings.filter(b => b.time==item.time&&b.active==1&&b.confirmed).reduce((a,c) => a + c.covers/1 + c.children/1,0)
                                  }}
                                </div>										
                              </template>
                            </v-data-table>
                          </v-col> 
                        </v-row>
                      </v-col>
                      <v-col cols="12" :lg="mapWidth" v-if="showiManagerMap&&tables" :style="$vuetify.breakpoint.mdAndUp?'minHeight:'+minHeight+'px;':''" id="iManagerMap">
                        <v-row v-if="$vuetify.breakpoint.xsOnly">
                          <v-expand-transition>
                            <div v-if="walkIn.tablesId&&walkIn.tablesId.length" class="v-card neu-glow mt-5 pt-3 mx-6 info darken-4">
                              <v-alert v-if="userDetails&&userDetails.rating" class="mb-2" dense dismissible :type="userDetails.rating>3?'success':userDetails.rating>0?'warning':'error'">
                                L'ultima valutazione di questo numero è <span class="font-weight-bold black--text">{{userDetails.rating}}</span>: <span class="font-weight-bold black--text">{{userDetails.ratingRemarks}}</span>
                              </v-alert>
                              <div class="text-h6 pl-4 pb-3">Volante Veloce</div>
                                  <v-row class="mb-0 mx-3">
                                    <v-col class="px-1" cols="5" md="3" xl="3">
                                      <v-select
                                        color="info"
                                        outlined
                                        v-model="walkIn.countryCode"
                                        :items="countries"
                                        :label="$t(page+'.Country Code')"
                                        hide-details
                                        :item-text="item => item.name +' '+ item.value"
                                      >
                                        <template v-slot:item="slotProps" >
                                          <i :class="['mr-2', 'em', slotProps.item.flag]"></i>
                                          {{slotProps.item.namel}} + {{slotProps.item.value}}
                                        </template>
                                        <template v-slot:selection="data">
                                          <i :class="['mr-2', 'em', data.item.flag]"></i>
                                          {{ data.item.value }}
                                        </template>
                                      </v-select>
                                    </v-col>
                                    <v-col  class="px-1" cols="7" md="3" xl="3">
                                      <v-text-field
                                        prepend-inner-icon="mdi-whatsapp"
                                        color="info"
                                        label="Cellulare"
                                        v-model="walkIn.phone"
                                        name="phone"
                                        type="number"
                                        autocomplete="off"
                                        reverse
                                        hide-spin-buttons
                                        outlined
                                        hide-details
                                        :success="successPhone_status"
                                        :error="errorPhone_status"
                                        :hint="errorPhone"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col  class="px-1" cols="6" md="3" xl="3">
                                      <v-text-field
                                        prepend-inner-icon="mdi-account"
                                        color="info"
                                        label="Cognome"
                                        v-model="walkIn.lastName"
                                        name="lastName"
                                        autocomplete="off"
                                        outlined
                                        hide-details
                                      ></v-text-field>  
                                    </v-col>
                                    <v-col  class="px-1" cols="6" md="3" xl="3">
                                      <v-text-field
                                        prepend-inner-icon="mdi-account"
                                        color="info"
                                        label="Nome"
                                        v-model="walkIn.firstName"
                                        name="firstName"
                                        autocomplete="off"
                                        outlined
                                        hide-details
                                      ></v-text-field>  
                                    </v-col>
                                    <v-col  class="px-1 pt-3 pb-7" cols="12" md="6" xl="4">
                                      <v-row class="px-3 d-flex justify-center"> 
                                      <!--
                                      <v-text-field 
                                        v-model="walkIn.covers"
                                        append-outer-icon="mdi-plus"
                                        prepend-icon="mdi-minus"
                                        color="info"
                                        type="number"
                                        name="covers"
                                        label="Coperti"
                                        hide-details
                                        dense
                                        reverse
                                        outlined
                                        class="input-group--focused"
                                        @click:append-outer="walkIn.covers+=1"
                                        @click:prepend="walkIn.covers-=1"
                                      ></v-text-field>
                                      -->
                                        <v-btn icon fab dense small class="neu-glow mr-6 float-left" @click="walkIn.covers-=1">
                                          <v-icon class="red--text">mdi-chevron-down</v-icon>
                                        </v-btn>
                                        <div class="text-h5 float-left">Coperti: {{walkIn.covers}}</div>
                                        <v-btn icon fab dense small class="neu-glow ml-6 float-right" @click="walkIn.covers+=1">
                                          <v-icon class="green--text">mdi-chevron-up</v-icon>
                                        </v-btn>
                                      </v-row>

                                    </v-col>
                                    <v-col  class="px-1 pt-3" cols="8" md="4" xl="4">
                                      <v-row class="px-3 d-flex justify-center">  
                                        <v-btn dense large class="neu-glow float-right" @click="dialog_mealDurationSlim=1">
                                          <v-icon color="info">mdi-timer-sand</v-icon>
                                          <span class="ml-3">{{walkIn.mealDuration/60}}'</span>
                                        </v-btn>
                                        <!--
                                          <v-btn-toggle
                                            v-model="walkIn.mealDuration" 
                                            active-class="info white--text"
                                            class="transparent-bg"
                                          >
                                            <v-col class="px-5">
                                              <template v-for="(md,mdi) in mealDurations.filter(m=>m.seconds<=10800)">
                                              <v-btn :value="md.seconds" :key="mdi" icon fab dense small class="neu-glow mr-3 my-3" @click="setMealDuration(md.seconds)">
                                                {{md.seconds/60}}"
                                              </v-btn>                              
                                            </v-col>
                                          </v-btn-toggle>
                                          -->
                                      </v-row>
                                    </v-col>                                 
                                    <v-col class="justify-end d-flex pt-0 pb-3">
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn @click="saveWalkInSlim()" fab icon small class="neu-glow pa-2" :loading="loading_checkUser" :disabled="!walkIn.covers" v-bind="attrs" v-on="on" active-class="neu-glow-inset">
                                            <v-icon color="warning">mdi-table-furniture</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>Salva Nuovo WalkIn</span>
                                      </v-tooltip>                                                                   
                                    </v-col>
                                  </v-row>                          
                            </div>
                          </v-expand-transition>                            
                        </v-row>                        
                        <!--<div>{{activeSlotId}} | {{activeHallId}} | {{activeLocationId}}</div>-->
                        <div class="mx-4 mb-3" v-if="$vuetify.breakpoint.lgAndUp">La Mappa visualizza anche le prenotazioni non assegnate, utilizzando l’AI
                          <!--
                          <div class="float-right mt-n5"><v-btn small class="mt-2 mr-8 neu-glow" @click="resizeMap(1)" color="success" fab icon><v-icon>mdi-magnify-plus</v-icon></v-btn><v-btn small class="mt-2 neu-glow" @click="resizeMap(-1)" color="warning" fab icon><v-icon>mdi-magnify-minus</v-icon></v-btn></div>
                          -->
                        </div>

                        <template v-if="$vuetify.breakpoint.smAndDown">
                          <v-btn-toggle v-model="activeHallId" mandatory  active-class="info white--text" v-if="halls&&showiManagerMap&&halls.filter(h=>h.locationId==activeLocationId).length>1" class="ml-4 flex-wrap justify-center">
                            <v-btn 
                              v-for="(m,m2) in halls.filter(h=>h.locationId==activeLocationId)" :key="m2"
                              v-bind="attrs" v-on="on"
                              small
                              :value="m.hallId"
                            >
                              {{m.name}}
                            </v-btn>
                          </v-btn-toggle>                           
                          <v-btn-toggle v-model="activeSlotId" mandatory :active-class="settings.options.color+' white--text'" :class="$vuetify.breakpoint.smAndDown?'mt-5 mb-3':'my-3'" class="background flex-wrap justify-center d-flex" v-if="showiManagerMap">  
                            <v-btn 
                              class="px-3 blue-grey darken-2"
                              small
                              :value="c.slotId"
                              v-for="(c,c1) in slots.filter(s=>s.mealId==mealId)" :key="c1"
                              :loading="loading"
                            >
                            {{c.name}}</v-btn>
                          </v-btn-toggle>
                        </template>
                        <template v-if="showUnassigned1">
                          <v-card class="neu-glow pa-2 mb-3 error">
                            <v-card-title class="font-weight-bold py-0">Prenotazioni non Assegnabili
                              <v-spacer></v-spacer>
                              <div v-for="(u, ui) in unassignables()" :key=ui>
                                <v-btn @click="ShowManualAssignMap(u)" small class="mr-2 disable-events">{{u.lastName+' - '+u.covers}} pax</v-btn>
                              </div>
                              <v-spacer></v-spacer>
                              <v-tooltip top color="black" max-width=200>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn small class="neu-glow" icon v-bind="attrs" v-on="on" @click="dialog_allocationRules=false">
                                    <v-icon fab color="info">mdi-information</v-icon>
                                  </v-btn>
                                </template>
                                <span>
                                  <div class="">Assegnare immediatamente in manuale il tavolo, l’AI non ha trovato una combinazione appropriata</div>
                                </span>
                              </v-tooltip>                              
                            </v-card-title>
                          </v-card>
                        </template>                        
                        <v-card ref="volanteSlim" class="neu-glow">
                          <div :style="'height:'+(calcWHeight(270))+'px;position: relative'">
                            <template v-if="loading_getFreeSlots">
                                <v-container fill-height>
                                  <v-row
                                    align="center"
                                    justify="center"
                                  >
                                    <v-col
                                      cols="auto"
                                      class="d-flex justify-center align-center"
                                    >
                                      <v-progress-circular
                                        :size="250"
                                        :width="25"
                                        indeterminate
                                        color="primary"
                                      />
                                    </v-col>
                                  </v-row>
                                </v-container>
                            </template>
                            <template v-else-if="showiManagerMap&&!showManualAssignMap">
                              <v-btn-toggle v-model="walkIn.tablesId" multiple active-class=" accent" class="d-flex flex-wrap justify-center">
                                    <div>
                                      <v-btn
                                        :key="ti"
                                        v-for="(t,ti) in tables.filter(t => t.hallId===activeHallId||(activeLocationId&&t.hallId===halls.find(h=>h.locationId===activeLocationId).hallId&&!activeHallId))"
                                        absolute
                                        :disabled="!t.tableName"
                                        :value="t.tableId" 
                                        :class="freeTableClassiManager(t)"                         
                                        :style="{width: (t.width*zoomLeveliManager(t.hallId))+'px','min-width': (t.width*zoomLeveliManager(t.hallId))+'px',height: (t.height*zoomLeveliManager(t.hallId))+'px',left:(t.xPos*zoomLeveliManager(t.hallId))+'px',top:(t.yPos*zoomLeveliManager(t.hallId))+'px',transform:'rotate('+(t.angle*45)+'deg)'}"
                                      >
                                        <span>
                                          <div v-html="freeTableClassiManagerDetails(t)"></div>
                                        </span>
                                      </v-btn>
                                      </div>
                              </v-btn-toggle>
                            </template>
                          </div>
                        </v-card>                    
                      </v-col>
                      <v-col cols="12" md="6" v-if="showManualAssignMap&&tables" :style="'minHeight:'+minHeight+'px'">
                        <v-card class="ml-2 mr-n1" style="z-index:10">
                          <v-card-title class="mb-n6">
                            <v-row>
                              <v-col cols="12" sm="6" lg="8">
                                {{item.fullName}} - Sala: {{item.location}} <br />
                                {{'Ore: '+item.time+' - Coperti: '+item.covers + (item.children?' + ' + item.children:'') + (assignedTablesId&&assignedTablesId.length>1?' - Tavoli: ':' - Tavolo: ')}} 
                                <span class="success--text ml-2">
                                  {{tablesList}}
                                </span>
                              </v-col>
                              <v-col cols="12" sm="6" lg="4">
                                <div class="float-right">
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-6" @click="dialog_swapTables=true">
                                        <v-icon color="error">mdi-swap-horizontal</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Scambia Tavoli</span>
                                  </v-tooltip> 
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-6" :disabled="!assignedTablesId.length" @click="assignedTablesId=[]">
                                        <v-icon color="error">mdi-delete</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Cancella Tavoli Assegnati</span>
                                  </v-tooltip> 
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-6" :loading="loading" :disabled="!assignedTablesId" @click="assignTablesSave()">
                                        <v-icon :color="assignedTablesId.length!=item.tablesCount?'warning':'success'">mdi-content-save</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Salva</span>
                                  </v-tooltip> 
                                  <template v-if="!hideCloseButton">
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow" @click="showManualAssignMap = 0; showiManagerMap=reopeniManagerMap">
                                          <v-icon color="info">mdi-close</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>Chiudi</span>
                                    </v-tooltip>
                                  </template>
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-title>
                        </v-card>
                        <v-row>  
                          <v-col cols="12" v-for="(h,hi) in halls.filter(hh=>hh.locationId==item.locationId)" :key="hi" id="manualAssign">
                            <div v-if="tables">
                              <v-col class="pb-1 ">
                                <div class="primaryBgText darken-3" :style="'width:100%;height:'+(calcWHeight(340))+'px;position: relative'">
                                  <v-btn-toggle
                                    v-model="assignedTablesId"
                                    multiple
                                    class="flex-wrap"
                                    active-class="info"
                                  >
                                    <v-btn
                                      v-for="(p,pi) in tables.filter(z=>z.hallId==h.hallId)"
                                      :key="pi"
                                      :value="p.tableId"
                                      absolute
                                      :class="freeTableClassManual(p,item)"
                                      :style="{width: (p.width*zoomLevelManual(p.hallId))+'px','min-width': (p.width*zoomLevelManual(p.hallId))+'px',height: (p.height*zoomLevelManual(p.hallId))+'px',left:(p.xPos*zoomLevelManual(p.hallId))+'px',top:(p.yPos*zoomLevelManual(p.hallId)-20)+'px',transform:'rotate('+(p.angle*45)+'deg)'}"
                                    >
                                      <span>
                                        <div v-html="freeTableClassManualDetails(p,item)"></div>
                                        <!--<div class="text-h5" v-html="p.tableName"></div>-->
                                      </span>
                                    </v-btn>
                                  </v-btn-toggle>
                                </div>
                              </v-col>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>                                              
                    </v-row>
                  </v-col>                 
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>       
      </div>
    </div>
    <v-snackbar v-model="snackbar_confirm_cancellation"
      centered
      dark
      timeout="1500"
      color="red"
    >
      Confermi Cancellazione Prenotazione
      <template v-slot:action="{ attrs }">
        <v-btn
          color="indigo"
          v-bind="attrs"
          @click="snackbar_confirm_cancellation = false"
        >
          Conferma
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="snackbar" 
      centered :color="snackbar_color" :timeout="snackbar_timeout"
    >
      <div class="text-h5 text-center"><span v-html="snackbar_message"></span></div>
    </v-snackbar>
    <v-dialog v-model="dialog_walkIn" 
      fullscreen
      content-class="neu-glow pb-3 overflow-x-hidden"
      persistent
      scrollable
      class="overflow-x-hidden"
      ref="dialogVolante"
      v-if="settings"
      >
      <template> 
        <v-row class="overflow-x-hidden">
          <v-col cols="12" lg="12" class="px-6">
            <v-card class="neu-glow pb-2">
              <v-card-title :class="newVolanteOrEdit=='e'?' error--text':''" class="text-h6 mb-2 font-weight-bold neu-glow">
                {{newVolanteOrEdit=='n'?'Nuova Prenotazione':'Modifica Prenotazione'}} 
                <v-spacer></v-spacer>
                <!--<div v-if="$vuetify.breakpoint.mdAndUp" class="info--text text-h4">{{booking.date?new Date(booking.date).toLocaleDateString('it-IT', {weekday: 'long', month: 'long', day: 'numeric' }):''}}</div>-->
                <template v-if="newVolanteOrEdit=='e'">
                    <v-tooltip top v-if="settings.level>200">
                      <template v-slot:activator="{ on, attrs }">
                        <div>
                          <v-btn :small="$vuetify.breakpoint.xs" v-bind="attrs" v-on="on" fab icon class="neu-glow mx-lg-4 mx-1" :loading="loading" @click="changeStatus(booking,'cancelled',1)">
                            <v-icon color="black">mdi-close-thick</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <span>Elimina</span>
                    </v-tooltip>  
                    <template v-if="!booking.active">  
                      <v-tooltip top >
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            <v-btn :small="$vuetify.breakpoint.xs" v-bind="attrs" v-on="on" fab icon class="neu-glow mx-lg-4 mx-1" :loading="loading" @click="deleteBooking('undeleteBooking',1)">
                              <v-icon color="success">mdi-undo</v-icon>
                            </v-btn>
                          </div>
                        </template>
                        <span>Ripristina Prenotazione</span>
                      </v-tooltip>
                      <v-tooltip top >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn :small="$vuetify.breakpoint.xs" @click="close_dialog_walkIn()" fab class="neu-glow mr-6" v-bind="attrs" v-on="on">
                            <v-icon color="error">mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <span>Chiudi</span>
                      </v-tooltip> 
                    </template> 
                    <template  v-else>
                      <!--
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            <v-btn v-bind="attrs" v-on="on" fab icon  class="neu-glow mr-8"  @click="open_Coupon()">
                              <v-icon color="success">mdi-ticket</v-icon>
                            </v-btn>
                          </div>
                        </template>
                        <span>Crea Coupon</span>
                      </v-tooltip>
                      -->
                      <!--
                      <v-tooltip top v-if="selectedBooking.isCouponActive&&selectedBooking.isCouponValid">
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            <v-btn v-bind="attrs" v-on="on" fab icon class="neu-glow mr-8" :loading="loading" @click="disableCoupon(selectedBooking.couponId)">
                              <v-icon color="warning">mdi-gift-open</v-icon>
                            </v-btn>
                          </div>
                        </template>
                        <span>Disabilita Coupon</span>
                      </v-tooltip>
                      -->   
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            <v-btn 
                              :small="$vuetify.breakpoint.xs"
                              v-bind="attrs" v-on="on" fab icon class="neu-glow mr-2" 
                              :disabled="newVolanteOrEdit=='n'" 
                              @click="dialog_rating=true">
                              <v-icon :class="newVolanteOrEdit=='n'?'':'info--text'">mdi-star</v-icon> 
                            </v-btn>
                          </div>
                        </template>
                        <span>Valutazione Cliente</span>
                      </v-tooltip> 

                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            <v-btn 
                              :small="$vuetify.breakpoint.xs" v-bind="attrs" v-on="on" 
                              fab icon class="neu-glow mx-lg-4 mx-1" 
                              :disabled="booking.validated&&booking.confirmed" 
                              :loading="loadingChangeStatus" 
                              @click="changeStatus(booking,'validate',1)">
                              <v-icon color="info">mdi-check-all</v-icon>
                            </v-btn>
                          </div>
                        </template>
                        <span>Conferma/Valida Prenotazione</span>
                      </v-tooltip>
                      

                      
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            <v-btn :small="$vuetify.breakpoint.xs" v-bind="attrs" v-on="on" fab icon class="neu-glow mx-lg-4 mx-1" 
                              :loading="loadingReviewRequest" 
                              @click="reviewRequest()">
                              <v-icon color="success">mdi-comment-quote</v-icon>
                            </v-btn>
                          </div>
                        </template>
                        <span>Richiedi Review</span>
                      </v-tooltip>
                    
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            <v-btn :small="$vuetify.breakpoint.xs" v-bind="attrs" v-on="on" fab icon class="neu-glow mx-lg-4 mx-1" :loading="loadingChangeStatus" @click="changeStatus(booking,'noshow',0)">
                              <v-icon color="teal">mdi-ghost</v-icon>
                            </v-btn>
                          </div>
                        </template>
                        <span>No Show</span>
                      </v-tooltip>
                      
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            <v-btn :small="$vuetify.breakpoint.xs" v-bind="attrs" v-on="on" fab icon class="neu-glow mx-lg-4 mx-1" :loading="loading" @click="dialog_confirmDelete=true">
                              <v-icon color="error">mdi-delete</v-icon>
                            </v-btn>
                          </div>
                        </template>
                        <span>Cancella</span>
                      </v-tooltip>

                      <v-tooltip top >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn :small="$vuetify.breakpoint.xs"  @click="close_dialog_walkIn()" fab class="neu-glow ml-md-8 ml-2" v-bind="attrs" v-on="on">
                            <v-icon color="error">mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <span>Chiudi</span>
                      </v-tooltip>
                    </template>
                </template>
                <template v-else>
                  <!--
                  <v-tooltip top >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn :small="$vuetify.breakpoint.xs" @click="close_dialog_walkIn()" fab class="neu-glow mr-6" v-bind="attrs" v-on="on">
                        <v-icon color="error">mdi-close</v-icon>
                      </v-btn>
                    </template>
                    <span>Chiudi</span>
                  </v-tooltip>
                  -->
                  <v-btn :small="$vuetify.breakpoint.xs" @click="close_dialog_walkIn()" fab class="neu-glow mr-6" v-bind="attrs" v-on="on">
                    <v-icon color="error">mdi-close</v-icon>
                  </v-btn>
                </template>           
              </v-card-title>
              <v-card-text class="px-0 pb-0">
                <v-col cols="12">
                  <v-col cols="12" class="pt-0" v-if="todayBooking">
                    <v-alert class="mb-2" dense dismissible type="error" @input="todayBooking=null">Per questo numero esiste già una prenotazione a nome di {{todayBooking.fullName}} alle {{todayBooking.time}} per {{todayBooking.covers}} coperti</v-alert>
                  </v-col>
                  <v-col cols="12" class="pt-0" v-if="userDetails&&userDetails.rating">
                    <v-alert class="mb-2" dense dismissible :type="userDetails.rating>3?'success':userDetails.rating>0?'warning':'error'">
                      L'ultima valutazione di questo numero è <span class="font-weight-bold black--text">{{userDetails.rating}}</span>: <span class="font-weight-bold black--text">{{userDetails.ratingRemarks}}</span>
                    </v-alert>
                  </v-col>
                  
                  <v-row class="px-3 pb-3">
                    <v-col cols="12" md="6">
                      <v-row class="no-gutters">
                        <v-col cols="12" id="coperti">
                          <v-card class="neu-glow" >
                            <v-card-title>
                              <v-icon class="mr-3">
                                mdi-account-multiple
                              </v-icon>
                              Coperti
                              <v-spacer></v-spacer>
                              <v-tooltip top >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn @click="openDialogHelp(2)" small class="neu-glow" icon v-bind="attrs" v-on="on">
                                    <v-icon color="info">mdi-help-circle</v-icon>
                                  </v-btn>
                                </template>
                                <span>Istruzioni</span>
                              </v-tooltip> 
                            </v-card-title>
                            <v-card-text>
                              <div class="d-flex justify-center mx-n2">
                                <v-row>
                                  <v-col cols="12" md="12" lg="3" class="d-flex justify-center align-center pt-0">
                                    <div style="min-height:52px" class="text-h3 font-weight-black text-center info--text">
                                      {{booking.covers}} {{booking.children? '+' + booking.children:''}}
                                    </div>
                                  </v-col>
                                  <v-col cols="12" md="12" lg="9" class="mb-3">
                                    <v-row v-if="$vuetify.breakpoint.mdAndDown">
                                      <v-col cols="4" lg="2" v-for="(c,c1) in [1,2,3,4,5,6,7,8,9,'+',0,'C']" :key="c1" class="py-1 text-center">
                                        <v-btn
                                          v-if="c!==''" 
                                          class="pa-1 text-h6 neu-glow"
                                          @click="setCovers(c)"
                                          :disabled="!booking.date"
                                          :color="c=='C'||c=='+'?'warning darken-2':'blue-grey darken-2'"
                                        >
                                        {{c}}
                                        </v-btn>
                                      </v-col>
                                  </v-row>
                                    <v-row v-else>
                                      <v-col cols="4" lg="2" v-for="(c,c1) in [1,2,3,4,5,'+',6,7,8,9,0,'C']" :key="c1" class="py-1 text-center">
                                        <v-btn
                                          v-if="c!==''" 
                                          class="pa-1 text-h6 neu-glow"
                                          @click="setCovers(c)"
                                          :disabled="!booking.date"
                                          :color="c=='C'||c=='+'?'warning darken-2':'blue-grey darken-2'"
                                        >
                                        {{c}}
                                        </v-btn>
                                      </v-col>
                                  </v-row>                                  
                                  </v-col>
                                </v-row>
                              </div>
                            </v-card-text>
                          </v-card>                  
                        </v-col>                        
                        <v-col cols="12" >
                          <div class="text-center mt-3">
                            <v-menu
                              v-model="menuDateVolante"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              width="290"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-card class="mb-1 neu-glow px-0">
                                  <!--<v-btn block x-large class="info--text font-weight-black text-h5" v-bind="attrs" v-on="on">{{new Date(booking.date).toLocaleDateString('it-IT', {weekday: 'long', month: 'long', day: 'numeric' })}}</v-btn>-->
                                  <v-btn block x-large class="info--text font-weight-black text-h5" v-bind="attrs" v-on="on">  {{ formattedBookingDate }}
                                  </v-btn>
                                </v-card>                                
                              </template>                       
                              <v-date-picker
                                v-model="pickedDate"
                                :width="600"
                                color="info"
                                header-color=""
                                :locale="settings.locale"
                                first-day-of-week=1
                                :min="today"
                                @input="menuDateVolante = false"
                              ></v-date-picker>  
                            </v-menu>                                     
                          </div>  
                        </v-col>
                        <!--
                        <v-col v-if="$vuetify.breakpoint.lgAndUp" cols="12" md="8" class="mt-3 text-center">
                          <v-card class="neu-glow pa-2 ml-4 ">
                             <div class="info--text text-h4">{{booking.date?new Date(booking.date).toLocaleDateString('it-IT', {weekday: 'long', month: 'long', day: 'numeric' }):''}}</div>
                          </v-card>
                        </v-col>
                        -->                                                 
                        <v-col cols="12" class="py-0 mt-3" id="mealsAreaSlots">
                          <v-row class="pa-0" id="mealsAreas">
                            <div class=" my-2 flex-grow-1 flex-shrink-1">
                              <v-card class="neu-glow mx-3">
                                <v-card-text>
                                  <v-row  class="pa-3 d-flex justify-center">
                                    <v-btn-toggle v-model="booking.mealId" active-class="info white--text" class="flex-wrap justify-center background" >
                                      <v-btn
                                        class="px-4 text-subtitle-1"
                                        v-for="(l,l2) in meals" :key="l2"
                                        :value="l.mealId"
                                        :width="125"
                                        :disabled="!booking.covers"
                                        :loading="loading_getFreeSlots"
                                        @click="booking.slotId=null"
                                      >
                                      {{l.name}}
                                      </v-btn>
                                    </v-btn-toggle>                         
                                  </v-row>                       
                                </v-card-text>
                              </v-card>                     
                            </div> 
                            <div v-if="locations&&locations.length>0" class=" my-3 flex-grow-1 flex-shrink-1">
                              <v-card class="neu-glow mx-3">
                                <v-card-text>
                                  <v-row  class="pa-3 d-flex justify-center">
                                    <v-btn-toggle v-model="booking.locationId" active-class="info white--text" class="flex-wrap justify-center background">
                                        <v-btn
                                          class="px-4 text-subtitle-1"
                                          v-for="(l,l2) in locations" :key="l2"
                                          :value="l.locationId"
                                          :width="125"
                                          :disabled="!booking.mealId"
                                          :loading="loading_getFreeSlots"
                                        >
                                        <div v-html="l.name"></div>
                                        </v-btn>
                                    </v-btn-toggle>                         
                                  </v-row>                      
                                </v-card-text>		  
                              </v-card>
                            </div> 
                            <div v-else-if="halls&&halls.length" class="my-3 flex-grow-1 flex-shrink-1">
                              <v-card class="neu-glow mx-3">
                                <v-card-text>
                                  <v-row  class="pa-2 d-flex justify-center">
                                    <v-btn-toggle v-model="booking.hallId" active-class="info white--text" class="flex-wrap justify-center elevation-8">
                                        <!--
                                        <v-btn
                                          class="px-4 text-subtitle-1"
                                          v-for="(l,l2) in locations" :key="l2"
                                          :value="l.locationId"
                                          :disabled="!booking.mealId"
                                        >
                                        <div v-html="l.name"></div>
                                      </v-btn>
                                      -->
                                      <v-btn 
                                        v-for="(m,m2) in halls.filter(h=>h.locationId==booking.locationId||(h.locationId==locations[0].locationId&&!booking.locationId))" :key="m2"
                                        v-bind="attrs" v-on="on"
                                        :value="m.hallId"
                                        :disabled="!booking.mealId"
                                        class="px-4 text-subtitle-1"
                                        :loading="loading_getFreeSlots"
                                      >
                                      {{m.hallName}}{{m.name}}
                                      </v-btn>                                    
                                    </v-btn-toggle>                         
                                  </v-row>                      
                                </v-card-text>		  
                              </v-card>
                            </div>
                            <v-col cols="12" id="slots2">
                              <v-card class="neu-glow" id="slots">
                                <v-row class="pa-0 justify-center">
                                  <div class="pl-3">
                                    <v-card-text>
                                      <div class="text-center" v-if="booking.hallId||booking.locationId">
                                        <v-row>
                                          <v-col cols="12">
                                            <template  v-if="freeTables_all">       
                                              <v-btn-toggle v-model="booking.slotId" active-class="info white--text" class="flex-wrap justify-center transparent-bg">
                                                <template v-for="(ft,f1) in freeTables_all.filter(f=>f.mealId==booking.mealId)">
                                                  <v-tooltip top :key="f1" >
                                                    <template v-slot:activator="{ on, attrs }">  
                                                      <div v-bind="attrs" v-on="on">
                                                        <v-btn 
                                                          :height="50"
                                                          :max-width="66"
                                                          class="text-subtitle-1 ma-1"
                                                          :class="ft.freeTables&&!ft.freeTables.length&&!ft.assigned?'error darken-2 font-weight-bold ':
                                                                  (ft.unassigned&&!ft.assigned)&&booking.slotId!=ft.slotId?'warning darken-2 font-weight-bold ':
                                                                  /*2025-06-01 yellow slot issue*/
                                                                  /*ft.assigned&&ft.unassigned||forceTableAllocation)&&booking.slotId!=ft.slotId?'warning lighten-3 font-weight-bold black--text':*/
                                                                  'font-weight-bold blue-grey darken-2'"
                                                          :value="ft.slotId"
                                                          :loading="loading_getFreeSlots"
                                                          
                                                          @click="processSlot(ft)"
                                                        >
                                                          <span>
                                                            <div>{{ft.name}}</div>
                                                            <div class="text-caption" :class="ft.totalCovers>ft.covers?'warning--text':''">#{{ft.totalCovers+'/'+ft.covers}}</div>
                                                          </span>
                                                          <!--
                                                          <span v-html="ft.name"></span>
                                                          <span class="text-caption" v-html="'<br>#'+ft.totalCovers+'/'+ft.covers"></span>
                                                          -->
                                                        </v-btn>
                                                      </div>
                                                    </template>
                                                    <span>{{ft.freeTables&&ft.freeTables.length&&!ft.assigned?'Assegnazione Manuale Obbligatoria':!ft.assigned?(settings.options.manageWaitingList=='1'?$t(page+'.Waiting List'):$t(page+'.Sold Out')):$t(page+'.Seats Available')}}</span>
                                                  </v-tooltip>
                                                  <!--
                                                  <div v-if="ft.unassigned" :key="f1">
                                                    <ul>
                                                      <li v-for="(ub, ubi) in ft.unassignedBookings" :key="ubi">
                                                        {{ub.lastName}} - {{ub.time}} - Coperti: {{ub.covers}}
                                                      </li>
                                                    </ul>
                                                  </div>
                                                  -->
                                                </template>
                                              </v-btn-toggle>
                                              <div class="pt-2 warning--text darken-2 font-weight-black" v-if="booking.slotId&&freeTables_all.find(f=>f.slotId==booking.slotId).unassigned==1&&freeTables_all.find(f=>f.slotId==booking.slotId).assigned==0">
                                                Seleziona Obbligatoriamente Tavoli per {{booking.covers}} {{booking.children? '+' + booking.children:''}} coperti
                                              </div>
                                            </template>                                              
                                            <div v-else>
                                              <v-progress-circular v-if="loading" indeterminate size="46" width="3" color="info"></v-progress-circular>
                                            </div>
                                          </v-col>
                                        </v-row>
                                      </div>
                                    </v-card-text>
                                  </div>
                                  <v-col class="d-flex align-center justify-center shrink">
                                    <!--
                                    <div class="mx-6 text-h5" v-if="freeTables_all&&booking.slotId">
                                      {{(freeTables_all.find(z=>z.slotId==booking.slotId).endTime-freeTables_all.find(z=>z.slotId==booking.slotId).startTime)/60}}&nbsp;"
                                    </div>
                                    -->

                                    <v-tooltip top color="rgba(0,0,0,1">
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn small class="neu-glow" icon v-bind="attrs" v-on="on" @click="dialog_allocationRules=true">
                                          <v-icon fab color="info">mdi-information</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>
                                        <div class="">Istruzioni</div>
                                      </span>
                                    </v-tooltip>

                                    <v-tooltip top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <div>
                                          <v-btn
                                            v-bind="attrs" v-on="on" icon tile class="neu-glow mx-4 px-12" large 
                                            @click="dialog_mealDuration=true">                                            
                                            <v-icon color="info">mdi-timer-sand</v-icon>
                                            <div class="mx-3" :class="booking.mealDuration?'red--text font-weight-black':'font-weight-black'" v-if="freeTables_all&&booking.slotId||booking.mealDuration">
                                              {{(booking.mealDuration?(booking.mealDuration):freeTables_all.find(z=>z.slotId==booking.slotId).endTime-freeTables_all.find(z=>z.slotId==booking.slotId).startTime)/60}}"
                                            </div>
                                          </v-btn>
                                        </div>
                                      </template>
                                      <span>Durata Pasto</span>
                                    </v-tooltip> 

                                    <v-btn v-bind="attrs" v-on="on" class="mx-5 info--text font-weight-black" style="pointer-events: none;" v-if="selectedSlotIdEdit_copy&&slots.find(s=>s.slotId==selectedSlotIdEdit_copy).name" >
                                      {{slots.find(s=>s.slotId==selectedSlotIdEdit_copy).name}}
                                    </v-btn>                                 
                                  </v-col>
                                </v-row>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-row class="no-gutters">

                        <v-col cols="12" md="12" class="py-0 mb-3">
                          <v-card class="neu-glow">                    
                            <v-card-title class="py-2">
                              <span v-if="booking.phone&&booking.phone.length>=8">
                              <v-tooltip top >
                                <template v-slot:activator="{ on, attrs }">
                                  <div
                                    v-bind="attrs"
                                    v-on="on"
                                    style="width:min-content;"
                                  >              
                                    <v-switch
                                      color="success"
                                      dense
                                      v-model="sendWAConfirmationModel"
                                      inset
                                      name="sendWAConfirmationModel"
                                      hide-details
                                      prepend-icon="mdi-whatsapp"
                                      class="mt-1 pt-0 mr-6"
                                    ></v-switch>
                                  </div>                
                                </template>
                                <span>Invia WhatsApp Conferma Prenotazione</span>
                              </v-tooltip>
                              </span>
                              <v-spacer></v-spacer> 
                              
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <div
                                    v-bind="attrs"
                                    v-on="on"
                                    style="width:min-content;"
                                  >              
                                    <v-switch
                                      color="error"
                                      dense
                                      v-model="booking.isTheFork"
                                      inset
                                      name="isFork"
                                      hide-details
                                      prepend-icon="mdi-silverware-fork"
                                      class="mt-1 pt-0 mr-6"
                                    ></v-switch>
                                  </div>                
                                </template>
                                <span>Prenotazione The Fork</span>
                              </v-tooltip>
                              <v-spacer></v-spacer>  


                              <v-tooltip top v-if="settings.options.childrenPresenceRequired=='1'">
                                <template v-slot:activator="{ on, attrs }">
                                  <div
                                    v-bind="attrs"
                                    v-on="on"
                                    style="width:min-content;"
                                  >              
                                    <v-switch
                                      color="info"
                                      dense
                                      v-model="booking.childrenPresence"
                                      inset
                                      true-value="1"
                                      false-value="-1"
                                      name="childrenPresence"
                                      hide-details
                                      prepend-icon="mdi-human-child"
                                      class="mt-1 pt-0 mr-6"
                                    ></v-switch>
                                  </div>                
                                </template>
                                <span>Presenza Bambini</span>
                              </v-tooltip>

                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <div>
                                    <v-btn 
                                      small
                                      :loading="loading_checkUser"
                                      v-bind="attrs" v-on="on" fab icon class="neu-glow mr-md-2 mr-2" 
                                      :disabled="!userDetails" 
                                      @click="dialog_userDetails=true">
                                      <v-icon :loading="loading_checkUser" :class="!userDetails?'':userDetails.minScore<0?'error--text':'success--text'">mdi-card-account-details</v-icon> 
                                    </v-btn>
                                  </div>
                                </template>
                                <span>Info Cliente</span>
                              </v-tooltip> 
                              <!-- 
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <div>
                                    <v-btn
                                      small 
                                      v-bind="attrs" v-on="on" fab icon class="neu-glow mr-md-2 mr-2" 
                                      @click="dialog_mealDuration=true">
                                      <v-icon color="info">mdi-timer-sand</v-icon>
                                    </v-btn>
                                  </div>
                                </template>
                                <span>Durata Pasto</span>
                              </v-tooltip>
                              -->

                             <v-spacer></v-spacer>
                              
                              <template v-if="settings.level>10">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <div>
                                      <v-btn
                                        small               
                                        v-bind="attrs" v-on="on" fab icon class="neu-glow mr-md-2 mr-2" 
                                        @click="dialog_addressBook=!dialog_addressBook;addressBookSearch='';addressBookCustomers=null"
                                      >
                                        <v-icon color="info">mdi-book-open-variant</v-icon>
                                      </v-btn>
                                    </div>
                                  </template>
                                  <span>Rubrica</span>
                                </v-tooltip>   
                              </template>
                              

                             <v-spacer></v-spacer>
                              <!--
                                    <div>{{!booking.slotId}}|{{forceTableAllocation===1}}|{{!validCombinations}}|
                                      {{((settings.options.phoneRequiredWalkIn=='1'&&!booking.phone))}}|{{((settings.options.fullnameRequiredWalkIn=='1'&&!booking.lastName))}}
                                      |{{(!selectedSlot.assigned&&booking.tablesId.length==0)}}||
                                      </div>
                              --> 
                              <template>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <div>
                                      <v-btn
                                        
                                        :disabled="
                                                      !booking.slotId
                                                      ||((settings.options.phoneRequiredWalkIn=='1'&&!booking.phone))
                                                      ||((settings.options.fullnameRequiredWalkIn=='1'&&!booking.lastName))
                                                  "                 
                                        v-bind="attrs" v-on="on" fab icon class="neu-glow mr-md-6 mr-2" 
                                        @click="saveWalkIn('wl')">
                                        <v-icon color="error">mdi-clipboard-list</v-icon>
                                      </v-btn>
                                    </div>
                                  </template>
                                  <span>Salva in Lista d'Attesa</span>
                                </v-tooltip>   
                              </template>

                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <div>
                                    <v-btn 
                                      v-bind="attrs" v-on="on" fab icon class="neu-glow mr-md-6 mr-2" 
                                      :loading="loading_book"
                                      :disabled="
                                                    !booking.slotId
                                                    ||((settings.options.phoneRequiredWalkIn=='1'&&!booking.phone))
                                                    ||((settings.options.fullnameRequiredWalkIn=='1'&&!booking.lastName))
                                                    ||booking.tablesId.length==0
                                                    ||(selectedSlot&&!selectedSlot.assigned&&booking.tablesId.length==0)
                                                    &&!enableBookWithTables
                                                " 
                                      @click="selectAction()">
                                      <v-icon color="warning">mdi-table-furniture</v-icon>
                                    </v-btn>
                                  </div>
                                </template>
                                <span>Salva con Tavoli</span>
                              </v-tooltip>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn 
                                    v-bind="attrs" v-on="on" fab icon class="neu-glow mr-md-6 mr-2" 
                                    :loading="loading_book" 
                                    :disabled="
                                                  !booking.slotId
                                                  ||forceTableAllocation==1
                                                  ||!validCombinations
                                                  ||((settings.options.phoneRequiredWalkIn=='1'&&!booking.phone))
                                                  ||((settings.options.fullnameRequiredWalkIn=='1'&&!booking.lastName))
                                                  ||(booking.slotId&&selectedSlot&&!selectedSlot.assigned)
                                              "                                              
                                    @click="saveWalkIn('',0)">
                                    <v-icon color="success">mdi-content-save</v-icon>
                                  </v-btn>
                                </template>
                                <span>Salva senza Tavoli</span>
                              </v-tooltip>
                              <!--
                              <v-tooltip top >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn @click="close_dialog_walkIn()" fab class="neu-glow ml-md-8 ml-2 mt-4" v-bind="attrs" v-on="on">
                                    <v-icon color="error">mdi-close</v-icon>
                                  </v-btn>
                                </template>
                                <span>Chiudi</span>
                              </v-tooltip>
                              -->
                            </v-card-title>
                          </v-card>

                        </v-col> 
                        <!--
                        <v-col>
                          booking.slotId:{{booking?booking.slotId:''}} | selectedSlot.assigned: {{selectedSlot?selectedSlot.assigned:''}} | booking.tablesId.length: {{booking.tablesId?booking.tablesId.length:''}}
                        </v-col>
                        -->
                        <v-col cols="12">
                          <v-expand-transition>
                            <v-card class="neu-glow" v-show="dialog_addressBook">
                              <!--
                              <v-card-title>
                                <v-toolbar flat>
                                  -->
                                  <v-card-title class="neu-glow py-0">
                                    <span class="text-h4">Rubrica</span> 
                                    <v-spacer></v-spacer>
                                    <span class="">
                                      {{selectedAddresses}}
                                    </span>
                                    <v-spacer></v-spacer>
                                    <span class="pt-0 pb-2">
                                      <v-text-field
                                        v-model="addressBookSearch"
                                        append-icon="mdi-magnify"
                                        label="Cerca"
                                        single-line
                                        clearable
                                        class="px-8"
                                        max-width="350"
                                        hint="Inserire Nome o Cognome o Numero (almeno 3 caratteri/numeri)"
                                        persistent-hint
                                      ></v-text-field>               
                                    </span>
                                </v-card-title>
                              <v-card-text>
                                <v-data-table
                                  :headers="addressBookCustomerHeaders"
                                  :items="addressBookCustomers||[]"
                                  :search="addressBookSearch"
                                  :loading="loading_addressBook" 
                                  item-key="phone"
                                  :height="500"
                                  :items-per-page="50000"
                                  class="neu-glow mt-3"
                                  hide-default-footer
                                  fixed-header
                                  dark
                                  :show-expand="false"
                                  :single-expand="1"
                                  :expanded.sync="addressBookExpanded"          
                                >
                                  <template v-slot:[`item.details`]="{ item }">
                                    <v-btn :loading="loading_addressBook" @click.native.stop="getAddressBookDetails(item)" icon>
                                      <v-icon color="info">mdi-account-details</v-icon>
                                    </v-btn>

                                  </template> 
                                  <template v-slot:[`item.book`]="{ item }">
                                      <v-icon @click.native.stop="pasteAddressBookData(item)"
                                      style="cursor:pointer" color="info">mdi-account-plus</v-icon>                 
                                  </template>                
                                  <template v-slot:[`item.call`]="{ item }">              
                                    <v-icon v-if="item.phone" :href="'tel:'+item.countryCode+item.phone" style="cursor:pointer" :color="item?'success':''">mdi-phone</v-icon>
                                  </template>

                                  <template v-slot:expanded-item="{ headers, item }" v-if="addressBookCustomers&&addressBookCustomers[0].details">
                                    <td :colspan="headers.length" class="my-2 py-2">
                                      <v-data-table
                                        :headers="addressBookBookingHeaders"
                                        :items="addressBookCustomers.find(b=>b.id==item.id).details||[]"
                                        :items-per-page="500"
                                        :height="400"
                                        item-key="phone"
                                        class="neu-glow"
                                        hide-default-footer
                                        fixed-header
                                        dark        
                                      >
                                        <template v-slot:[`header.ghost`]="{ header }">
                                          <v-icon color="error" :class="header?'':''" small>mdi-ghost</v-icon>
                                        </template>
                                        <template v-slot:[`item.ghost`]="{ item }">
                                          <v-simple-checkbox
                                            v-model="item.ghost"
                                            readonly
                                          ></v-simple-checkbox>
                                        </template> 
                                      </v-data-table>       
                                    </td>
                                  </template>              
                                </v-data-table>
                              </v-card-text>       
                            </v-card>
                          </v-expand-transition>
                        </v-col>                        
                        <v-col cols="12" class="py-0" id="cliente">
                          <v-card class="neu-glow">
                            <v-card-text class="mb-5 pb-0">
                              <v-row class="">
                                <v-col cols="12" md="3" class="px-1">
                                  <v-autocomplete
                                    color="info"
                                    outlined
                                    v-model="booking.countryCode"
                                    :items="countries"
                                    :label="$t(page+'.Country Code')"
                                    hide-details
                                    :item-text="item => item.name +' '+ item.value"
                                    @focus="$set(booking, 'countryCode', null)"
                                  >
                                    <template v-slot:item="slotProps" >
                                      <i :class="['mr-2', 'em', slotProps.item.flag]"></i>
                                      {{slotProps.item.namel}} + {{slotProps.item.value}}
                                    </template>
                                    <template v-slot:selection="data">
                                      <i :class="['mr-2', 'em', data.item.flag]"></i>
                                      + {{ data.item.value }}
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="9" md="7" class="px-1">
                                  <v-text-field
                                    prepend-inner-icon="mdi-whatsapp"
                                    color="info"
                                    label="Cellulare"
                                    v-model="booking.phone"
                                    name="phone"
                                    type="tel"
                                    autocomplete="off"
                                    hide-spin-buttons
                                    outlined
                                    clearable
                                    hide-details
                                    :success="successPhone_status"
                                    :error="errorPhone_status"
                                    :hint="errorPhone"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="3" md="2" class="text-center px-1">
                                  <v-btn block :disabled="!booking.phone||booking.phone.length<8" height="56" elevation="5" :href="'tel:+'+booking.countryCode+booking.phone" class="success white--text py-5">
                                    <v-icon large>mdi-phone</v-icon>
                                  </v-btn>
                                </v-col>
                                <v-col cols="12" md="6" class="px-1">
                                  <v-text-field
                                    prepend-inner-icon="mdi-account"
                                    color="info"
                                    label="Cognome"
                                    v-model="booking.lastName"
                                    name="lastName"
                                    autocomplete="off"
                                    outlined
                                    clearable
                                    hide-details
                                  ></v-text-field>  
                                </v-col>
                                <v-col cols="12" md="6" class="px-1">
                                  <v-text-field
                                    prepend-inner-icon="mdi-account"
                                    color="info"
                                    label="Nome"
                                    v-model="booking.firstName"
                                    name="firstName"
                                    autocomplete="off"
                                    outlined
                                    clearable
                                    hide-details
                                  ></v-text-field>  
                                </v-col>
                                <v-col cols="3" md="2" class="pt-0 pt-lg-3 pl-1">
                                  <v-btn
                                      height="56"
                                      outlined
                                      color="blue-grey"
                                      block
                                      @click="booking.lastName='WALK IN'"
                                  >
                                    <v-icon dark>
                                      mdi-walk
                                    </v-icon>
                                  </v-btn>
                                </v-col>
                                <v-col cols="5" md="3" class="pt-0 pb-3 px-1 mt-md-3" >
                                  <v-text-field
                                    prepend-inner-icon="mdi-map-marker"
                                    color="info"
                                    label="CAP"
                                    v-model="booking.postalCode"
                                    name="postalCode"
                                    autocomplete="off"
                                    outlined
                                    hide-details
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="4" md="3" class="pt-0 pb-3 px-1 mt-md-3" v-if="(settings.options.birthdateRequested=='1'||settings.options.birthdateRequired=='1')" >
                                  <v-menu
                                    ref="menuBirthdate"
                                    v-model="menuBirthdate"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    :nudge-left="$vuetify.breakpoint.smAndDown?240:40"
                                    offset-y
                                    min-width="auto"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <!--
                                      <v-btn 
                                        block x-large 
                                        class="info--text font-weight-black text-h5"
                                        v-bind="attrs" v-on="on"
                                      >
                                          <div v-if="booking.birthdate">
                                            {{new Date(booking.birthdate).toLocaleDateString('it-IT', {weekday: 'short', month: 'long', day: 'numeric', year:'numeric' })}}
                                          </div>
                                          <div v-else>
                                            <v-icon color="info mr-3">mdi-cake-variant</v-icon>
                                            Compleanno
                                          </div>
                                        </v-btn>
                                        -->
                                      
                                      <v-text-field
                                        v-model="booking.birthdate"
                                        :label="$t(page+'.Birthdate')"
                                        prepend-inner-icon="mdi-calendar"
                                        outlined
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        hide-details
                                      ></v-text-field>                                        
                                    </template>
                                    <v-date-picker
                                      ref="birthdate"
                                      first-day-of-week=1
                                      :locale="locale"
                                      v-model="booking.birthdate"
                                      color="info"
                                      :max="subtractYears(14)"
                                      :min="subtractYears(99)"
                                      @change="saveBirthdate"
                                    ></v-date-picker>
                                  </v-menu>                                  
                                </v-col>                                                                                                 
                                <v-col cols="12" md="4" class="mb-3 pt-0 pb-3 px-1 mt-md-3" > 
                                  <v-text-field
                                    prepend-inner-icon="mdi-account"
                                    color="info"
                                    label="Note"
                                    v-model="booking.remarks"
                                    name="remarks"
                                    autocomplete="off"
                                    outlined
                                    hide-details
                                  ></v-text-field>
                                </v-col>                                          
                              </v-row>
                              <v-row>

                                  <v-col cols="12" md="6" class="py-0" v-if="settings.options.emailRequested=='1'||settings.options.emailRequired=='1'">
                                    <v-text-field
                                      prepend-inner-icon="mdi-at"
                                      :color="settings.options.emailRequired=='1'?'error':settings.options.color"
                                      :label="settings.options.emailRequired=='1'?$t(page+'.Email')+' *':$t(page+'.Email')"
                                      v-model="booking.email"
                                      name="email"
                                      autocomplete="off"
                                      outlined
                                      ref="email"
                                      :hint="settings.options.emailRequired=='1'?$t(page+'.Mandatory'):$t(page+'.Optional')"
                                    ></v-text-field>  
                                  </v-col>                                 
                              </v-row>                                                  
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="12" class="py-20 mt-2">
                          <v-row class="pa-0" id="reqOpt">
                            <v-col cols="12" sm="6">
                              <v-card class="neu-glow">
                                <v-card-text class="py-2">
                                  <v-row>
                                    <template v-for="(r,i) in requests">
                                      <v-col class="text-center px-1" :key="i">	  
                                        <template>
                                            <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                              <v-icon v-bind="attrs" v-on="on">{{r.icon}}</v-icon>
                                              <v-simple-checkbox
                                                v-bind="attrs" v-on="on"
                                                v-model="booking.requests[i].value"
                                                :label="$t(page+'.'+r.name)"
                                                color="info"
                                                class="mt-1"
                                                small
                                                ></v-simple-checkbox>
                                            </template>
                                            <span v-html="r.description"></span>
                                            </v-tooltip>									  
                                        </template>
                                      </v-col>
                                    </template>                       
                                  </v-row>                      
                                </v-card-text>		  
                              </v-card>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-card class="neu-glow">
                                <v-card-text class="py-2">
                                  <v-row>
                                    <template v-for="(r,i) in foodStyles">
                                      <v-col class="text-center px-1" :key="i">	  
                                        <template>
                                            <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                              <v-icon v-bind="attrs" v-on="on">{{r.icon}}</v-icon>
                                              <v-simple-checkbox
                                                v-bind="attrs" v-on="on"
                                                v-model="booking.foodStyles[i].value"
                                                :label="$t(page+'.'+r.name)"
                                                color="info"
                                                class="mt-1"
                                                small
                                                ></v-simple-checkbox>
                                            </template>
                                            <span v-html="r.description"></span>
                                            </v-tooltip>									  
                                        </template>
                                      </v-col>
                                    </template>                        
                                  </v-row>                       
                                </v-card-text>
                              </v-card>                     
                            </v-col>                    
                          </v-row>                   
                        </v-col>                
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row class="px-3 pb-3">
                  </v-row>  
                </v-col>
              </v-card-text>
                        <v-card class="neu-glow mx-6 pa-2 my-2 error" v-if="showUnassigned2">
                          <v-card-title class="font-weigth-bold py-0">Prenotazioni non Assegnabili
                            <v-spacer></v-spacer>
                            <div v-for="(u,ui) in freeTables_all[0].unassignedBookings.filter(ff=>ff.bookingId!='Neu')" :key=ui>
                              <v-btn small class="mr-2 disable-events" @click="ShowManualAssignMap(u)" > {{u.lastName+' - '+u.covers}} pax</v-btn>
                            </div>
                            <v-spacer></v-spacer>
                            <v-tooltip top color="black" max-width=200>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn small class="neu-glow" icon v-bind="attrs" v-on="on" @click="dialog_allocationRules=false">
                                  <v-icon fab color="info">mdi-information</v-icon>
                                </v-btn>
                              </template>
                              <span>
                                <div class="">Assegnare immediatamente in manuale il tavolo, l’AI non ha trovato una combinazione appropriata</div>
                              </span>
                            </v-tooltip>                                
                          </v-card-title>                      
                        </v-card>                
            </v-card>            
          </v-col>
          <v-col cols="12" lg="12" class="neu-glow primaryBgText darken-3" id="volante_Map">
            <v-card class="neu-glow pb-2">
              <template v-if="freeTables_all&&(booking.locationId||booking.hallId)">
                <v-row v-if="halls">
                  <v-col cols="12" sm="12" :md="halls.filter(h=>h.locationId==booking.locationId)&&halls.filter(h=>h.locationId==booking.locationId).length>1?6:12"  class="" v-for="(h,hi) in halls.filter(h=>h.locationId==booking.locationId)" :key="hi" id="volanteMap">
                    <div class="grey darken-3 pl-4 py-1 font-weight-black">{{h.name}}</div>
                      <v-col class=" pb-1 pt-3 neu-glow-inset">
                        <div :style="'width:'+(wWidth*.94/2)+'px;height:'+(calcWHeight(300))+'px;position: relative'">   

                          <v-btn-toggle
                                  v-model="booking.tablesId"
                                  multiple 
                                  class="flex-wrap"
                                  :style="'height:'+calcWHeight(0)+'px'"
                                  active-class="info"
                          >
                              <v-btn
                                      v-for="(p,pi) in tables.filter(t => t.hallId===h.hallId)||t.hallId===halls[0].hallId"
                                      :key="pi"
                                      :value="p.tableId"
                                      absolute
                                      :class="freeTableClassVolante(p,booking)"  
                                      :style="{width: (p.width*zoomLevelFull(p.hallId))+'px','min-width': (p.width*zoomLevelFull(p.hallId))+'px',height: (p.height*zoomLevelFull(p.hallId))+'px',left:(p.xPos*zoomLevelFull(p.hallId))+'px',top:(p.yPos*zoomLevelFull(p.hallId))+'px',transform:'rotate('+(p.angle*45)+'deg)'}"
                              >
                                <span class="black--text">
                                  <div v-html="freeTableClassVolanteDetails(p,booking)"></div>
                                </span>
                              </v-btn>
                          </v-btn-toggle>
                        </div>
                      </v-col>
                  </v-col>
                </v-row>
              </template>
            </v-card>
            
          </v-col>

          
        </v-row>       
      </template>
    </v-dialog>
    <v-dialog v-model="dialog_history"
      width="800"
      color="red lighten-3"
      v-if="historyEvents"
    >
      <v-card class="px-3 neu-glow">
        <v-card-title class="text-h5 mb-2 font-weight-bold">
          Storico Prenotazione (Beta/Test!)
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow"  @click="dialog_history = false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>          
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="!historyEvents">
          <v-card :height="wHeight-248" class="text-center mt-14">
              <v-progress-circular
                :size="200"
                width="30"
                color="info"
                indeterminate
              ></v-progress-circular>
          </v-card>               
        </v-card-text>

        <v-card-text v-else class="text-subtitle-1 pt-2">
          <v-timeline
            align-top
            dense
            fill-dot
            
          >
            <v-timeline-item
              :color="ei==0?'success':'info'"
              :small="ei!=0"
              v-for="(e,ei) in historyEvents" :key="ei"
            >
              
              <v-card :color="ei==0?'success darken-1':'info darken-1'">
                <v-card-title>
                  <strong>{{fdate(e.TS)}}</strong>
                </v-card-title>
                <v-card-text>
                  <v-row class="pt-1">
                    <v-col cols="12">
                      <v-row >
                        <v-col >
                        <v-simple-table class="pa-3">
                          <template v-slot:default>
                            <tbody>
                              <template v-for="(ev,key,evi) in e">
                                <tr 
                                  :key="evi"                          
                                >
                                  <v-simple-table>
                                    <template v-slot:default>
                                      <tbody>
                                        <tr v-if="key!='TS'"
                                        >
                                          <td width="200" style="height:20px">{{key}}</td>
                                          <td style="height:20px">
                                              <span v-html="calcHistory(ei,key,historyEvents.length)"></span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </template>
                                    </v-simple-table>
                                </tr>                            
                              </template>
                            </tbody>
                          </template>
                        </v-simple-table>                    
                        </v-col>                  
                      </v-row>
                    </v-col>
                  </v-row>                
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>

      </v-card>
    </v-dialog> 
    <v-dialog v-model="dialog_mealDuration"
      width="600"
      color="red lighten-3"
      v-if="mealDurations"
      class="neu-glow"
    >
      <v-card class="px-3 neu-glow pb-3">
        <v-card-title class="text-h5 mb-2 font-weight-bold">
          Imposta Durata Pasto
            <v-spacer></v-spacer>
            <!--
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow mr-4" :loading="loading" @click="dialog_mealDuration = false">
                  <v-icon color="success">mdi-check</v-icon>
                </v-btn>
              </template>
              <span>OK</span>
            </v-tooltip>  
            -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow"  @click="booking.mealDuration=null;dialog_mealDuration = false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>          
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-subtitle-1 pt-2 neu-glow">
          <p>
            Impostazione necessaria solo se la durata è diversa dallo standard
          </p>
          <v-card class="neu-glow mt-6 mb-3">
            <v-row class="px-3 d-flex justify-center">                   
                <v-btn-toggle
                  v-model="booking.mealDuration" 
                  active-class="info white--text"
                  class="transparent-bg"
                >
                  <v-col class="px-5">
                    <template v-for="(md,mdi) in mealDurations">
                    <v-btn :value="md.seconds" :key="mdi" icon fab dense small class="neu-glow mr-3 my-3" @click="setMealDuration(md.seconds)">
                      {{md.seconds/60}}"
                    </v-btn>                              
                  </v-col>
                </v-btn-toggle>
            </v-row>
          </v-card>
        </v-card-text>

      </v-card>
    </v-dialog> 
    <v-dialog v-model="dialog_mealDurationSlim"
      width="600"
      color="red lighten-3"
      v-if="mealDurations"
      class="neu-glow"
    >
      <v-card class="px-3 neu-glow pb-3">
        <v-card-title class="text-h5 mb-2 font-weight-bold">
          Imposta Durata Pasto
            <v-spacer></v-spacer>
            <!--
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow mr-4" :loading="loading" @click="dialog_mealDuration = false">
                  <v-icon color="success">mdi-check</v-icon>
                </v-btn>
              </template>
              <span>OK</span>
            </v-tooltip>  
            -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow"  @click="booking.mealDuration=null;dialog_mealDurationSlim = false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>          
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-subtitle-1 pt-2 neu-glow">
          <p class="red--text">
            ATTENZIONE: se impostate una durata più lunga di quella proposta, verificate che il tavolo sia ancora Libero!
          </p>
          <v-card class="neu-glow mt-6 mb-3">
            <v-row class="px-3 d-flex justify-center">                   
                <v-btn-toggle
                  v-model="walkIn.mealDuration" 
                  active-class="info white--text"
                  class="transparent-bg"
                  mandatory
                >
                  <v-col class="px-5">
                    <template v-for="(md,mdi) in mealDurations">
                    <v-btn :value="md.seconds" :key="mdi" icon fab dense small class="neu-glow mr-3 my-3" @click="dialog_mealDurationSlim=false" >
                      {{md.seconds/60}}'
                    </v-btn>                              
                  </v-col>
                </v-btn-toggle>
            </v-row>
          </v-card>
        </v-card-text>

      </v-card>
    </v-dialog>     
    <v-dialog v-model="dialog_rating"
      width="500"
      color="red lighten-3"

    >
      <v-card class="px-3 pb-8">
        <v-card-title class="text-h5 mb-2 font-weight-bold">
          Valutazione Cliente
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow mr-1" :disabled="!booking.rating" @click="rateUser(booking.rating,booking.ratingRemarks)">
                  <v-icon color="success">mdi-content-save</v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip> 

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow"  @click="booking.mealDuration=null;dialog_rating = false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>          
        </v-card-title>
        <v-row class="px-3 d-flex justify-center">
          <div class="d-flex flex-column" style="gap:8px">
            <div
              v-for="(l,li) in userRatings"
              :key="li"
              class="d-flex align-center"
              style="cursor:pointer"
              @click="booking.rating = l.ratingLevel"
            >
              <v-btn
                icon fab dense small
                class="neu-glow mr-4"
                :class="booking.rating === l.ratingLevel ? 'info' : ''"
                :value="l.ratingLevel"
              >
                <v-icon :color="l.color">{{l.icon}}</v-icon>
              </v-btn>
              <span v-html="l.class+': '+l.rule"></span>
            </div>
            <div class="d-flex flex-column mt-4" style="gap:8px">
              <v-text-field v-model="booking.ratingRemarks" label="Note"></v-text-field>
            </div>            
          </div>
        </v-row>        
        <!--
        <v-row class="px-3 d-flex justify-center">
            <v-btn-toggle
              v-model="booking.rating" 
              active-class="blue-grey"
              class="transparent-bg"
            >
              <v-row v-for="(l,li) in userRatings" :key="li">
                <v-col cols="auto" class="px-5">
                  <v-tooltip top >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn :value="l.ratingLevel" v-bind="attrs" v-on="on" icon fab dense small class="neu-glow mr-2" @click="rateUser(l.ratingLevel)">
                        <v-icon :color="l.color">{{l.icon}}</v-icon>
                      </v-btn>                              
                    </template>
                    <span v-html="l.name"></span>
                  </v-tooltip>
                </v-col>
                <v-col cols="auto">
                  <span v-html="l.rule"></span>
                </v-col>
              </v-row>
            </v-btn-toggle>
        </v-row>
        -->
      </v-card> 

    </v-dialog>    
    <v-dialog v-model="dialog_resetTables"
      width="600"
      color="red lighten-3"
      v-if="selectedBooking&&selectedBooking.tables"
    >
      <v-card class="neu-glow pb-1">
        <v-card-title class="text-h5 mb-2 font-weight-bold">
          Conferma Cambio {{resetText}}
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow mr-4" :loading="loading" @click="resetTables()">
                  <v-icon color="error">mdi-flash</v-icon>
                </v-btn>
              </template>
              <span>Prosegui</span>
            </v-tooltip>  
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow"  @click="abortResetTables()">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>          
        </v-card-title>
        
        <v-divider></v-divider>
        <v-card class="neu-glow ma-4">
          <v-card-text class="text-subtitle-1 mt-3">
            <p>
              A questa Prenotazione sono già stati assegnati i seguenti tavoli:
            </p>
            <p class="text-center text-h6 font-weight-black info--text">
              {{selectedBooking.tables.join(', ')}}
            </p>
            <p>Modificando la {{resetText}} i tavoli verranno liberati e dovrai assegnarne altri</p>
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog> 
    <v-dialog v-model="dialog_coupon_details"
      width="500"
      class="neu-glow"
      color="red lighten-3"
      v-if="couponDetails"
    >
      <v-card class="neu-glow pb-1">
        <v-card-title class="text-h5 mb-2 font-weight-bold">
          Dettagli Coupon
          <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="error" v-bind="attrs" v-on="on" fab small icon class="neu-glow mr-4" :loading="loading" @click="disableCoupon(couponDetails.couponId)">
                  <v-icon color="warning">mdi-gift-open</v-icon>
                </v-btn>
              </template>
              <span>Disabilita Coupon</span>
            </v-tooltip>  
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow"  @click="dialog_coupon_details = false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>                     
        </v-card-title>
        <v-card-text>
          <v-card>
            <v-img
              v-if="couponDetails&&couponDetails.couponPicture" 
              max-height="300"
              :src="'https://ibookrestaurant.com/static/users/pictures/coupons/'+couponDetails.couponPicture" 
              :lazy-src="'https://ibookrestaurant.com/static/users/pictures/coupons/'+couponDetails.couponPicture" >
            </v-img>
            <div v-else class="my-6 text-h6 neu-glow pa-4 text-center">
              Coupon Manuale
            </div>
          </v-card>
        </v-card-text>
        <v-card-text>
          Prenotazione del: {{new Date(couponDetails.couponBookingDate).toLocaleDateString('it-IT',{ year: 'numeric', month: '2-digit', day: '2-digit',})}} ore {{couponDetails.couponBookingTime}}
          <br />
          Coperti: {{couponDetails.couponBookingCovers}}
          <br />
          Descrizione: {{couponDetails.couponDescription}}
        </v-card-text>
        <v-card-text>
          Status: {{couponDetails.couponSpentDate?'Già Speso il '+couponDetails.couponSpentDate:!couponDetails.isCouponValid?'Non Spendibile Oggi':'Valido'}}
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_DirectBookingLock"
      width="500"
      class="neu-glow"
      color="red lighten-3"
    >
      <v-card class="neu-glow pb-1">
        <v-card-title class="text-h5 mb-2 font-weight-bold">
          {{settings.options.disableSameDayDirectBooking!=dsddb?'Blocca Prenotazione Online':'Sblocca Prenotazione Online'}}
          <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="error" v-bind="attrs" v-on="on" fab small icon class="neu-glow mr-4" :loading="loading" @click="disableDirectBooking()">
                  <v-icon :color="settings.options.disableSameDayDirectBooking!=dsddb?'error':'success'">mdi-content-save</v-icon>
                </v-btn>
              </template>
              <span>Procedi</span>
            </v-tooltip>  
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow"  @click="dialog_DirectBookingLock = false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>         
        </v-card-title>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_permanentSaveWalkInWithTables"
      width="600"
      v-if="booking&&booking.tablesId&&dialog_permanentSaveWalkInWithTables"
    >
      <v-card class="neu-glow">
        <v-card-title class="text-h5">
          Salva Prenotazione con Tavoli
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow" @click="dialog_permanentSaveWalkInWithTables=false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Annulla</span>
              
              

            </v-tooltip>         
        </v-card-title>
        
        <v-card-text class="pa-6">
          <v-card class="neu-glow pa-5">
            <v-row>
              <v-col cols="12">
                Rilevata nuova combinazione per {{booking.children?booking.children/1+booking.covers/1:booking.covers}} coperti
              </v-col>
              <v-col cols="12" class="text-center text-h4">
                <div>
                  {{tables.filter(t=> booking.tablesId.includes(t.tableId)).map(z=>z.tableName).join('-')}}
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
        

        <v-card-text class="pa-6">
          <v-card class="neu-glow pa-5">
            <v-row>
              <v-col class="text-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" fab large icon color="warning" class="neu-glow" :loading="loading" @click="saveWalkIn('',1,1)">
                      <v-icon x-large color="info">mdi-content-save</v-icon>
                    </v-btn>
                    <div class="pt-2 text-h6">
                      Salva Assegnazione per uso Temporaneo
                    </div>
                  </template>
                  <span>Salva Assegnazione per uso Temporaneo</span>
                </v-tooltip>               
              </v-col>

              <v-col class="text-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" color="warning" fab large icon class="neu-glow" :loading="loading" @click="saveWalkIn('',1,2)">
                      <v-icon x-large color="success">mdi-table-cog</v-icon>
                    </v-btn>
                    <div class="pt-2 text-h6">
                      Salva Assegnazione per utilizzo con AI
                    </div>
                  </template>
                  <span> Salva per utilizzo con AI<br>per {{booking.children?booking.children/1+booking.covers/1:booking.covers}} coperti</span>
                </v-tooltip>               
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_saveCombination"
      width="600"
      v-if="item&&tablesList"
    >
      <v-card class="neu-glow">
        <v-card-title class="text-h5">
          Nuova Combinazione
            <v-spacer></v-spacer>           
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow" @click="dialog_saveCombination=false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Annulla</span>
            </v-tooltip>         
        </v-card-title>

        <v-card-text class="pa-6">
          <v-card class="neu-glow pa-5">
            <v-row>
              <v-col cols="12">
                Rilevata nuova Assegnazione per {{item.children?item.children/1+item.covers/1:item.covers}} coperti
              </v-col>
              <v-col cols="12" class="text-center text-h4">
                <div>
                  {{tablesList}}
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>

        <v-card-text class="px-6">
          <v-card class="neu-glow pa-5">
            <v-row>
              <v-col class="text-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" fab large icon color="warning" class="neu-glow" :loading="loading" @click="assignTablesSave(1)">
                      <v-icon x-large color="info">mdi-content-save</v-icon>
                    </v-btn>
                    <div class="pt-2 text-h6">
                      Salva Assegnazione per uso Temporaneo
                    </div>
                  </template>
                  <span>Salva Assegnazione per uso Temporaneo</span>
                </v-tooltip>               
              </v-col>
              <v-col class="text-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" color="warning" fab large icon class="neu-glow" :loading="loading" @click="assignTablesSave(2)">
                      <v-icon x-large color="success">mdi-table-cog</v-icon>
                    </v-btn>
                    <div class="pt-2 text-h6">
                      Salva Assegnazione per utilizzo con AI
                    </div>
                  </template>
                  <span> Salva per utilizzo con AI<br>per {{booking.children?booking.children/1+booking.covers/1:booking.covers}} coperti</span>
                </v-tooltip>               
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>

      </v-card>
    </v-dialog> 

    <v-dialog v-model="dialog_swapTables"
      width="900"
      v-if="item&&item.tables"
    >
      <v-card class="neu-glow">
        <v-card-title class="text-h5">
          Scambia Tavoli
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-2" :disabled="!swappedBooking" @click="swapTables()">
                  <v-icon color="error">mdi-shuffle-variant</v-icon>
                </v-btn>
              </template>
              <span>Scambia</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow" @click="dialog_swapTables=false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Annulla</span>
            </v-tooltip>         
        </v-card-title>
        <v-card-text class="pa-6">
          <v-card class="neu-glow pa-5">
            <v-row>
              <v-col cols="5" class="text-center text-h6 d-flex align-center">
                <div>
                  {{item.fullName}}: {{item.covers}} {{item.children?'+'+item.children:''}}px : {{item.time}}
                </div>
              </v-col>
              <v-col cols="2">
                &nbsp;
              </v-col>
              <v-col cols="5" class="text-center">
                <div class="text-h5">
                  <v-select
                    outlined
                    v-model="swappedBooking"
                    :items="bookings.filter(b=>((b.covers+b.children)===(item.covers+item.children)&&item.seconds<=b.seconds&&b.bookingId!=item.bookingId&&b.tables&&b.tables.length==item.tables.length))"
                    item-text="swapText"
                    return-object
                    label="Prenotazioni Scambiabili"
                    hide-details
                  >
                  </v-select>                 
                </div>                
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>          
        <v-card-text class="">
          <v-card class="neu-glow pa-5">
            <v-row>
              <v-col cols="6" class="text-center text-h3">
                <div class="text-h5">
                  {{item.fullName}}
                </div>
                <div class="text-h5">
                  {{item.covers}} {{item.children?'+'+item.children:''}}px -  {{item.time}}
                </div>
                <!--                
                <div class="text-h4 error--text">
                 {{item.tables.join('-')}}
                </div>
                <div class="text-h4 success--text ">
                  {{swappedBooking?swappedBooking.tables.join('-'):'???'}}
                </div>
                --> 
                <div>
                  <span class="text-h4 error--text text-center">
                    {{item.tables.join('-')}}
                  </span>
                  <v-icon>mdi-arrow-right-bold</v-icon>
                  <span class="text-h4 success--text">
                    {{swappedBooking?swappedBooking.tables.join('-'):'???'}}
                  </span>
                </div>                                              
              </v-col>
              <!--
              <v-col cols="2" class="d-flex align-end">
                <v-icon color="white" class="text-h1">mdi-swap-horizontal</v-icon>
              </v-col>
              -->
              <v-col cols="6" class="text-center text-h3">
                <div class="text-h5">
                  {{swappedBooking?swappedBooking.fullName:'???'}}
                </div>
                <div class="text-h5">
                  {{swappedBooking?swappedBooking.covers:'?'}} {{swappedBooking?(swappedBooking.children?'+'+swappedBooking.children:''):''}}px -  {{swappedBooking?swappedBooking.time:'??:??'}}
                </div> 
                <div>
                  <span class="text-h4 error--text text-center">
                    {{swappedBooking?swappedBooking.tables.join('-'):'???'}}
                  </span>
                  <v-icon>mdi-arrow-right-bold</v-icon>
                  <span class="text-h4 success--text">
                    {{item.tables.join('-')}}
                  </span>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>      
      </v-card>
    </v-dialog>        
    <v-dialog v-model="dialog_unconfirmed_booking"
      width="500"
    >
    <v-card class="neu-glow pb-1">
      <v-card-title class="text-h5 mb-2">
        Gestione modifica prenotazione
          <v-spacer></v-spacer>
          
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow mr-3" :loading="loading_edit" @click="checkIfCombinationExists()">
                <v-icon color="success">mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>Salva Modifiche</span>
          </v-tooltip>  
          
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_unconfirmed_booking_opened=false;dialog_unconfirmed_booking=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>         
      </v-card-title>
      <v-card-text>
        <v-card class="neu-glow pa-4">
          <p>
              Prima di modificare una prenotazione è consigliabile:
          </p>
          <p>
            Manuale: contattare telefonicamente il cliente chiedendo di poter spostare la prenotazione in altra fascia oraria
          </p>
          <p>
            Automatico (solo per prenotazioni non confermate o in lista d'attesa): con tasto <v-icon color="error">mdi-thumb-down</v-icon> in 'Lista d'Attesa', declinare la richiesta di prenotazione:
            <br>il cliente riceverà un messaggio WA con richiesta di selezionare un'altra fascia oraria
          </p>
        </v-card>
      </v-card-text>
    </v-card>
    </v-dialog>      
    <v-dialog v-model="dialog_confirmConfirm"
      width="500"
    >
    <v-card>
      <v-card-title class="text-h5 mb-2">
        Conferma Prenotazione
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow mr-3" :loading="loading" @click="confirmWABooking(1)">
                <v-icon color="success">mdi-thumb-up</v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>  
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_confirmConfirm=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>         
      </v-card-title>
      <v-card-text>
        <v-card class="neu-glow">
          <v-alert warning>IMPORTANTE: Verificare la disponibilità di Tavoli e di Combinazioni prima di Confermare</v-alert>
        </v-card>
      </v-card-text>
    </v-card>
    </v-dialog>     
    <v-dialog v-model="dialog_confirmDelete"
      width="460"
    >
      <v-card class="error">
        <v-card-title class="text-h5">
          Elimina Prenotazione
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow mr-3" :loading="loading" @click="deleteBooking()">
                  <v-icon color="error">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Elimina</span>
            </v-tooltip>  
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_confirmDelete=false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>         
        </v-card-title>
      </v-card>
    </v-dialog> 
    <v-dialog v-model="dialog_confirmSaveAuto"
      width="600"
    >
    <v-card>
      <v-card-title class="text-h5">
        Salvataggio Assegnazioni Auto
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow mr-6" :loading="loading" @click="simulateAssignment('save')">
                <v-icon color="error">mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip> 
          
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_confirmSaveAuto=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>         
      </v-card-title>
    </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_autoAssignEraseConfirmation"
      width="600"
    >
    <v-card class="neu-glow">
      <v-card-title class="text-h5">
        Elimina Assegnazione Tavoli
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow mr-6" :loading="loading_cancelling_auto" @click="simulateAssignment('erase')">
                <v-icon color="warning">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Elimina Assegnazioni Automatiche</span>
          </v-tooltip> 
          <!--
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow mr-6" :loading="loading_cancelling_all" @click="simulateAssignment('erase_full')">
                <v-icon color="error">mdi-delete-empty</v-icon>
              </v-btn>
            </template>
            <span>Elimina Tutte Assegnazioni</span>
          </v-tooltip> 
          -->           
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_autoAssignEraseConfirmation=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Esci senza Cancellare</span>
          </v-tooltip>         
      </v-card-title>
    </v-card>
    </v-dialog> 
    <v-dialog v-model="dialog_dateWide"
      width="800"
    >
      <v-card class="neu-glow pa-4">
        <v-card-title>
          Scegli la Data
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_dateWide=false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>  
        </v-card-title>
        <v-date-picker
          :picker-date.sync="pickerDate"
          class="wide_dp text-h5 neu-glow"
          header-color="info"
          v-if="events"
          locale="it"
          first-day-of-week=1
          v-model="date"
          full-width
          show-week
          :min="settings.level>=100?null:new Date().toISOString().slice(0, 10)"
          color="info"
          @input="dialog_dateWide = false"
          :events="events.map(e => e.date)"
          :event-color="settings.level>=100?events.map(e => e.covers):events.map(e => new Date(e.date).setHours(0,0,0,0) >= new Date().setHours(0,0,0,0)?e.covers:'')"
          style="min-height:580px"
        >       
        </v-date-picker>
      </v-card>
    </v-dialog>    

    <v-dialog fullscreen v-model="dialog_freeTable_all_Slots_Map" v-if="locations&&dialog_freeTable_all_Slots_Map">
      <v-card  ref="canvasOut4">
        <v-card-title class="text-h5 mb-2 font-weight-bold">
          Mappa Tavoli
          <v-spacer></v-spacer>  
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="showMapsDiv2=false;dialog_freeTable_all_Slots_Map=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>                     
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3 text-h6">
                        <v-btn-toggle
                                v-model="booking.tablesId"
                                multiple class="flex-wrap"
                                :style="'width:'+wWidth*.95+'px;height:'+wHeight-248+'px;position: relative'"
                                active-class="warning"
                        >
                            <v-btn
                                    v-for="(p,pi) in slotsDetails.find(k=>k.slotId==activeSlotId).tables.filter(z=>z.locationId==activeLocationId)"
                                    :key="pi"
                                    :value="p.tableId"
                                    :color="p.color"
                                    absolute
                                    :class="'table-shape-'+[p.shape]"
                                    style="border-radius: 10px"
                                    :style="{'pointer-events': p.covers?'none':'',width: (p.width*zoomLevel(p.hallId)*2)+'px','min-width': (p.width*zoomLevelFull(p.hallId))+'px',height: (p.height*zoomLevel(p.hallId)*2)+'px',left:(p.xPos*zoomLevel(p.hallId)*2)+'px',top:(p.yPos*zoomLevel(p.hallId)*2)+'px',transform:'rotate('+(p.angle*45)+'deg)'}"
                            >
                              <span class="black--text">
                                <div class="font-weight-bold text-h6 mt-n3 mb-2">{{p.tableName}}
                                  <v-icon
                                    v-if="p.reuse"
                                    color="black"
                                    class="mt-1"
                                  >
                                    mdi-rotate-360
                                  </v-icon>
                                </div>
                                <div class="text-mini font-weight-bold">{{p.lastName}}</div>
                                <div class="font-weight-bold text-micro">{{p.children>0? p.covers + '+' + p.children:p.covers}} - {{p.ETA}}</div>
                              </span>
                            </v-btn>
                        </v-btn-toggle>              
        </v-card-text>    
      </v-card>
    </v-dialog> 

    <v-dialog v-model="dialog_freeTable_all_Slots" class="old"
      max-width="1000"
      transition="dialog-bottom-transition"
      v-if="tables&&freeTables_all&&dialog_freeTable_all_Slots"
      >
      <v-card class="neu-glow">
        <v-card-title class="text-h5">
          <div class="float-left mr-5">Tavoli liberi a...</div>
          <v-spacer></v-spacer>
					<v-col class="d-inline text-center">
            <v-btn-toggle v-model="mealFilter" mandatory active-class="info white--text">
              <v-btn 
                v-for="(m,m2) in meals" :key="m2"
                v-bind="attrs" v-on="on"
                elevation="5"
                height="40"
                class="px-3 blue-grey darken-2"
                :value="m.mealId"    
              >
              {{m.name}}
              </v-btn>
            </v-btn-toggle>
					</v-col>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mb-2 mr-6" @click="bookWalkIn()">
                <v-icon color="info">mdi-book-account</v-icon>
              </v-btn>
            </template>
            <span>Prenota Walk-In</span>
          </v-tooltip>          
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mb-2" @click="dialog_freeTable_all_Slots=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
          </v-card-title>
          <v-card-text class="px-3">
            <v-row>
              <v-col class="mt-2">
                <v-btn-toggle v-model="activeSlot" mandatory :active-class="settings.options.color+' white--text'" class="d-flex flex-wrap justify-center background" >  
                  <!--<template v-for="(m,m1) in meals">
                    <div :key="m1" class="mb-2">-->
                      <v-btn 
                        class="px-3 blue-grey darken-2"
                        height="40"
                        :value="c.slotId"
                        v-for="(c,c1) in slots.filter(c=>c.mealId==mealFilter)" :key="c1"
                        :loading="loading"
                      >
                      {{c.name}}</v-btn>
                    <!--</div>
                  </template>-->
                </v-btn-toggle> 
              </v-col>
            </v-row>
          </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="pa-3">

          <v-card class="neu-glow">
            <v-btn-toggle v-model="walkInSelectedTables" multiple active-class="black--text" class="d-flex flex-wrap justify-center">
              <v-row class="ma-2" v-for="(h,hi) in halls" :key="hi">
                <template>
                  <v-col cols="12" class="pa-0">
                    <div class="blue-grey darken-3 pl-4 py-1 font-weight-black">{{h.name}}</div>
                  </v-col>

                  <template v-for="(t,ti) in tables.filter(t => t.hallId===h.hallId)">
                    <v-col class="pa-1" :key="ti">
                      <!--<v-btn-toggle v-model="freeTables_all.filter(f=>f.slotId===activeSlot).freeTablesId" multiple active-class="info" class="d-flex flex-row">-->
                        <v-btn
                          x-small
                          style="pointer-events: none"
                          block
                          :disabled="!t.tableName"
                          :value="t.tableId"
                          
                        >
                          {{t.tableName}}
                        </v-btn>
                      <!--</v-btn-toggle>-->
                    </v-col>
                    <v-responsive v-if="(ti+1)%parseInt(h.cols) === 0" :key="ti" width="100%"></v-responsive>
                  </template>                
                </template>
              </v-row>
            </v-btn-toggle>
          </v-card> 
        </v-card-text>
      </v-card>
    </v-dialog>    
    <v-dialog v-model="dialog_userDetails" 
      max-width="90%"
      transition="dialog-bottom-transition"
      v-if="userDetails"
      >
      <v-card class="d-flex neu-glow" style="flex-direction:column;">
        <v-card-title class="text-h5">
          Dettagli Cliente
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_userDetailsClose()">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>            
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
             <v-col cols="12" md="3" class="mt-6">
              <v-card class="neu-glow pb-4">
                <v-row class="py-0 px-3">
                  <v-col cols="12">
                    <v-card class="neu-glow">
                      <v-card-title>
                        Dettagli Cliente
                      </v-card-title>
                      
                      <v-card-text>
                        <div>
                          <v-row v-for="(value,name,di) in bookingDetails[0]" :key="di"> 
                            <v-col cols="6" class="pa-2">
                              <div class="blue-grey darken-3 pl-4 py-1 font-weight-black">{{name}}</div>
                            </v-col>
                            <v-col class="pa-2">
                              <div class="pl-4 py-1 font-weight-black text-right">{{userDetails[value]}}</div>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                      
                    </v-card>
                    <v-card class="neu-glow mt-3">
                      <v-card-title>
                        Riepilogo Prenotazioni
                      </v-card-title>
                      <v-card-text>
                        <div>
                          <v-row v-for="(value,name,di) in userDetails.summary" :key="di"> 
                            <v-col cols="6" class="pa-2">
                              <div class="blue-grey darken-3 pl-4 py-1 font-weight-black">{{name}}</div>
                            </v-col>
                            <v-col class="pa-2">
                              <div class="pl-4 py-1 font-weight-black text-right">{{value}}</div>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                    </v-card>
                    <v-card class="neu-glow mt-3">
                      <v-card-title>
                        Canali Prenotazione
                      </v-card-title>
                      <v-card-text>
                        <div>
                          <v-row v-for="(value,name,di) in userDetails.bookingChannels" :key="di"> 
                            <v-col cols="6" class="pa-2">
                              <div class="blue-grey darken-3 pl-4 py-1 font-weight-black">
                                <v-icon class="mr-2"  color="info">{{value.icon}}</v-icon>
                                  {{value.bookingChannel}}
                              </div>
                            </v-col>
                            <v-col class="pa-2">
                              <div class="pl-4 py-1 font-weight-black text-right">
                                {{value.cnt}}
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                    </v-card>                                        
                  </v-col>
                </v-row>
              </v-card>           
            </v-col>
            <v-col cols="12" md="9" class="mt-3">
              <v-card class="neu-glow py-4">
                <v-data-table
                  class="mx-4"
                  dense
                  fixed-header
                  :headers="userDetailsHeaders"
                  :items="userDetails.history"
                  hide-default-footer
                  :items-per-page=500
                  :height="wHeight-350"
                  :loading="loading"
                  no-data-text="Nessun dato presente in archivio"
                  no-results-text="Nessun Risultato estratto"
                  loading-text="Consultazione archivio: attendi..."                
                >
                <template v-slot:[`item.active`]="{ item }">
                  <v-checkbox
                    v-model="item.active"
                    readonly
                    hide-details
                    :color="settings.options.color"
                    class="mt-0 d-flex justify-center"
                  ></v-checkbox>
                </template>


                <template v-slot:[`item.rating`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" :color="item.ratingIconColor">{{item.ratingIcon}}</v-icon>
                    </template>
                    <span>{{item.ratingName}}</span>
                  </v-tooltip>                   
                </template>

                <template v-slot:[`item.location`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" :color="settings.options.color">{{item.locationIcon}}</v-icon>
                    </template>
                    <span>{{item.locationName}}</span>
                  </v-tooltip>                   
                </template>                

                <template v-slot:[`item.delayed`]="{ item }">
                  <div>{{item.delayed>0?item.delayed+' min.':''}}</div>
                </template>

                <template v-slot:[`item.noShow`]="{ item }">
                  <v-checkbox
                    v-model="item.noShow"
                    readonly
                    hide-details
                    color="error"
                    class="mt-0 d-flex justify-center"
                  ></v-checkbox>
                </template>

                <template v-slot:[`item.ghost`]="{ item }">
                  <v-checkbox
                    v-model="item.ghost"
                    readonly
                    hide-details
                    :color="settings.options.color"
                    class="mt-0 d-flex justify-center"
                  ></v-checkbox>
                </template>

                </v-data-table>
              </v-card>
            </v-col>            
          </v-row>
        </v-card-text>        
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_confirmWABooking" 
      max-width="90%"
      transition="dialog-bottom-transition"
      v-if="confirmBookingDetails"
      >
      <v-card class="d-flex" style="flex-direction:column;">
        <v-card-title class="text-h5">
          Dettagli Cliente/Prenotazione
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_confirmWABooking=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>            
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="3" class="mt-6">
              <v-card class="neu-glow elevation-8 pb-4">
                <v-row class="py-0 px-3">
                  <v-col cols="12">
                    <v-card class="neu-glow elevation-8">
                      <v-card-title>
                        Dettagli Cliente
                      </v-card-title>
                      <v-card-text>
                        <div>
                          <v-row v-for="(value,name,di) in confirmBookingDetails[0]" :key="di"> 
                            <v-col cols="6" class="pa-2">
                              <div class="blue-grey darken-3 pl-4 py-1 font-weight-black">{{name}}</div>
                            </v-col>
                            <v-col class="pa-2">
                              <div class="pl-4 py-1 font-weight-black text-right">{{confirmBookingDetails[value]}}</div>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                    </v-card>
                    <v-card class="neu-glow elevation-8 mt-3">
                      <v-card-title>
                        Riepilogo Prenotazioni
                      </v-card-title>
                      <v-card-text>
                        <div>
                          <v-row v-for="(value,name,di) in confirmBookingDetails.summary" :key="di"> 
                            <v-col cols="6" class="pa-2">
                              <div class="blue-grey darken-3 pl-4 py-1 font-weight-black">{{name}}</div>
                            </v-col>
                            <v-col class="pa-2">
                              <div class="pl-4 py-1 font-weight-black text-right">{{value}}</div>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                    </v-card>
                    <v-card class="neu-glow elevation-8 mt-3">
                      <v-card-title>
                        Canali Prenotazione
                      </v-card-title>
                      <v-card-text>
                        <div>
                          <v-row v-for="(value,name,di) in confirmBookingDetails.bookingChannels" :key="di"> 
                            <v-col cols="6" class="pa-2">
                              <div class="blue-grey darken-3 pl-4 py-1 font-weight-black">
                                <v-icon class="mr-2"  color="info">{{value.icon}}</v-icon>
                                  {{value.bookingChannel}}
                              </div>
                            </v-col>
                            <v-col class="pa-2">
                              <div class="pl-4 py-1 font-weight-black text-right">
                                {{value.cnt}}
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                    </v-card>                                        
                  </v-col>
                </v-row>
              </v-card>           
            </v-col>
            <v-col cols="12" md="9" class="mt-3">
              <v-card class="neu-glow elevation-8 pb-4 my-3">
                <v-row class="py-0 px-3">
                  <v-col cols="12" md="5">
                    <v-card class="neu-glow elevation-8">
                      <v-card-title>
                        Dettagli Prenotazione
                      </v-card-title>
                      <v-card-text>
                        <div>
                          <v-row v-for="(value,name,di) in bookingDetails[1]" :key="di"> 
                            <v-col cols="6" class="pa-2">
                              <div class="blue-grey darken-3 pl-4 py-1 font-weight-black">{{name}}</div>
                            </v-col>
                            <v-col class="pa-2">
                              <div class="pl-4 py-1 font-weight-black text-right">{{confirmBookingDetails[value]}}</div>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-card class="neu-glow elevation-8">
                      <v-card-title>
                        Dettagli Richiesta
                      </v-card-title>
                      <v-card-text>
                        <v-row v-for="(value,name,di) in bookingDetails[2]" :key="di">
                          <v-col cols="6" class="pa-2">
                            <div class="blue-grey darken-3 pl-4 py-1 font-weight-black">{{name}}</div>
                          </v-col>
                          <v-col class="pa-2">
                            <div class="pl-4 py-1 font-weight-black text-right">{{confirmBookingDetails[value]}}</div>
                          </v-col>
                        </v-row>                        
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-card class="neu-glow elevation-8">
                      <v-card-title class="justify-center">
                        Conferma                        
                      </v-card-title>
                      <v-card-text class="text-center">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_confirmConfirm=true">
                              <v-icon color="success">mdi-thumb-up</v-icon>
                            </v-btn>
                          </template>
                          <span>Conferma</span>
                        </v-tooltip> 
                      </v-card-text>
                    </v-card>
                    <v-card class="neu-glow elevation-8 mt-3">
                      <v-card-title class="justify-center">
                        Cancella                      
                      </v-card-title>
                      <v-card-text class="text-center">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="confirmWABooking(0)">
                              <v-icon color="error">mdi-thumb-down</v-icon>
                            </v-btn>
                          </template>
                          <span>Cancella</span>
                        </v-tooltip>   
                      </v-card-text>
                    </v-card>
                  </v-col>                                  
                </v-row>
              </v-card>
              <v-card class="neu-glow elevation-8 py-4">
                <v-data-table
                  class="mx-4"
                  dense
                  fixed-header
                  :headers="userDetailsHeaders"
                  :items="confirmBookingDetails.history.slice(0,10)"
                  hide-default-footer
                  :items-per-page=500
                  :height="wHeight-700"
                  :loading="loading"
                  no-data-text="Nessun dato presente in archivio"
                  no-results-text="Nessun Risultato estratto"
                  loading-text="Consultazione archivio: attendi..."                
                >
                <template v-slot:[`item.active`]="{ item }">
                  <v-checkbox
                    v-model="item.active"
                    readonly
                    hide-details
                    :color="settings.options.color"
                    class="mt-1"
                  ></v-checkbox>
                </template>

                <template v-slot:[`item.rating`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" :color="item.ratingIconColor">{{item.ratingIcon}}</v-icon>
                    </template>
                    <span>{{item.ratingName}}</span>
                  </v-tooltip>                   
                </template>

                <template v-slot:[`item.location`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" :color="settings.options.color">{{item.locationIcon}}</v-icon>
                    </template>
                    <span>{{item.locationName}}</span>
                  </v-tooltip>                   
                </template>                

                <template v-slot:[`item.delayed`]="{ item }">
                  <div>{{item.delayed>0?item.delayed+' min.':''}}</div>
                </template>

                <template v-slot:[`item.ghost`]="{ item }">
                  <v-checkbox
                    v-model="item.ghost"
                    readonly
                    hide-details
                    :color="settings.options.color"
                    class="mt-1"
                  ></v-checkbox>
                </template>

                </v-data-table>
              </v-card>
            </v-col>            
          </v-row>
        </v-card-text>        
      </v-card>
    </v-dialog>     
    <v-dialog v-model="dialog_reassign_changes" 
      max-width="1000"
      transition="dialog-top-transition"
      v-if="Boo"
      >
      <v-card class="neu-glow">
        <v-card-title class="text-h5">
          Variazioni:
          <v-spacer></v-spacer>        
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow" @click="dialog_reassign_changes=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>            
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="overflow:auto">
          <v-card class="neu-glow my-3 py-5 px-8">
            <v-simple-table
              fixed-header
              height="500px"
            >
              <template v-slot:default>
                <thead class="text-button">
                  <tr>
                    <th class="text-left">Cliente</th>
                    <th class="text-left">Orario</th>
                    <th class="text-left">Coperti</th>
                    <th class="text-left">Tavoli Attuali</th>
                    <th class="text-left">Tavoli Nuovi</th>                                                            
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(b,bi) in BOO" :key="bi"
                  >
                    <td>{{b.lastName}}</td>
                    <td>{{b.time}}</td>
                    <td>{{b.covers}}</td>
                    <td>{{Boo.find(bb=>bb.bookingId==b.bookingId)?Boo.find(bb=>bb.bookingId==b.bookingId).tables:''}}</td>
                    <td>{{b.tables}}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <!--                  
            <v-row class="text-button">
              <v-col>Cliente</v-col>
              <v-col>Orario</v-col>
              <v-col>Coperti</v-col>
              <v-col>Tavoli Attuali</v-col>
              <v-col>Tavoli Nuovi</v-col>
            </v-row>
            <v-row class="text-subtitle-1 success lighten-5" v-for="(b,bi) in BOO" :key="bi">
              <v-col>{{b.lastName}}</v-col>
              <v-col>{{b.time}}</v-col>
              <v-col>{{b.covers}}</v-col>
              <v-col>{{Boo.find(bb=>bb.bookingId==b.bookingId)?Boo.find(bb=>bb.bookingId==b.bookingId).tables:''}}</v-col>
              <v-col>{{b.tables}}</v-col>
            </v-row>
            -->
          </v-card>
        </v-card-text>      
      </v-card>
    </v-dialog>     
    <v-dialog v-model="dialog_autoAssign" 
      max-width="97%"
      transition="dialog-top-transition"
      >
      <v-card class="neu-glow">
        <v-card-title class="text-h5">
          Assegnazione Automatica Tavoli
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon class="neu-glow mr-9" :disabled="!assignedHalls" @click="dialog_assignedHalls=true">
                <v-icon color="info">mdi-view-comfy</v-icon>
              </v-btn>
            </template>
            <span>Visualizza Occupazione Sale</span>
          </v-tooltip>          
                     
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon class="neu-glow mr-9" :disabled="autoAssignLocked||!tablesAssigned" @click="tablesAssigned=[];tablesAssignedDetailed=[];unassignedReservations=[]">
                <v-icon color="info">mdi-eraser</v-icon>
              </v-btn>
            </template>
            <span>Pulisci</span>
          </v-tooltip> 
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon class="neu-glow mr-9" :disabled="autoAssignLocked||!tablesAssigned" :loading="loading_simulate" @click="simulateAssignment('test')">
                <v-icon color="info">mdi-creation</v-icon>
              </v-btn>
            </template>
            <span>Simula Assegnazioni Tavoli</span>
          </v-tooltip>            
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon class="neu-glow mr-9" :disabled="autoAssignLocked" :loading="loading_set" @click="eraseAssignment()">
                <v-icon color="error">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Cancella Assegnazioni Tavoli</span>
          </v-tooltip> 
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon class="neu-glow mr-9" :disabled="autoAssignLocked||(!tablesAssigned&&!tablesAssignedDetailed.length)" :loading="loading_set" @click="dialog_confirmSaveAuto=true">
                <v-icon color="success">mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>Salva Assegnazioni Tavoli</span>
          </v-tooltip> 
          <!--
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-6" @click="lockAutoAssignment()">
                <v-icon v-if="autoAssignLocked" color="error">mdi-lock</v-icon>
                <v-icon v-if="!autoAssignLocked" color="info">mdi-lock-open</v-icon>
              </v-btn>
            </template>
            <span>Blocca Assegnazione Tavoli</span>
          </v-tooltip>
          -->          
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab class="neu-glow mr-16"  @click="dialog_autoAssign_instruction =true">
                <v-icon color="info">mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span>Istruzioni Assegnazione Tavoli</span>
          </v-tooltip>          
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon class="neu-glow" @click="closeDialog_autoAssign()">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>            
        </v-card-title>
        <v-divider></v-divider>
        <div class="mb-0 pb-1">
          <v-card class="neu-glow ma-3 pb-3" v-if="unassignedReservations&&unassignedReservations.length">
            <v-card-title>
              <div class="text-h6">Prenotazioni non Assegnate</div>
              <v-spacer></v-spacer>         
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-4" to="/settings/?pageId=allcombinations">
                    <v-icon color="info">mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Verifica/Aggiungi Combinazioni</span>
              </v-tooltip> 
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow" @click="unassignedReservations=[]">
                    <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Chiudi</span>
              </v-tooltip>               
            </v-card-title>
            <v-row class="px-3">
              <v-col class="py-1" v-for="(e,ei) in unassignedReservations" :key="ei">
                <v-alert
                  dense
                  type="error"
                  class="my-0 pb-2"
                >
                  {{e.lastName + ': '+e.covers +' px '+ e.time + ' | ' + e.area}}
                </v-alert>
              </v-col>
            </v-row>
          </v-card>
          <v-card class="neu-glow px-2 pt-2 pb-7 ma-3" id="autoAssign" v-if="dialog_autoAssign">
            <v-row>
              <v-col cols="6"  class="mt-2" v-for="(h,hi) in halls" :key="hi">
                <div class="grey darken-3 pl-4 py-1 font-weight-black">{{h.name}}</div>
                <div v-if="currentTables">
                  <v-col class="mt-3 pb-1 pt-3 neu-glow-inset">
                    <div :style="'width:'+(wWidth*.95/2)+'px;height:'+(calcWHeight(300))+'px;position: relative'">
                      <v-btn-toggle
                        v-model="tablesAssigned"
                        multiple
                        class="flex-wrap"
                        active-class="info lighten-2"
                      >
                          <v-btn
                            v-for="(p,pi) in tables.filter(z=>z.hallId==h.hallId)"
                            :key="pi"
                            :value="p.tableId"
                            :color="p.color"
                            absolute
                            :class="freeTableClassAuto(p,item)"
                            :style="{width: (p.width*zoomLevelFull(h.hallId))+'px','min-width': (p.width*zoomLevelFull(p.hallId))+'px',height: (p.height*zoomLevelFull(h.hallId))+'px',left:(p.xPos*zoomLevelFull(h.hallId))+'px',top:(p.yPos*zoomLevelFull(h.hallId))+'px',transform:'rotate('+(p.angle*45)+'deg);pointer-events: none'}"
                          >
                            <span class="">
                              <div class="font-weight-bold mt-n1">{{p.tableName}}</div>
                              <div class="text-caption text-lowercase">{{tablesAssignedDetailed.find(ta=>ta.tableId==p.tableId)?tablesAssignedDetailed.find(ta=>ta.tableId==p.tableId).time:''}} - {{tablesAssignedDetailed.find(ta=>ta.tableId==p.tableId)?tablesAssignedDetailed.find(ta=>ta.tableId==p.tableId).covers:''}}</div>
                              <div class="text-caption text-lowercase">{{tablesAssignedDetailed.find(ta=>ta.tableId==p.tableId)?tablesAssignedDetailed.find(ta=>ta.tableId==p.tableId).lastName:''}}</div>                              
                            </span>
                          </v-btn>
                    
                      </v-btn-toggle>
                    </div>
                  </v-col>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </div>      
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_assignedHalls" fullscreen v-if="assignedHalls" transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar>           
            <v-toolbar-title class="text-h5 mr-3">Occupazione Sale <div class="float-right ml-5 mt-2 text-body-1">La Mappa visualizza anche le prenotazioni non assegnate, utilizzando l’assegnazione simulata dall’ AI</div></v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items class="pt-3">
                <!--
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <div>
                      <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" @click="dialog_instruction_verify=true">
                        <v-icon color="info">mdi-help-circle</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <span>Istruzioni</span>
                </v-tooltip>
                -->
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <div>
                      <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" @click="dialog_assignedHalls=false">
                        <v-icon color="info">mdi-close-circle</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <span>Chiudi</span>
                </v-tooltip>
              </v-toolbar-items>
          </v-toolbar>
          <v-container fluid>
            <v-row class="pa-0 ma-0">
              <v-col cols="6" v-for="(h,hi) in halls" :key="hi" class="pt-0">
                <v-card class="mx-0 pa-4 pt-0 neu-glow" >
                  <v-card-title>{{h.longName}}</v-card-title>
                  <v-row class="pa-0 ma-0">
                    <v-col cols="1" class="pa-0 ma-0">
                        <v-btn block tile x-small color="info">Table</v-btn>
                    </v-col>
                    <v-col cols="11" class="pa-0 ma-0">
                      <v-row
                        class="pa-0 ma-0"
                      >
                      <v-col class="pa-0 ma-0" v-for="(s,si) in assignedHallsSlots.filter(s=>s.mealId===mealId)" :key="si">
                        <v-btn block tile x-small class="justify-start px-0" color="warning darken-1">{{s.name}}</v-btn>
                      </v-col>   
                      </v-row>        
                    </v-col>
                  </v-row>      
                  <v-row class="pa-0 ma-0 pt-1" v-for="(t,ti) in assignedHalls.filter(t=>t.hallId===h.hallId)" :key="ti">
                    <v-col cols="1" class="ma-0 pa-0">
                        <v-btn block tile x-small :color="t.active?'info':'error'">{{t.tableName}}</v-btn>
                    </v-col>
                    <v-col cols="11" class="ma-0 pa-0">
                      <v-row
                        align="center"
                        class="pa-0 ma-0"
                      >
                        <template v-for="(b,bi) in t.bookings">
                          <v-btn 
                            :key="bi"
                            v-if="bi==0&&b.name=='disabled'"
                            depressed
                            class=""
                            x-small
                            tile
                            disabled
                            color="red lighten-4" 
                            style="width:100%"
                          >
                          </v-btn>
                          <v-btn 
                            :key="bi"
                            v-if="bi==0&&b.name=='reserved'"
                            depressed
                            class=""
                            x-small
                            tile
                            color="red darken-2" 
                            style="width:100%"
                          >
                            riservato
                          </v-btn>                        
                          <v-btn 
                            :key="bi"
                            v-if="bi==0&&b.starts>0"
                            depressed
                            class="background"
                            x-small
                            tile
                            :style="'width:'+b.starts+'%'"
                          >
                          </v-btn>
                          <v-btn 
                            :key="bi"
                            v-if="bi>0&&t.bookings[bi-1].ends<b.starts"
                            depressed
                            class="background"
                            x-small
                            tile
                            :style="'width:'+(b.starts-t.bookings[bi-1].ends)+'%'"
                          >
                          </v-btn>                  
                          <v-btn
                            v-if="b.name!='disabled'"
                            :key="bi" 
                            :depressed="!b.name"
                            :outlined="!b.name"
                            class=""
                            x-small
                            tile
                            :color="!b.name?'':(b.name=='New Reservation'?'error':'blue-grey darken-3')" 
                            :style="'width:'+b.size+'%'"
                          >
                            {{b.name}} - {{b.children>0?b.covers-b.children + '+' + b.children :b.covers}}
                          </v-btn>
                        </template>
                      </v-row>        
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-if="unassigned&&unassigned.length>0">
              <v-card-title>
                Attenzione!! Le seguenti prenotazioni non sono assegnate:
              </v-card-title>
              <v-col class="py-1" v-for="(e,ei) in unassigned" :key="ei">
                <v-alert
                  dense
                  type="error"
                  class="my-0 pb-2"
                >
                  {{e.lastName + ': '+e.covers +' px '+ e.time + ' | ' + e.area}}
                </v-alert>
              </v-col>
            </v-row>               
          </v-container>
        </v-card>
    </v-dialog>    
    <v-dialog v-model="dialog_reserveTable" 
      max-width="1000"
      transition="dialog-top-transition"
      persistent
      >
      <v-card>
        <v-card-title class="text-h5">
          Tavoli Riservati
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" :loading="loading" @click="dialog_reservedTableHelp=true">
                <v-icon color="info">mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span>Istruzioni</span>
          </v-tooltip>           
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow" @click="closeDialog_reserveTable()">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>            
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="overflow:auto">
          <v-card class="elevation-8 my-3 pt-1 pb-6">
            <v-row class="ma-2 info lighten-3" v-for="(h,hi) in halls" :key="hi">
              <template>
                <v-col cols="12" class="pa-0">
                  <div class="grey lighten-1 pl-4 py-1 font-weight-black">{{h.name}}</div>
                </v-col>
                <template v-for="(t,ti) in tables.filter(t => t.hallId===h.hallId)">
                  <v-col class="pa-1" :key="ti">
                    <v-btn-toggle v-model="reservedTables" multiple active-class="error white--text" class="d-flex flex-row">
                      <v-btn
                        small
                        block
                        :style="!t.show?'pointer-events: none':''"
                        :color="!t.show&&t.tableName?'warning':''"
                        class="text-body-1 font-weight-bold px-0"                          
                        :value="t.tableId"
                        @click="reserveTableSave(t)"
                      >
                        {{t.tableName}}
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                  <v-responsive v-if="(ti+1)%parseInt(h.cols) === 0" :key="ti" width="100%"></v-responsive>
                </template>
              </template>
            </v-row>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_createCombination" 
      max-width="97%"
      transition="dialog-top-transition"
      persistent
      class="overflow-visible"
      v-if="selectedBooking&&selectedBooking.locationId"
      >
      <v-card class="neu-glow">
        <v-card-title class="text-h5">
          Crea combinazione per {{oldCovers[0]+oldChildren[0]}} Coperti
          <v-spacer></v-spacer>
          <v-alert type="warning">Attenzione Non stai assegnando i tavoli a questa prenotazione ma stai solo creando una combinazione.</v-alert>
          <v-spacer></v-spacer>
          <!--
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" :loading="loading" @click="dialog_disableTableHelp=1">
                <v-icon color="info">mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span>Istruzioni</span>
          </v-tooltip>  
          -->
          <!--
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-9" :loading="loading" @click="saveNewCombination(0)">
                <v-icon color="warning">mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>Salva come Temporanea</span>
          </v-tooltip>
          --> 
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-9" :loading="loading" @click="saveNewCombination(1)">
                <v-icon color="info">mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>                               
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow" @click="dialog_createCombination=0">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>            
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row v-if="halls">
            <v-col cols="6"  class="mt-2" v-for="(h,hi) in halls.filter(h=>h.locationId==selectedBooking.locationId)" :key="hi" id="disableTables">
              <div class="grey darken-3 pl-4 py-1 font-weight-black">{{h.name}}</div>
              <div v-if="currentTables">
                <v-col class="mt-3 pb-1 pt-3 neu-glow-inset">
                  <div :style="'width:'+(wWidth*.95/2)+'px;height:'+(calcWHeight(300))+'px;position: relative'">
                    <v-btn-toggle
                      v-model="assignedTablesId"
                      multiple
                      class="flex-wrap"
                      active-class="info white--text"
                    >
                        <v-btn
                          v-for="(p,pi) in currentTables.filter(z=>z.hallId==h.hallId)"
                          :key="pi"
                          color="light-green"
                          :value="p.tableId"
                          absolute
                          :class="'table-shape-'+[p.shape]"
                          :style="{width: (p.width*zoomLevelFull(h.hallId))+'px','min-width': (p.width*zoomLevelFull(p.hallId))+'px',height: (p.height*zoomLevelFull(h.hallId))+'px',left:(p.xPos*zoomLevelFull(h.hallId))+'px',top:(p.yPos*zoomLevelFull(h.hallId))+'px',transform:'rotate('+(p.angle*45)+'deg);pointer-events: none'}"
                        >
                          <span class="white--text">
                            <div class="font-weight-bold mt-n1 mb-1">{{p.tableName}}</div>
                            <div class="text-caption">{{tablesAssignedDetailed.find(ta=>ta.tableId==p.tableId)?tablesAssignedDetailed.find(ta=>ta.tableId==p.tableId).lastName:''}}</div>
                          </span>
                        </v-btn>
                  
                    </v-btn-toggle>
                  </div>
                </v-col>
              </div>
            </v-col>
          </v-row>                  
        </v-card-text>

      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_disableTable" 
      max-width="97%"
      transition="dialog-top-transition"
      persistent
      class="overflow-visible"
      v-if="locations"
      >
      <v-card class="neu-glow">
        <v-card-title class="text-h5">
          Disabilita Tavoli (solo per il {{new Date(date).toLocaleDateString('it-IT', { year: '2-digit', month: '2-digit', day: 'numeric' })}})
          <v-spacer></v-spacer>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" :loading="loading" @click="dialog_disableTableHelp=1">
                <v-icon color="info">mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span>Istruzioni</span>
          </v-tooltip>           
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow" @click="closeDialog_disableTable()">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>            
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row v-if="halls">
            <v-col cols="6"  class="mt-2" v-for="(h,hi) in halls" :key="hi" id="disableTables">
              <div class="grey darken-3 pl-4 py-1 font-weight-black">{{h.name}}</div>
              <div v-if="currentTables">
                <v-col class="mt-3 pb-1 pt-3 neu-glow-inset">
                  <div :style="'width:'+(wWidth*.95/2)+'px;height:'+(calcWHeight(300))+'px;position: relative'">
                    <v-btn-toggle
                      v-model="disabledTables"
                      multiple
                      class="flex-wrap"
                      active-class="error white--text"
                    >
  
                        <v-btn
                          v-for="(p,pi) in currentTables.filter(z=>z.hallId==h.hallId)"
                          :key="pi"
                          :value="p.tableId"
                          :color="p.color"
                          absolute
                          @click="disableTableSave(p)"
                          :class="'table-shape-'+[p.shape]"
                          :style="{width: (p.width*zoomLevelFull(h.hallId))+'px','min-width': (p.width*zoomLevelFull(p.hallId))+'px',height: (p.height*zoomLevelFull(h.hallId))+'px',left:(p.xPos*zoomLevelFull(h.hallId))+'px',top:(p.yPos*zoomLevelFull(h.hallId))+'px',transform:'rotate('+(p.angle*45)+'deg);pointer-events: none'}"
                        >
                          <span class="white--text">
                            <div class="font-weight-bold mt-n1 mb-1">{{p.tableName}}</div>
                            <div class="text-caption">{{tablesAssignedDetailed.find(ta=>ta.tableId==p.tableId)?tablesAssignedDetailed.find(ta=>ta.tableId==p.tableId).lastName:''}}</div>
                          </span>
                        </v-btn>
                  
                    </v-btn-toggle>
                  </div>
                </v-col>
              </div>
            </v-col>
          </v-row>                  
        </v-card-text>

      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_enterBillAmount" 
      max-width="520"
      transition="dialog-bottom-transition"
      v-if="item"
      >
      <v-card class="d-flex" style="flex-direction:column;">
        <v-card-title class="text-h5">
          Importo Scontrino
          <v-spacer></v-spacer>
            <v-tooltip top >
              <template v-slot:activator="{ on, attrs }">
                <div>
                  <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" :loading="loading" @click="changeStatus(item,'ghost',0)">
                    <v-icon color="teal">mdi-ghost</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>No Show</span>
            </v-tooltip>           
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow mr-3" :loading="loading" :disabled="!item.billAmount" @click="changeStatus(item,'gone',0)">
                <v-icon color="error">mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>  
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_enterBillAmount=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>           
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="">
          <v-row>
            <v-col cols="12">
              <v-card class="neu-glow mt-3">
                <v-card-title>
                  Importo Scontrino Cliente                    
                </v-card-title>
                <v-card-text>
                  <v-text-field
                    label="Importo Scontrino"
                    v-model="item.billAmount"
                    name="billAmount"
                    append-icon="mdi-currency-eur"
                    outlined
                    reverse
                    type="number"
                    hide-details
                    class="px-4 pt-4"
                  ></v-text-field>
                </v-card-text>
              </v-card>              
              <v-card class="neu-glow mt-3">
                <v-card-title>
                  Valutazione Cliente
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon fab x-small class="neu-glow mr-2 float-right" @click="dialog_userRatingHelp=true">
                          <v-icon color="info">mdi-help-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Istruzioni</span>
                    </v-tooltip>                      
                </v-card-title>
                <v-card-text class="d-flex justify-center">
                  <v-btn-toggle
                    v-model="item.rating" 
                    active-class="info white--text"
                    class="d-flex flex-wrap transparent-bg"
                  >
                    <v-col class="px-5">
                      <v-tooltip top v-for="(l,li) in userRatings" :key="li">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn :value="l.ratingLevel" v-bind="attrs" v-on="on" icon fab dense small elevation="8" class="neu-glow mr-2">
                            <v-icon :color="l.color">{{l.icon}}</v-icon>
                          </v-btn>                              
                        </template>
                        <span v-html="l.name"></span>
                      </v-tooltip>
                    </v-col>
                  </v-btn-toggle>
                </v-card-text>
              </v-card>              
            </v-col>
            <!-- 
            <v-col cols="6">
              <v-card class="neu-glow mt-3">
                <v-card-title>
                  Preferenze
                </v-card-title>
                <v-card-text>
                  <v-checkbox
                    :color="settings.options.color||'info'"
                    class="mt-0"
                    v-for="(l,i) in trackedItems" :key="i"
                    v-model="item.trackedItems[i].value"
                    :label="l.name"
                    >
                  </v-checkbox>
                </v-card-text>
              </v-card>  
            </v-col>
            -->
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_allocationRules" 
      max-width="600"
    >
      <v-card class="neu-glow pa-4">
        <v-card-title class="text-h5 mb-2 font-weight-bold">
          Significato Colore Pulsanti
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_allocationRules=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>           
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3 text-h6">
          <v-card class="neu-glow pa-3">
            <v-card-text>
              <p>I pulsanti <v-btn classs="py-1" x-small color="error darken-2">&nbsp;</v-btn> indicano che non ci sono tavoli liberi ed è solamente possibile inserire in lista d'attesa, ove gestita</p>
              <p>I pulsanti <v-btn classs="py-1" x-small color="warning darken-2">&nbsp;</v-btn> indicano che vi sono tavoli liberi ma l'App non ha trovato una combinazione adeguata: dovete selezionare manualmente i tavoli da assegnare</p>
              <!-- fix 250601 yelloow Slots-->
              <!--<p>I pulsanti <v-btn classs="py-1" x-small color="warning lighten-3">&nbsp;</v-btn> indicano che l'App ha trovato una combinazione adeguata e che dovete obbligatoriamente assegnare i tavoli</p>-->
              <p>I pulsanti <v-btn classs="py-1" x-small color="blue-grey darken-2">&nbsp;</v-btn> indicano che l'App ha trovato una combinazione di tavoli adeguata ma non è necessario assegnare i tavoli in questo momento</p>              
            </v-card-text>
          </v-card>
        </v-card-text>    
      </v-card>
    </v-dialog>    
    <v-dialog class="neu-glow mx-2" v-model="dialog_waitingListTime"
      width="420"
      v-if="settings.options.manageWaitingList==='1'"
    >
      <v-card class="neu-glow">
        <v-card-title class="text-h6 font-weight-bold">
          {{$t(page+'.Waiting List Parameters')}}
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow" @click="dialog_waitingListTime=false">
                <v-icon color="info">mdi-check</v-icon>
              </v-btn>
            </template>
            <span>OK</span>
          </v-tooltip>           
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-subtitle-1 pt-2">
          <div>
            {{$t(page+'.How long do you want to be in waiting List')}}? 
            <!--<div class="text-center">{{new Date(booking.date).toLocaleDateString(settings.locale,{ weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric' })}}</div>-->
          </div>
          <div>
            <v-slider
              class="mt-12"
              max=48
              min=1
              step=1
              thumb-label="always"
              ticks="always"
              :label="$t(page+'.Up to')"
              v-model="booking.waitingListTime"
            >        
            </v-slider>            
          </div>
          <div>
          {{$t(page+'.Hours before the event')}}
          </div>     
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_walkInHelp" 
      max-width="800"
    >
      <v-card class="neu-glow">
        <v-card-title class="text-h5 mb-2 font-weight-bold">
          Istruzioni
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_walkInHelp= false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>          
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text :class="helpType==5||helpType==7?'mt-3 text-subtitle-1':'mt-3 text-h6'">
          <v-card class="neu-glow pa-3">
            <div v-if="helpType==1">
              <p>Selezionare il giorno in cui si vuole prenotare:</p>
              <p>Come potete vedere la finestra 'Coperti' viene abilitata solo dopo che il giorno è stato selezionato</p>
              <p><br>NB: Nella maschera di prenotazione Walk-In il giorno/i di chiusura anche se impostati, non sono disabilitati, questo per non limitare l'operatività.</p>
            </div>
            <div v-else-if="helpType==2">
              <p>
                Selezionare il numero di ospiti (coperti) digitando sul tastierino virtuale.
                <br>Per indicare 7 adulti e 2 bambini (che necessitano di seggiolino) digitare 7+2
                <br>In caso di errore, cancellare premendo il tasto 'C'.
              </p>
            </div>
            <div v-else-if="helpType==3">
              <p>
                Selezionare la posizione, solitamente Interno/Esterno, ma se avete creato ulteriori zone appariranno in questa sezione.
                <br>
                NB: La scelta della sala ove ne fosse disponibile più d'una nella stessa posizione, non è facoltà del cliente: l'attribuirete voi a seconda delle vostre necessità.
              </p>
            </div>
            <div v-else-if="helpType==4">
              <p>
                Selezionare se visualizzare gli orari relativi al Pranzo, alla Cena o altri pasti che avrete definito precedentemente.
                <br>Nella sezione Orario appariranno tutti gli slot attivati.
                <br>I numeri che appaiono sotto l'orario indicano rispettivamente il numero di Coperti Liberi/Coperti Totali.
                <br>Selezionando uno slot, appaiono sotto i pulsanti in 'posizione' degli ulteriori numeri: questi indicano il numero di Tavoli Liberi/Tavoli Totali per la posizione prescelta.
                <br>A cosa serve? In funzione della composizione delle prenotazioni a parità di numero di coperti, il numero dei tavoli può variare anche sensibilmente:
                è pertanto importante conoscere esattamente sia la disponibilità di Coperti che di Tavoli in tempo reale.
                <br><br>
                <br>Un numero negativo (in rosso) indica che sono state accettati coperti e/o tavoli in eccesso rispetto a quanto impostato, ma il sistema consente comunque all'operatore di accettare la prenotazione se lo ritiene
                <br><br>NB: chiaramente nel modulo di prenotazione diretta il cliente non può eccedere rispetto alle impostazioni.
              </p>
            </div>
            <div v-else-if="helpType==5">
              <p>
                Inserire Nome e Cognome possibilmente, selezionare ove necessario il prefisso internazionale ed inserire il numero di telefono ed eventuali Note.
                <br>L'anagrafica del cliente è importante anche in caso di Walk-In in quanto eventuali comunicazioni/campagne/richiesta recensioni avverranno tramite WhatsApp.
                <br><br>
                <br><br>NB: le prenotazioni generate con il Walk-In non generano un messaggio WhatsApp di conferma prenotazione.
              </p>
            </div>
            <div v-else-if="helpType==6">
              <p>
                Inserire Nome e Cognome possibilmente, selezionare ove necessario il prefisso internazionale ed inserire il numero di telefono ed eventuali Note.
                <br>L'anagrafica del cliente è importante anche in caso di Walk-In in quanto eventuali comunicazioni/campagne/richiesta recensioni avverranno tramite WhatsApp.
                <br><br>
                <br><br>NB: le prenotazioni generate con il Walk-In non generano un messaggio WhatsApp di conferma prenotazione.
              </p>
            </div>
            <div v-else-if="helpType==7">
              <v-row>
                <v-col cols="4">
                  WA 
                </v-col>
                <v-col>
                  Messaggio Inviato da Segreteria Virtuale selezionando il tasto 1+1
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  Promemoria
                </v-col>
                <v-col>
                  Messaggi Inviato in automatico per il promemoria della prenotazione (impostazioni > iWhastsAppManager > impostazioni invii automatizzati).
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  Recensione
                </v-col>
                <v-col>
                  Messaggio inviato in automatico per il rilascio recensioni (impostazioni > iWhastsAppManager > impostazioni invii automatizzati)   
                </v-col>
              </v-row>                            
            </div>   
            <div v-else>
              <p>
                Per ultimo due note relativamente alle Opzioni/Richieste:
                <br>
                Nel caso di Walk-in queste informazioni non sono particolarmente utili, essendo il cliente già nel locale, ma sono state riportate per completezza e comunque se selezionate possono essere utilizzate per campagne pubblicitarie ad Hoc
              </p>
            </div>
          </v-card>
        </v-card-text>     
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_reservedTableHelp" 
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5 mb-2 font-weight-bold">
          Disabilita Tavoli
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_reservedTableHelp=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>           
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3 text-h6">
          <div>
              I tavoli non attivi (in Impostazioni) appaiono in arancione e non sono attivabili
          </div>
          <div>
            I tavoli in Rosso sono quelli riservati, ovvero che non vengono considerati dall'Online Booking mentre sono considerati nella prenotazione da parte dell'Operatore (Volante).
          </div>
        </v-card-text>    
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_helpGlobal"
      width="1200"
      class="neu-glow"
      v-if="dialog_helpGlobal"
    >
      <v-card class="px-3 pb-3 neu-glow">
        <v-card-title class="text-h5 mb-2 font-weight-bold neu-glow px-7">
          <v-toolbar flat>
            <v-toolbar-title>Legenda Generale</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow"  @click="dialog_helpGlobal = false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          Ogni pulsante ha una sua descrizione: basta passarci sopra con il mouse ed appare. 
          <br>Nei tablet/cellulari questa funzione è ottenuta tenendo il dito sul pulsante per circa mezzo secondo.
          <br>Si consiglia di utilizzarla nonostante il non semplice uso, in quanto oltre alla descrizione, spesso appaiono ulteriori informazioni
        </v-card-text>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12" md="12">
            <v-card class="text-subtitle-1 px-5 pb-5 neu-glow" :class="pi>0?'mt-4':''" v-for="(p,pi) in pages()" :key="pi">
              <v-card-title>
                {{p}}
              </v-card-title>
              <v-card class="neu-glow mb-3 pb-5" :class="ai>0?'mt-7':''" v-for="(a,ai) in areas(p)" :key="ai">
                <v-card-title>
                  {{a}}
                </v-card-title>
                <v-card class="neu-glow ma-3"> 
                  <v-row class="px-3 justify-center"  style="flex-wrap: nowrap;" v-for="(c,ci) in captions.filter(c=>c.page==p&&c.area==a)" :key="ci">
                    <v-col class="" style="max-width: 60px">
                      <v-icon :color="c.color">{{c.icon}}</v-icon>                    
                    </v-col> 
                    <v-col cols="2" style="min-width: 200px;" class="flex-grow-0 flex-shrink-1">
                      {{c.name}}
                    </v-col>
                    <v-col style="min-width: 100px; max-width: 100%;" class="flex-grow-1 flex-shrink-0">
                      {{c.remarks}}
                    </v-col>
                  </v-row>
                </v-card>
              </v-card>
            </v-card>
          </v-col>
        </v-row>       
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_autoAssign_instruction" max-width="900">
    <v-card class="neu-glow">
      <v-card-title class="text-h5">
        Istruzioni
        <v-spacer></v-spacer>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_autoAssign_instruction = false">
                <v-icon color="info">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Esci</span>
        </v-tooltip>             
      </v-card-title>
      <v-divider></v-divider>
      <v-card class="neu-glow ma-5">
        <v-row class="mx-3 mt-2 mb-0">
          <v-col md="12" cols="12">
            <p>
              Dopo aver premuto <v-icon color="info">mdi-creation</v-icon>, qualora vi siano delle prenotazioni non assegnate queste vengono evidenziate in alto:
              <br>E' consigliabile fare in modo che nella simulazione, TUTTE le prenotazioni risultino assegnabili prima di procedere all'assegnazione effettiva:
              <br>Si può agire in 3 modi:
              <ul>
                <li>
                  Se vi sono tavoli liberi, verificare se si possono aggiungere delle combinazioni
                </li>
                <li>
                  Se non vi sono tavoli liberi, spostare manualmente alcune prenotazioni da interno ad esterno o viceversa.
                </li>
                <li>
                  Come estrema razio si devono cancellare alcune prenotazioni. (1)
                </li>
              </ul>
              <strong>E' possibile comunque assegnare i tavoli anche in presenza di prenotazione non assegnate.</strong> 
            </p>
            <p class="text-h6">
              Legenda
            </p>
            <ul>
              <li>
                I tavoli <v-btn classs="py-1" x-small color="error">&nbsp;</v-btn> sono quelli disabilitati a livello generale
              </li>
              <li>
                I tavoli <v-btn classs="py-1" x-small color="warning">&nbsp;</v-btn> sono quelli già assegnati manualmente o disabilitati giornalmente
              </li>
              <li>
                I tavoli <v-btn classs="py-1" x-small color="info">&nbsp;</v-btn> sono quelli assegnati automaticamente dalla simulazione.
              </li>
              <li>
                I tavoli <v-btn classs="py-1" x-small color="blue-grey">&nbsp;</v-btn> sono quelli liberi.
              </li>            
            </ul>                                                            
          </v-col>
          <v-col md="12" cols="12">
            <p>
              il pulsante <v-icon color="info">mdi-eraser</v-icon> cancella a video la simulazione ma non modifica alcun dato.
            </p>
            <p>
              il pulsante <v-icon color="info">mdi-creation</v-icon> simula l'assegnazione tavoli ma non salva alcun dato.
            </p>  
            <p>
              il pulsante <v-icon color="success">mdi-content-save</v-icon> assegna effettivamente i tavoli alle prenotazioni e salva i dati
            </p>
            <p>
              il pulsante <v-icon color="error">mdi-delete</v-icon> cancella tutte le assegnazioni del pasto selezionato (Pranzo o Cena) ma solo dopo ulteriore conferma.
            </p>
            <p class="mb-0">
              il pulsante <v-icon color="error">mdi-lock</v-icon>/<v-icon color="info">mdi-lock-open</v-icon> consente di disabilitare (o riabilitare) i pulsanti 
              <v-icon color="error">mdi-content-save</v-icon>, <v-icon color="warning">mdi-delete</v-icon> 
              in modo da evitare di riassegnare accidentalmente i tavoli nuovamente una volta decisa la configurazione della Sala.
            </p>  
          </v-col>
          <!--
          <v-col cols="12">
            <p color="error">
              <strong>(1)</strong> Questo può accadere solo nel caso vi siano delle prenotazioni inserite dall'operatore, in quanto l'operatore non deve sottostare a tutti i vincoli che ha la prenotazione diretta da parte del cliente. 
            </p>
          </v-col>
          -->
        </v-row>
      </v-card>
    </v-card>
    </v-dialog>          
    <v-dialog v-model="dialog_disableTableHelp" 
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5 mb-2 font-weight-bold">
          Disabilita Tavoli
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_disableTableHelp=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>           
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3 text-h6">
          <div>
              I tavoli non attivi (in Impostazioni) appaiono in arancione e non sono attivabili
          </div>
          <div>
            I tavoli in Rosso sono quelli non attivi per la data indicata: negli altri giorni si riattivano automaticamente.
          </div>
        </v-card-text>    
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_userRatingHelp" 
      max-width="600"
      v-if="userRatings"
    >
      <v-card>
        <v-card-title class="text-h5 mb-2 font-weight-bold">
          Significato Valutazioni
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_userRatingHelp=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>           
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3 text-h6">
          <div>
            <ul>
              <li class="text-subtitle-2" v-for="(r,ri) in userRatings" :key="ri"><span class="text-subtitle-1 info--text">{{r.name+': '}}</span>{{r.rule}} </li>
            </ul>
          </div>
        </v-card-text> 
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_coupon" max-width="1200" class="pb-3" v-if="selectedBooking&&prizes">
      <v-card class="neu-glow">
          <v-card-title class="text-h5 mb-1">
            Invia Coupon a {{selectedBooking.lastName + ' ' + selectedBooking.firstName}}
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div>
                  <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-4" :loading="loading_sendCoupon" @click="sendCoupon('send')">
                    <v-icon color="success">mdi-whatsapp</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>Invia</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div>
                  <v-btn to="/settings/?pageId=coupons" v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-4">
                    <v-icon color="warning">mdi-creation</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>Crea Nuovo Coupon</span>
            </v-tooltip>                        
            <v-tooltip top >
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="dialog_coupon=false" fab small class="neu-glow mr-4" v-bind="attrs" v-on="on">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-card-title>
          <v-divider></v-divider>
          <v-row class="mx-2 mb-0 pb-3">
            <v-col cols="9">
              <v-card-text>
                <div class="mb-2">Scegli Coupon</div>
                <v-data-table
                  v-model="selectedCoupon"
                  class="neu-glow"
                  item-key="prizeId"
                  fixed-header
                  show-select
                  single-select="true"
                  :headers="headersCoupons"
                  :items="prizes||[]"
                  hide-default-footer
                  :items-per-page=500
                  :loading="loading||loading_refresh"
                  no-data-text="Nessun dato presente in archivio"
                  no-results-text="Nessun Risultato estratto"
                  loading-text="Consultazione archivio: attendi..."
                >

                  <template v-slot:[`item.validDoW`]="{ item }">
                    <div>
                      <!--
                      <v-btn-toggle v-model="item.validDoW" multiple small active-class="info" class="d-inline-block transparent">
                        <v-btn
                          style="pointer-events: none"
                          x-small
                          v-for="(d,di) in dows" :key="di" :value="d.code">
                          {{d['it'].substring(0,2).toUpperCase()}}
                        </v-btn>
                      </v-btn-toggle> 
                    -->
                    <span v-for="(d,di) in dows.filter(d => item.validDoW.includes(d.code))" :key="di">
                      {{d['it'].substring(0,2).toUpperCase()}}
                    </span>  
                                       
                    </div>
                  </template>

                  <template v-slot:[`item.highRewardRange`]="{ item }">
                    <div>{{item.highRewardRange.join('-')}}</div>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    
                    <!--
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon @click="showItem(item)">
                          <v-icon
                            v-bind="attrs" 
                            v-on="on"
                            color="info"
                            class="mr-2"
                          >
                            mdi-check-circle
                          </v-icon> 
                        </v-btn>               
                      </template>
                      <span>Visualizza</span>
                    </v-tooltip>
                    -->

                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">

                        <v-simple-checkbox
                          v-bind="attrs" 
                          v-on="on"
                          v-model="item.selected"
                          @click="showItem(item)"
                        >
                        </v-simple-checkbox>
                      </template>
                      <span></span>
                    </v-tooltip>                    

                  </template>

                </v-data-table>
              </v-card-text>                

              <v-row v-if="selectedCoupon" class="mt-2 mx-2">                                           
                <v-col cols="12" md="4">
                  <v-img v-if="selectedCoupon[0].highRewardImage" 
                    :src="'/static/users/pictures/coupons/'+selectedCoupon[0].highRewardImage||'/static/users/pictures/coupons/default.png'"
                    :lazy-src="'/static/users/pictures/coupons/'+selectedCoupon[0].highRewardImage||'/static/users/pictures/coupons/default.png'"
                    max-width="200"
                    class="mx-auto"
                  ></v-img>              
                </v-col>
                <v-col cols="12" md="8">
                  <v-textarea
                    class="mt-4"            
                    counter
                    rows="3"
                    auto-grow
                    label="Messaggio Coupon"
                    outlined
                    v-model="highRewardDescription"
                  >
                  </v-textarea>
                </v-col>
                <!--
                <v-col cols="12" md="4">                  
                  <v-switch
                    color="success"
                    dense
                    v-model="addTripAdvisorButton"
                    inset
                    label="Includi link TripAdvisor"
                    name="addTripAdvisorButton"
                    hide-details
                    prepend-icon="fab fa-tripadvisor"
                    class="mt-3 pt-0 text-center"
                  ></v-switch>                                            
                </v-col> 
                <v-col cols="12" md="4">                  
                  <v-switch
                    color="success"
                    dense
                    v-model="addGoogleReviewButton"
                    inset
                    label="Includi link Google Review"
                    name="addGoogleReviewButton"
                    hide-details
                    prepend-icon="fab fa-google"
                    class="mt-3 pt-0 text-center"
                  ></v-switch>                                            
                </v-col>    
                -->             
                                                                                                                                      
              </v-row>
            </v-col>
            <v-col cols="3" v-if="selectedBooking">
              <div class="my-3">Messaggio Whatsapp:</div>
              <v-card class="pa-4  neu-glow">
                <v-row class="">   
                  <v-col cols="12" md="12">
                    <v-img 
                      :src="'/static/users/pictures/wa/'+settings.options.logoWA"
                      :lazy-src="'/static/users/pictures/wa/'+settings.options.logoWA"
                      max-width="250"
                      class="mx-auto"
                    ></v-img>              
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-card class="pa-4 neu-glow">
                      <div>
                        <p>
                          {{$t('Review.Dear') + ' ' +  (selectedBooking.firstName?selectedBooking.firstName: selectedBooking.lastName) }},
                        </p>
                        <p v-html="shownMessage">
                        </p>
                        <p>
                          Lo Staff
                          <br>{{settings.options.brand}}
                        </p>
                      </div>
                      <div>
                        <v-btn
                          outlined
                          block
                          color="info"
                        >
                          Visualizza Coupon
                        </v-btn>
                      </div>
                      <div v-if="addTripAdvisorButton">
                        <v-btn
                          outlined
                          block
                          color="info"
                          class="mt-2"
                        >
                          TripAdvisor
                        </v-btn>
                      </div>                      
                    </v-card> 
                  </v-col>  
                </v-row>
              </v-card>
            </v-col>
          </v-row>
      </v-card>
    </v-dialog>    
    <v-dialog v-model="dialog_connectionError"
      width="700"
    >
      <v-card class="">
        <v-card-title class="text-h5 mb-1 font-weight-bold error--text">
          {{errorTitle?'Errore Server':'Errore Connessione'}}
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :href="'https://wa.me/'+settings.options.phoneTechnician">
                <v-icon color="success">mdi-whatsapp</v-icon>
              </v-btn>
            </template>
            <span>Contatta Assistenza</span>
          </v-tooltip> 
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_connectionError = false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>                
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4">
          <div v-if="errorMessage===null" class="text-h6">Connessione assente o server sovraccarico:
            <br />
            Riprova tra qualche secondo.
          </div>
          <template v-else>
            <div  class="text-h5 mb-3" v-html="errorTitle"></div>
            <div  class="text-subtitle-1" v-html="errorMessage"></div>
          </template>
          <div class="text-h6 mt-6">
            Se il problema persiste contattare l'assistenza via Whatsapp
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>      
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'
export default {
  components: { 
      jsPDF,
      autoTable
  },
  data() {
    return {
      max_bookable_rules:[v =>(v&&v>=1&&v<=this.max_bookable)],
      page: "Manage",
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      dialog_selectTable:false,
      dialog_disableTable:false,
      dialog_confirmDelete:false,
      dialog_dateWide:false,
      dialog_walkInHelp:false,
      dialog_date:false,			  
      dialog_walkIn:false,
      dialog_disableTableHelp:false,
      dialog_userRatingHelp:false,
      dialog_accomplished_message:'',
      dialog_resetTables:false,
      dialog_freeTable_all_Slots:false,
      dialog_connectionError:false,
      dialog_panView:false,
      dialog_userDetails:false,
      dialog_DirectBookingLock:false,
      dialog_enterBillAmount:false,
      dialog_waitingListTime:false,
      dialog_confirmWABooking:false,
      dialog_autoAssignLock:false,
      dialog_autoAssign:false,
      dialog_autoAssignEraseConfirmation:false,
      dialog_autoAssign_instruction :false,
      dialog_confirmSaveAuto:false,
      dialog_reserveTable:false,
      dialog_reassign_changes:null,
      dialog_mealDuration:null,
      dialog_reservedTableHelp:false,
      dialog_assignedHalls:false,
      dialog_permanentSaveWalkInWithTables:false,
      dialog_allocationRules:false,
      dialog_helpGlobal:false,
      dialog_confirmConfirm:false,
      dialog_unconfirmed_booking:false,
      dialog_unconfirmed_booking_opened:false,
      dialog_saveCombination:false,
      dialog_swapTables:false,
      dialog_freeTable_all_Slots_Map:false,
      dialog_rating:false,
      dialog_addressBook:false,
      dialog_coupon:false,
      dialog_coupon_details:false,
      dialog_mealDurationSlim:false,
      dialog_history:false,
      showiManagerMap:false,
      showMapsDiv2:false,
      couponDetails:null,
      selectedCoupon:null,
      hideCloseButton:false,
      snackbar_confirm_cancellation:false,
      snackbar_confirm_cancellation_text:null,
      snackbar:false,
      snackbar_color:null,
      snackbar_message:null,
      snackbar_timeout:1500,
      snackbar_expired:false,
      max_bookable:50,
      overbooking:50,
      search:null,
      autoAssignLocked:false,
      autoAssignSaved:false,
      loading_checkUser:false,
      previousDisabledTables:[],
      selectedBooking:null,
      disabledTables:[],
      reservedTables:[],
      disabledTablesName:[],
      alreadyAssigned:[],
      loading_getFreeSlots:false,
      loading:false,
      loading_edit:false,
      loading_datepicker:false,
      loading_simulate:false,
      loading_walkIn:false,
      loading_set:false,
      loading_cancelling_all:false,
      loading_cancelling_auto:false,
      loading_panView:false,
      loading_sendCoupon:false,
      loadingReviewRequest:false,
      loadingChangeStatus:false,
      loading_history:false,
      walkInLocations:[],
      pan_view_details:false,
      prizes:null,
      panTables:null,
      date:null, // for datepicker
      dateString:null,
      dateString2:null,
      time:null,
      area:null,
      activeSlot:null,
      activeLocation:null,
      halls:null,
      assignedTablesId:[],
      swappedBooking:null,  
      ATA:null,
      tablesList:null,
      currentTimePC:null,
      covers:null,
      slot:null,
      slotId:null,
      areaId:null,
      locationId:null,
      shift:null,
      //shiftClassId:null,
      mealId:null,
      meals:null,
      newUser:0,
      optIn:1,
      errorTitle:null,
      errorMessage:null,
      bookings:null,
      bookings_previous:null,
      fullname:null,
      events:null,
      eventscolor:null,
      activeOptions:null,
      tableAlert:false,
      tables:null,
      tablesId:[],
      //dialog_free_tables:false,
      free_tables:null,
      //newBookingTablesId:null,
      disabledTablesId:null,
      otherBookingTablesId:null,
      selectedSlotId:null,
      origin:null,
      loading_free:false,
      polling:null,
      pickerDate:null,
      countryCode:39,
      phone:null,
      isnull:null,
      helpType:null,
      mealFilter:null,
      //tablesByCovers:[],
      errorPhone:'Solo numero di cellulare',
      errorPhone_status:0,
      successPhone_status:0,
      showCancelled:false,
      //walkInSelectedTables:[],
      rowToBlink:[],
      currentCombinations:null,
      userRatings:null,
      trackedItems:null,
      oldLocationId:[],
      oldSlotId:[],
      oldMealDuration:[],
      oldCovers:[],
      oldChildren:[],
      canvaHeight:null,
      canvaWidth:null,
      //fullnames:['Extra'],
      expired:null,
      billAmount:null,
      todayBooking:null,
      mealDurations:null,
      canvasAction:null,
      canvasSlotId:null,
      canvasBookingId:null,
      dsddb:new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000 )).toISOString().split("T")[0],
      validCombinations:null,
      swappables:["Giovanni Bianchi","Alberto Neri","Giuseppe Verdi"],
      bookingDetails:[
                      {"Nome":"fullName","Telefono":"fullPhone","CAP":"postalCode","Email":"email"},
                      {"Data":"bookingDate","Ora":"time","Coperti":"covers","Bambini":"children","Sala":"locationName","Note":"remarks"},
                      {"Data Richiesta":"createdDate","Ora Richiesta":"createdTime","In Lista?":"isWaitingList","Scadenza lista":"endOfWaitingList","Ore a Scadenza Lista":"hoursToEndOfWaitingList"}],
      booking:{locationId:null,hallId:null,bookingId:null,countryCode:39,covers:null,children:null,date:null,lastName:null,firstName:null,requests:[],trackedItems:[],phone:null,slotId:null,time:null,optIn:false,reassign:0,waitingListTime:null,sendWAConfirmation:null,requester:'map',tablesId:["001"],rating:null,ratingRemarks:null,review:null,reviewScore:null,reviewDate:null,reviewTime:null,reviewerName:null,reviewerLocation:null,avgBillAmount:null,dailyAvgBillAmount:null},
      emptyBooking:{locationId:null,hallId:null,bookingId:null,countryCode:39,covers:null,children:null,date:null,lastName:null,firstName:null,requests:[],trackedItems:[],phone:null,slotId:null,time:null,optIn:false,reassign:0,waitingListTime:null,sendWAConfirmation:null,requester:'map',tablesId:["001"]},
      item:{locationId:null,hallId:null,bookingId:null,countryCode:39,covers:null,children:null,date:null,lastName:null,firstName:null,requests:[],trackedItems:[],phone:null,slotId:null,time:null,optIn:false,waitingListTime:null,sendWAConfirmation:null,tables:null},
      locations:null,
      resHash:null,
      oldHash:null,
      selectedBooking_hash:null,
      disabledTables_hash:null,
      highRewardDescription:'Grazie per la sua Recensione da tutto lo staff',
      addTripAdvisorButton:false,
      dows:[
            {code:1,it:'Lunedì',en:'Mondays'},
            {code:2,it:'Martedì',en:'Tuesdays'},
            {code:3,it:'Mercoledì',en:'Wednsdays'},
            {code:4,it:'Giovedì',en:'Thursdays'},
            {code:5,it:'Venerdì',en:'Fridays'},
            {code:6,it:'Sabato',en:'Saturdays'},
            {code:7,it:'Domenica',en:'Sundays'}
           ],
      headers_free: [
                //{text: 'N', align: 'start', value: 'new'},
                { text: 'Occupato',    value: 'busy_at',     align: 'center',  sortable: false, class:'px-1 text-lg-button' },
                { text: 'Tavolo',       value: 'table',       align: 'center',  sortable: false, class:'pl-3 pr-1 text-lg-button' },
                { text: 'Libero',  value: 'free_at',     align: 'center',  sortable: false, class:'px-1 text-lg-button' },
                //{ text: 'Assegna',      value: 'actions',     align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
              ],
      headers: [
                //{text: 'N', align: 'start', value: 'new'},
                { text: 'Tavolo',   value: 'tables',      align: 'start',   sortable: true, class:'text-button font-weight-bold', width: "150" },
                { text: 'Pax',      value: 'covers',      align: 'center',  sortable: true, class:'text-button font-weight-bold', width: "80" },
                { text: 'Nome',     value: 'fullName',    align: 'start',   sortable: true, class:'text-button font-weight-bold', width: "250" },         
                { text: 'Note',     value: 'requests',    align: 'center',  sortable: true, class:'text-button font-weight-bold' },
                //{ text: 'Ore',    value: 'time',        align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                { text: 'Azione',   value: 'actions',     align: 'center',  sortable: false, class:'text-button font-weight-bold', width: "200" },
              ],
      userDetailsHeaders: 
        [
                { text: 'Data',       value: 'date',          align: 'center',  sortable: false, class:'text-subtitle-1 font-weight-bold px-1' },
                { text: 'Ora',        value: 'time',          align: 'center',  sortable: false, class:'text-subtitle-1 font-weight-bold px-1' },
                { text: 'Ritardo',    value: 'delayed',       align: 'center',  sortable: false, class:'text-subtitle-1 font-weight-bold px-1' },
                { text: 'Coperti',    value: 'covers',        align: 'center',  sortable: false, class:'text-subtitle-1 font-weight-bold px-1' },
                { text: 'Scontrino',  value: 'avgBillAmount',       align: 'center',  sortable: false, class:'text-subtitle-1 font-weight-bold px-1' },
                { text: 'AvgBill',    value: 'dailyAvgBillAmount',  align: 'center',  sortable: false, class:'text-subtitle-1 font-weight-bold px-1' },
                { text: 'Rating',     value: 'rating',        align: 'center',  sortable: false, class:'text-subtitle-1 font-weight-bold px-1' },
                { text: 'Review',     value: 'score',        align: 'center',  sortable: false, class:'text-subtitle-1 font-weight-bold px-1' },
                { text: 'Posizione',  value: 'location',      align: 'center',  sortable: false, class:'text-subtitle-1 font-weight-bold px-1' },
                { text: 'Confermata', value: 'active',        align: 'center',  sortable: false, class:'text-subtitle-1 font-weight-bold px-1' },
                { text: 'NoShow',     value: 'noShow',        align: 'center',  sortable: false, class:'text-subtitle-1 font-weight-bold px-1' },
                { text: 'Ghost',      value: 'ghost',         align: 'center',  sortable: false, class:'text-subtitle-1 font-weight-bold px-1' },
        ],
      headersCoupons: [
          { text: 'Titolo',         value: 'prizeName',   align: 'start',   sortable: false, class:'px-1 text-lg-button' },
          { text: 'Durata gg',      value: 'duration',      align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
          { text: 'Giorni Validi',  value: 'validDoW',    align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
          //{ text: 'Range',   value: 'highRewardRange',    align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
          //{ text: 'Scegli',         value: 'actions',     align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
          { text: 'Scegli',         value: 'data-table-select',align: 'center',  sortable: false, class:'pl-1 text-lg-button' }
        ],
    addressBookCustomerHeaders:[
          { text: 'D',            value: 'details',     align: 'start', sortable: false},
          { text: 'Cognome',      value: 'lastName',    align: 'start', sortable: true},
          { text: 'Nome',         value: 'firstName',   align: 'start', sortable: true},
          { text: 'Numero',       value: 'phone',       align: 'center', sortable: true },
          { text: 'Visite',       value: 'cnt',         align: 'center', sortable: true },
          { text: 'Rating',       value: 'rating',      align: 'center', sortable: true },
          { text: 'Prenota',      value: 'book',        align: 'center', sortable: true },
          { text: 'Chiama',       value: 'call',        align: 'center', sortable: true }
          ],
   addressBookBookingHeaders:[          
          { text: 'Data',         value: 'date', align: 'start', sortable: false},
          { text: 'Ora',          value: 'time' },
          { text: 'Ritardo',      value: 'late' },
          { text: 'Coperti',      value: 'covers' },
          { text: 'Tavolo',       value: 'tables' },
          { text: 'Review',       value: 'score' },
          { text: 'Ghost',        value: 'ghost' },
          { text: 'Scontrino',    value: 'bill' },
          { text: 'Rating',       value: 'rating' },
          ],
      waStatus:[{"title":"WA","idx":"waLinkI","color":"waLinkIc"},{"title":"Promemoria","idx":"waRemI","color":"waRemIc"},{"title":"Recensione","idx":"waRRqI","color":"waRRqIc"}],             
      userDetails:null,
      slots:  null,//["19:00","19:30","20:00","20:30","21:00","21:30","22:00","22:30","23:00","23:30","00:00"],
      requests:null,
      //shifts:[{"name":"Primo","shiftId":"0BF94C0BAF7C262948A848EC567AE49B"},{"name":"Secondo","shiftId":"ED95A701106443DDB098D07CC0754904"}],
      shifts: null,
      foodStyles:null,
      allBookings:null,
      allTables:null,
      allCombinations:null,
      allSlots:null,
      tablesAssigned:[],
      canvasSelectedHall:null,
      BOO:[],
      boo:null,
      Boo:null,
      reassign:"0",
      tablesAssignedDetailed:[],
      unassignedReservations:[],
      confirmBookingDetails:null,
      freeTables:null,
      allRules:null,
      menuDateVolante:false,
      pickedDate:null,
      selectedSlot:null,
      assignedHalls:null,
      assignedHallsSlots:null,
      forceTableAllocation:0,
      freeTables_all:null,
      basicMessage:'** <br>Clicca sul pulsante in fondo per visualizzare il coupon che ti abbiamo riservato.<br>*',
      unassigned:null,
      activeLocationId:null,
      activeHallId:null,
      activeSlotId:null,
      canvaWidthVolante:null,
      canvaHeightVolante:null,
      refreshTrigger:false,
      slotsDetails:null,
      iManagerMap:null,
      mapZoomLevel:null,
      mapZoomLevelManual:null,
      minHeight:null,
      showManualAssignMap:false,
      assignedTablesIdTemp:[],
      iManagerMapDetails:null,
      reopeniManagerMap:false,
      enableBookWithTables:false,
      suggestedTablesIdDefault:null,
      isCovers:true,
      resetOption:null,
      iManagerMapSwitch:false,
      isVolante:false,
      txtPDF:['Scarica PDF Prenotazioni','Prenotazioni Scaricate'],
      clrPDF:['warning','success'],
      statusPDF:0,
      itemsPDF: null, 
      headingPDF:null,
      previousConfirmationTooltip:null,
      previousConfirmationTooltipLast:null,
      savedTotalCovers:null,
      dialog_createCombination:false,
      newCombination:null,
      currentTables:null,
      newVolanteOrEdit:'n',
      selectedSlotIdEdit:null,
      selectedSlotIdEdit_copy:null,
      selectedLocationIdEdit:null,
      selectSlotEdit:null,
      selectedCoversEdit:null,
      selectedChildrenEdit:null,
      loading_addressBook:false,
      addressBookSearch:'',
      addressBookExpanded:[],
      addressBookDetails:[],
      addressBookCustomers:null,
      timeout:null,
      activePicker:null,
      menuBirthdate:false,
      addressBookCount:null,
      isExpanded:0,  
      walkIn:{"countryCode":39,"phone":null,"firstName":null,"lastName":null,"covers": 2,"mealDuration":5400,"tablesId":[]},
      walkInEmpty:{"countryCode":39,"phone":null,"firstName":null,"lastName":null,"covers": 2,"mealDuration":5400,"tablesId":[]},
      isWalkInSlim:false,
      mapWidth:6,
      historyEvents:null,
      pressTimer: null,
      holdDuration: 600, // Duration in ms
      isLongPress: false,  
    };
  },
  computed : {
    ...mapGetters(["settings","SST","countries"]),
    sendWAConfirmationModel: {
      get() {
        // If booking.sendWAConfirmation is undefined/null, use default
        console.log(5293,this.booking.sendWAConfirmation,this.settings.options.WA_sendWAMessageFromVolante_defaultValue)

        let dfValue=this.settings.options.WA_sendWAMessageFromVolante_defaultValue==='1'?1:0;
        let tmp= this.booking.sendWAConfirmation !== null 
          ? this.booking.sendWAConfirmation 
          : dfValue;
        this.$set(this.booking, 'sendWAConfirmation', tmp)        
        console.log(5297,this.booking.sendWAConfirmation,this.settings.options.WA_sendWAMessageFromVolante_defaultValue,tmp,dfValue)
        return tmp;
        /*
        let dfValue=this.settings.options.WA_sendWAMessageFromVolante_defaultValue=='1'?1:0;
        console.log(5293,this.settings.options.WA_sendWAMessageFromVolante_defaultValue,this.booking.sendWAConfirmation,this.sendWAConfirmationModel,dfValue)
        let tmp=this.sendWAConfirmationModel===null?dfValue:this.booking.sendWAConfirmation;
        this.$set(this.booking, 'sendWAConfirmation', tmp)
        console.log(5295,this.settings.options.WA_sendWAMessageFromVolante_defaultValue,this.booking.sendWAConfirmation,tmp,dfValue,this.sendWAConfirmationModel)
        return tmp;
        */
        /*return this.booking.sendWAConfirmation !== null 
          ? this.booking.sendWAConfirmation 
          : this.settings.options.WA_sendWAMessageFromVolante_defaultValue=='1'?1:0;
        */
      },
      set(value) {
        //this.booking.sendWAConfirmation = value;
        this.$set(this.booking, 'sendWAConfirmation', value)  
      }
    },    
    selectedAddresses:function()
    {
      var src=this.addressBookSearch?this.addressBookSearch.toUpperCase():'';
      if (src=='')
      {
        this.addressBookCustomers=null;
      }
      if (this.addressBookCustomers)
      {
        var cnt=this.addressBookCustomers.filter(c=>c.phone.includes(src)||c.firstName.includes(src)||c.lastName.includes(src)).length
        return cnt + ' contatti';
      }
      else
      {
        return this.addressBookCount + ' contatti';
      }
  },   
  showUnassigned1: function()
  {
    //var tmp = this.freeTables_all?.[0]?.unassignedBookings?.filter(ff=>ff.bookingId!='Neu')?.length > 0
    var unassigned=this.freeTables_all?.[0]?.unassignedBookings;
    var tmp=unassigned?.filter(ff=>ff.bookingId!='Neu'&&!ff.tableString)?.length > 0    
    console.log(5282,tmp)
    return tmp;
  },
  showUnassigned2: function()
  {
    var unassigned=this.freeTables_all?.[0]?.unassignedBookings;
    var tmp=unassigned?.filter(ff=>ff.bookingId!='Neu'&&!ff.tableString)?.length > 0
    //var tmp= this.freeTables_all?.[0]?.unassignedBookings?.filter(ff=>ff.bookingId!='Neu')?.length > 0
    console.log(5288,tmp)
    return tmp;
  },

    continue_button:function()
    {
      var p2=this.booking.covers===null;
      var p3=(this.booking.slotId);
      var p4=(this.locationId);
      var p5=(this.fullname);
      var p7=p2||p3||p4||p5;
     return p7;
    },
    today:function()
    {
      var yourDate=new Date();
      const of = yourDate.getTimezoneOffset()
      yourDate = new Date(yourDate.getTime() - (of*60*1000))
      return yourDate.toISOString().split('T')[0]
    },
    shownMessage()
    {
      let msg=this.basicMessage;
      msg=msg.replace('**',this.highRewardDescription+'<br>')
      if (this.highRewardDescription.includes("\n"))
      {
        this.snackbar_message='Il carattere "a capo" non può essere inserito nel messaggio whatsapp';
        this.snackbar_color='warning';
        this.snackbar=true;
      }      
      let TAMessage=this.addTripAdvisorButton?'<br>Ci aiuterebbe moltissimo se volessi rilasciare una recensione su Tripadvisor':'.';
      //console.log(4303,TAMessage)
      msg=msg.replace('*',TAMessage)
      return msg
    },

  formattedBookingDate() {
    const d = this.booking?.date || this.pickedDate || null;
    if (!d) return '';
    const dt = new Date(d);
    if (isNaN(dt)) return '';
    return dt.toLocaleDateString('it-IT', { weekday: 'long', month: 'long', day: 'numeric' });
  },

  },
  created(){
    //console.log(1357,this.settings)
    //this.GetDate(0);
    //this.pollData()
    ////console.log(1360,this.timer)
    this.$vuetify.theme.dark = true;//this.settings.options.darkTheme;
    this.$store.dispatch("scheme/setDarkTheme", false);
    //console.log(716,this.settings);
    if (this.settings&&this.settings.brand==' ')
    {
      this.$router.push('/auth/login').catch(() => {});
    }
    else
    {
      this.GetDate(0)
      this.pollData()
    }
  },
  mounted() {
      ////console.log(768,this.$route.query.user)
      //console.log(1935,this.SST)
     this.onResize() 

  },
  watch : {
    'walkIn.firstName': function (newVal)
    {
      console.log(5424,newVal)
      if (newVal?.length>0)
      {
        this.walkIn.firstName=newVal.toUpperCase()
      }
    },
    'walkIn.lastName': function (newVal)
    {
      console.log(5432,newVal)
      if (newVal?.length>0)
      {
        this.walkIn.lastName=newVal.toUpperCase()
      }
    },
    'walkIn.tablesId': function (newVal,oldVal)
    {
      if (oldVal.length>0&&newVal.length==0)
      {
        this.walkInEmpty.duration=this.slots.find(s=>s.slotId==newVal).duration||90;
        this.walkIn=JSON.parse(JSON.stringify(this.walkInEmpty))
      }
      //console.log(2002,this.oldLocationId)
    },
    'walkIn.phone': function (newVal)
    {
      console.log(5175,newVal)
      if (newVal?.length>8)
      {
        this.checkPhoneNumber(newVal, 'walkIn')
      }
    },   
    activeSlotId(newVal)
    {
      this.walkIn.mealDuration=this.slots.find(s=>s.slotId==newVal).duration
      //this.$set(this.walkIn, 'mealDuration', this.slots.find(s=>s.slotId==newVal).duration)
      console.log(5196,newVal,this.walkIn.mealDuration,this.slots,this.slots.find(s=>s.slotId==newVal).duration)
      this.walkIn.tablesId=[];
    },
    menuBirthdate (val) {
      val && setTimeout(() => (this.$refs.birthdate.activePicker = 'YEAR'))
    },    
    addressBookSearch(newVal)
    {
      if(newVal.length>2)
      {
        if (this.timeout) 
          clearTimeout(this.timeout); 

        this.timeout = setTimeout(() => {
          this.addressBookGet(newVal,0)
        }, 1000); // delay
      }
    },
    mealId(newVal){
      console.log(5214,newVal)
      this.locationId=null;
      this.walkIn.tablesId=[]
      this.getFreeSlots('v',4929)
    },
    async activeLocationId(newVal, oldVal) {
      console.log(5420, newVal, oldVal);
      
      // Reset tables selection
      this.walkIn.tablesId = [];
      
      // Handle undefined/null values
      if (!newVal) {
        console.log(5423, 'activeLocationId cleared');
        this.activeHallId = null;
        this.showiManagerMap = false;
        this.showManualAssignMap = false;
        this.freeTables_all = null;
        return; // Exit early
      }
      
      // Only proceed if newVal is truthy and different from oldVal
      if (newVal !== oldVal) {
        // Safely find hall
        const hall = this.halls?.find(h => h.locationId === newVal);
        
        if (hall) {
          this.activeHallId = hall.hallId;
          this.showiManagerMap = true;
          console.log(5422, 'calling ShowiManagerMap...');
          await this.ShowiManagerMap();
        } else {
          console.warn('No hall found for locationId:', newVal);
          this.activeHallId = null;
        }
      }
    }, 
    /*
    async activeLocationId(newVal,oldVal)
    {
      //this.activeHallId=null;
      console.log(542,newVal,oldVal)
      this.activeHallId=this.halls.find(h=>h.locationId==newVal).hallId
      this.walkIn.tablesId=[]
      console.log(5420,newVal,oldVal,this.freeTables_all,this.halls,this.activeHallId)
      console.log(5421,this.halls.find(h=>h.locationId==newVal))
      //this.freeTables_all=null;
      if(newVal)
      {
        console.log(5422,'calling...')
        this.showiManagerMap=true;
        await this.ShowiManagerMap();
      }
      if (!newVal||newVal==oldVal)
      {
        console.log(5423,newVal,oldVal)
        this.showiManagerMap=false;
        this.showManualAssignMap=false;
      }
      else
      {
        this.showiManagerMap=true;
        console.log(5424,'KKK',this.showiManagerMap)
      }
    },
    */
    async activeHallId(newVal,oldVal)
    {
      console.log(5425,newVal,oldVal,this.freeTables_all)
      this.walkIn.tablesId=[];
      this.freeTables_all=null;
      if (!this.freeTables_all)
      {
        console.log(5426,newVal)
        await this.ShowiManagerMap();
      }
      if (!newVal||newVal==oldVal)
      {
        console.log(5427,newVal,oldVal)
        this.showiManagerMap=false;
      }
      else
      {
        this.showiManagerMap=true;
        console.log(5428,'KKK',this.showiManagerMap)
      }
    },    
    pickerDate (newVal,oldVal) {
      console.log(4791,newVal,oldVal,this.date)
      if (oldVal)
      {
        if (newVal>oldVal)
        {
          this.date=this.addMonthFunction(new Date(this.date),1)
        }
        else
        {
          this.date=this.addMonthFunction(new Date(this.date),-1)
        }
        //console.log(3713,this.date.substr(2));
        ////console.log(3713,('00'+new Date(this.date).getDate()).subst(-22));
        //var nda=new Date(this.date).getDate()
        //this.date=newVal+'-'+('00'+new Date(this.date).getDate()).substr(-2);
        this.$store.dispatch("setDate",this.date);
        //console.log(4501,this.date)
        this.getMonthlyBookings()
      }
    },
    'selectedBooking.locationId': function (newVal,oldVal)
    {
      this.oldLocationId=[newVal,oldVal];
      //console.log(2002,this.oldLocationId)
    },
    'selectedBooking.slotId': function (newVal,oldVal)
    {
      this.oldSlotId=[newVal,oldVal];
      //console.log(2002,this.oldLocationId)
    },
    'selectedBooking.mealDuration': function (newVal,oldVal)
    {
      this.oldMealDuration=[newVal,oldVal];
      //console.log(2002,this.oldLocationId)
    },
    'selectedBooking.covers': function (newVal,oldVal)
    {
      console.log(4736,newVal,oldVal)
      this.oldCovers=[newVal,oldVal];
      //this.startResetTables('covers')      
      //console.log(2002,this.oldLocationId)
    },
    'selectedBooking.children': function (newVal,oldVal)
    {
      console.log(5510,newVal,oldVal)
      this.oldChildren=[newVal,oldVal];
      //this.startResetTables('children') 
    },                
    'booking.firstName': function (newVal)
    {
      if(newVal)
      {
        this.booking.firstName=newVal.toUpperCase();
        //console.log(4759,this.booking.firstName)
      }
    },
    'booking.lastName': function (newVal)
    {
      if(newVal)
      {
        this.booking.lastName=newVal.toUpperCase();
        //console.log(4764,this.booking.lastName)
      }
    },            
    pickedDate (val) {
      console.log(5633,val)
      this.booking.date = val;//this.formatDate(val)
    },    
    'booking.date':function(newVal,oldVal)
    {
      console.log(5639,newVal,oldVal)
      this.isCovers=false;
      //if (newVal&&this.booking.mealId)
      if (newVal)
      {
        if(this.booking.phone&&!this.booking.bookingId)
        {
          this.checkPhoneNumber(this.booking.phone)
        }
        //this.getFreeSlots('v');
        this.booking.tablesId=null; 
        this.booking.slotId=null;
        if (newVal&&newVal!=oldVal&&this.booking.locationId&&!this.selectedSlotIdEdit&&!this.isWalkInSlim)
          this.getFreeSlots('v',5248);
      }
    },
    'booking.mealId':function(newVal,oldVal)
    {
      console.log(4718,newVal,oldVal)
      this.isCovers=false;
      this.booking.slotId=null;
      this.booking.tablesId=null;
      //if (newVal&&this.booking.mealId)
      if (newVal&&newVal!=oldVal&&this.booking.locationId&&!this.selectedSlotIdEdit&&!this.isWalkInSlim)
      {
        //console.log(3741,this.booking,newVal)
        this.getFreeSlots('v',4973);
      }      
    },
    'booking.covers':function(newVal,oldVal)
    {
      this.booking.slotId=null;
      this.booking.tablesId=null;
      //this.CL(4729,newVal,this.booking.covers,this.booking.locationId)

      //if (newVal&&this.booking.mealId)
      if (newVal&&newVal!=oldVal&&this.booking.locationId&&!this.selectedSlotIdEdit&&!this.isWalkInSlim)
      {
        this.getFreeSlots('v',4985);
      }
    },
    'booking.children':function(newVal,oldVal)
    {
      this.booking.slotId=null;
      this.booking.tablesId=null;
      if (newVal&&newVal!=oldVal&&this.booking.locationId&&!this.isWalkInSlim)
      {
        this.getFreeSlots('v',4994);
      }
    }, /*   
    'booking.tablesId':function(newVal,oldVal)
    {
      console.log(5286,newVal,oldVal)
      if (newVal&&newVal!=oldVal)
      {
        var p=this.tables.find(t=>t.tableId==newVal.slice(-1))
        console.log(5290,newVal,p)  
        //this.freeTableClassVolante(p,this.booking)     
        //this.getFreeSlots('v',5007);
      }
    },*/
    'booking.locationId':function(newVal,oldVal)
    {
      this.booking.slotId=null;
      this.booking.tablesId=null;
      this.isCovers=false;
      //if (newVal&&this.booking.mealId)
      if (newVal&&newVal!=oldVal&&this.booking.locationId&&!this.isWalkInSlim)
      {
        //this.activeLocationId=newVal;
        //console.log(4879,newVal)        
        this.getFreeSlots('v',5007);
      }
    },
    'booking.mealDuration':function(newVal,oldVal)
    {
      this.booking.slotId=null;
      this.booking.tablesId=null;
      console.log(4823,'changedDuration')
      console.log(4824,this.booking)
      //if (newVal&&this.booking.mealId)
      if (newVal&&newVal!=oldVal&&this.booking.locationId&&!this.isWalkInSlim)
      {
        this.getFreeSlots('v',5019);
      }
    },
    'booking.slotId': function(newVal)
    {
      console.log(4934,newVal)
      this.isCovers=false;
      this.selectedSlotId=newVal;
    },
    'booking.phone':function(newVal)
    {
      //console.log(4825,newVal);
      this.isCovers=false;
      if(this.booking.countryCode==39)
      {
        if (newVal)
        {
          //const rgx= new RegExp('^(\\+39)|\\s', 'gm')
          //this.booking.phone=newVal.replace(rgx, '');
          newVal=newVal.trim().replace(' ','').replace('+39','').replace(/\D/g,'')
          this.booking.phone=newVal;
          //console.log(4982,this.booking.phone)

          if(newVal.length>8&&newVal.length!=10)
          {
            this.errorPhone='Solitamente 9 o 10 cifre: verifica'
            this.errorPhone_status=0;
            this.successPhone_status=1;
          }
          else if (newVal.length==10)
          {
            this.errorPhone='Numero formalmente Corretto'
            this.successPhone_status=1;
            this.errorPhone_status=0
            console.log(5154,this.booking.bookingId)
            //if(!this.booking.bookingId)
              this.checkPhoneNumber(newVal);
          }
          else
          {
            this.errorPhone='Solo numero di cellulare';
            this.errorPhone_status=0
            this.successPhone_status=0;      
          }
        }
        else
        {
          this.errorPhone='Solo numero di cellulare';
          this.errorPhone_status=0
          this.successPhone_status=0
        }
      }
      else
      {
        if (newVal.length>8)
          {
            this.errorPhone='Numero formalmente Corretto'
            this.successPhone_status=1;
            this.errorPhone_status=0
            console.log(5179,this.booking.bookingId)
            //if(!this.booking.bookingId)
              this.checkPhoneNumber(newVal);
          }
      }
    },
    'walkIn.phone':function(newVal)
    {
      //console.log(4825,newVal);
      this.isCovers=false;
      if(this.walkIn.countryCode==39)
      {
        if (newVal)
        {
          //const rgx= new RegExp('^(\\+39)|\\s', 'gm')
          //this.booking.phone=newVal.replace(rgx, '');
          newVal=newVal.trim().replace(' ','').replace('+39','').replace(/\D/g,'')
          this.walkInphone=newVal;
          //console.log(4982,this.booking.phone)

          if(newVal.length>8&&newVal.length!=10)
          {
            this.errorPhone='Solitamente 9 o 10 cifre: verifica'
            this.errorPhone_status=0;
            this.successPhone_status=1;
          }
          else if (newVal.length==10)
          {
            this.errorPhone='Numero formalmente Corretto'
            this.successPhone_status=1;
            this.errorPhone_status=0
            console.log(5154,this.booking.bookingId)
            //if(!this.booking.bookingId)
              this.checkPhoneNumber(newVal);
          }
          else
          {
            this.errorPhone='Solo numero di cellulare';
            this.errorPhone_status=0
            this.successPhone_status=0;      
          }
        }
        else
        {
          this.errorPhone='Solo numero di cellulare';
          this.errorPhone_status=0
          this.successPhone_status=0
        }
      }
      else
      {
        if (newVal.length>8)
          {
            this.errorPhone='Numero formalmente Corretto'
            this.successPhone_status=1;
            this.errorPhone_status=0
            console.log(5179,this.booking.bookingId)
            //if(!this.booking.bookingId)
              this.checkPhoneNumber(newVal);
          }
      }
    },    
    selectedBooking(newValue,oldValue)
    {
      console.log(1359,newValue,oldValue)
      if(newValue)
        this.savedTotalCovers=newValue.children+newValue.covers;
      /*
      this.selectedBooking.time=this.covers.find(c=>c.slotId==newValue.slotId).name;
      this.selectedBooking.location=this.locations.find(l=>l.locationId==newValue.locationId).name;
      //console.log(1362,this.selectedBooking,this.covers.find(c=>c.slotId==newValue.slotId).name,this.locations.find(l=>l.locationId==newValue.locationId).name);
      */
    },
    activeSlot (newValue,oldValue)
    {
      //console.log(3479,newValue)
      //console.log(3831,this.tables)
      ////console.log(3832,this.tables)
      if(this.freeTables_all)
      {
        //console.log(3830,this.freeTables_all.find(f=>f.slotId==newValue));
        //console.log(3831,this.freeTables_all);
        //this.walkIn.tablesId=this.freeTables_all.find(f=>f.slotId==newValue).otherBookingTablesId;
        this.walkIn.tablesId=this.tables.map(t=>t.tableId);
        
        //console.log(3481,this.walkIn.tablesId)
      }    
      if (newValue!=oldValue)
      {
        this.ATA=new Date('1970-01-01T' + newValue.substring(0,8) + 'Z').getTime() / 1000;
        //console.log(3486, this.ATA);
      }
    },
    date (newValue,oldValue)
    {
      //console.log(1452,newValue,oldValue);
      this.statusPDF=0;
      if(oldValue!==null&&this.events)
      {
        this.GetDate(0)
      }
    },
    item (newValue) {
      console.log(5048,newValue)
      //this.getData(newValue)
    },
    assignedTablesId(newValue)
    {
      //console.log(3745,newValue,oldValue,this.canvasAction);
      //if (this.canvasAction!='canvasManualAssign') //testare questa opzione
      {
        //console.log(3747,newValue)
        this.assignTables(newValue);
      }
    },
    disabledTables(newValue)
    {
      ////console.log(1075,newValue,oldValue)
      this.disableTable(newValue)
    },
    reservedTables(newValue)
    {
      ////console.log(1075,newValue,oldValue)
      this.reserveTable(newValue)
    },
    tablesList(newValue)
    {
      console.log(5072,'tablesList',newValue)
    }
  },
  methods:
  {
   startPress(event) {
      // Only respond to main button (left click) or touch
      if (event.button !== 0 && event.pointerType === 'mouse') return;
      this.isLongPress = false;
      console.log('startpress')
      this.pressTimer = setTimeout(() => {
        this.isLongPress = true;
        this.handleLongPress();
      }, this.holdDuration);
    },
    cancelPress() {
      if (this.pressTimer) {
        clearTimeout(this.pressTimer);
        this.pressTimer = null;
      }
    },
    handleClick(event) {
      // If a long press just triggered, block the normal click
      if (this.isLongPress) {
        this.isLongPress = false; // Reset for next interaction
        return;
      }
      console.log('handleClick')
      // Normal short click logic here
      this.GetDate(-1);
    },
    handleLongPress() {
      console.log('Long press triggered');
      this.GetDate(-1, true);
    },    
    formatDate3(date, type='dmy') {
      var locale = this.settings?.locale || navigator?.language || 'it-IT';
      
      if (!date) return '';
      var d = new Date(date);

      // Map each custom code character to its Intl.DateTimeFormat option
      var optionMap = {
        // Weekday
        'w': { weekday: 'short' },
        'W': { weekday: 'long' },

        // Day
        'd': { day: '2-digit' },

        // Month
        'm': { month: '2-digit' },
        'M': { month: 'short' },
        'N': { month: 'long' },

        // Year
        'y': { year: '2-digit' },
        'Y': { year: 'numeric' },

        // Time
        'h': { hour: '2-digit', hour12: false },
        'H': { hour: '2-digit', hour12: true },
        'i': { minute: '2-digit' },
        's': { second: '2-digit' },
        'z': { fractionalSecondDigits: 3 }
      };

      // Build options dynamically from the characters in `type`
      var options = {};
      if (type) {
        for (var i = 0; i < type.length; i++) {
          var char = type[i];
          if (optionMap[char]) {
            Object.assign(options, optionMap[char]);
          }
        }
      }

      // Fallback to default format if type is empty or invalid
      if (Object.keys(options).length === 0) {
        options = { day: '2-digit', month: '2-digit', year: 'numeric' };
      }

      return new Intl.DateTimeFormat(locale, options).format(d);
    },

    calcHistory(ei,key,l)
    {
      console.log(29,ei,key,l) 
      var rsp='';
      if(ei<l&&key)
      {  
        var cEv = this.historyEvents[ei]
        var pEv = this.historyEvents[ei+1]
        //console.log(35,cEv,pEv)
        //var clr = cEv[key]!=pEv[key]?'red--text font-weight-black':'black--text';
        if (pEv !== undefined)         
        {
          //console.log(40,cEv)
          //console.log(41,pEv)
          //console.log(42,cEv[0],pEv[0])           
          switch(key)
          {

            case 'active':
            case 'confirmed':
            case 'denied':
            case 'waiting':
              if (cEv[key]!=pEv[key])
              {
                rsp='<span class="red--text">'+pEv[key] +' => '+cEv[key]+'</span>'
              }
              else
              {
                rsp='<span>'+cEv[key]+'</span>';
              }
            break;
            case 'date':
              if (cEv[key]!=pEv[key])
              {
                rsp='<span class="red--text">'+new Date(pEv[key]).toLocaleDateString("it-IT",{weekday: "long",  month: "long",  day: "numeric"}) +' => '+new Date(cEv[key]).toLocaleDateString("it-IT",{weekday: "long",  month: "long",  day: "numeric",})+'</span>'
              }
              else
              {
                rsp='<span>'+new Date(cEv[key]).toLocaleDateString("it-IT",{weekday: "long",  month: "long",  day: "numeric"})+'</span>'
              }
            break;

            default:
              if (cEv[key]!=pEv[key])
                rsp= '<span class="red--text">'+pEv[key] +' => '+cEv[key]+'</span>'//clr
              else
                rsp= '<span>'+cEv[key]+'</span>'
         }
        }
        else
        {
          switch(key)
          {
            case 'date':
              rsp= '<span>'+new Date(cEv[key]).toLocaleDateString("it-IT",{weekday: "long",  month: "long",  day: "numeric",})+'</span>';
            break;
            default:
              rsp= '<span>'+cEv[key]+'</span>';
          }
        }

        return rsp;
       }
      else
        {
          return null;// '<span>'+cEv[key]+'</span>'
        }

    },      
  async resizeMap(v) {
    this.mapWidth += v;
    const currentHallId = this.activeHallId;
    this.activeHallId = null;
    
    await this.$nextTick(); // Wait for DOM update
    
    this.activeHallId = currentHallId;
  },
    unassignables()
    {
      console.log(5863,this.freeTables_all,this.activeSlotId)
      return this.freeTables_all.find(f=>f.slotId==this.activeSlotId)?.unassignedBookings?.filter(ff=>ff.bookingId!='Neu'&&!ff.tableString) || [];
    },
    async showHistory(item)
    {     
      this.loading_history=true;
      this.dialog_history=true;
      //console.log(5982,item)
      try
      {
          const payload=JSON.stringify({"action":"booking_history_get","payload":{"bookingId":item.bookingId}});
          const res = await this.$http.post('/manage/manage.php', payload );
          console.log(5618,res);
          switch (res.data.errorid)
          {
            case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              this.historyEvents=res.data.payloads;
              console.log(5624,this.historyEvents)
          break;
          case '0006':
              this.$router.push('/auth/login').catch(() => {});
          break;
          }
          this.loading_history= false;
      } catch(e)
      {
          this.loading_history= false;
          //console.log(res.data);
      }
    },
    pasteAddressBookData(item)
    {
      this.booking.phone=item.phone;
      this.booking.lastName=item.lastName;
      this.booking.firstName=item.firstName;
      this.booking.postalCode=item.postalCode
      this.booking.birthdate=item.birthdate;
      this.booking.email=item.email;
      this.dialog_addressBook=false
      this.addressBookSearch='';
      this.addressBookCustomers=null
    },    
    saveBirthdate (date) {
      this.$refs.menuBirthdate.save(date)
    },   
    subtractYears(years) {
      var date = new Date(Date.now())
      date.setFullYear(date.getFullYear() - years);
      return date.toISOString().substring(0, 10);
    },    
    getAddressBookDetails(item)
    {
      console.log(5668,item,this.addressBookCustomers,this.addressBookExpanded)
      if (this.addressBookCustomers&&this.addressBookCustomers[0].details&&this.addressBookCustomers.length>1||this.addressBookExpanded.length)
      {
        this.addressBookCustomers[0].details=null;
        this.addressBookSearch=''
        this.addressBookExpanded=[];
      }
      else
      {
        this.addressBookExpanded=[];
        this.addressBookExpanded.push(item);
        if (this.addressBookCustomers&&!this.addressBookCustomers[0].details)
          this.addressBookGet(item.phone,1);
      }
    },
    async addressBookGet(phoneNumber=null,getDetails)
    {
      console.log(5640,phoneNumber,getDetails,this.addressBookCustomers)
      this.dialog_addressBook=true;
      /*
      this.booking.firstName='',
      this.booking.lastName='',
      this.booking.phone=''
      */
      this.loading_addressBook=true;
      if((phoneNumber&&phoneNumber.length>2&&this.addressBookCustomers&&this.addressBookCustomers.length)||(!this.addressBookCustomers))
      {
        //this.addressBookCustomers=null;
        try
        {
            const payload=JSON.stringify({"action":"addressBook_get","q":phoneNumber,"getDetails":getDetails});
            const res = await this.$http.post('/manage/manage.php', payload );
            console.log(5618,res);
            switch (res.data.errorid)
            {
              case '0':
                sessionStorage.setItem('jwt', res.data.jwt);
                this.addressBookCustomers=res.data.payloads;
                console.log(5624,this.addressBookCustomers)
            break;
            case '0006':
                this.$router.push('/auth/login').catch(() => {});
            break;
            }
            this.loading_addressBook= false;
        } catch(e)
        {
            this.loading_addressBook= false;
            //console.log(res.data);
        }
      }
    },
    async rateUser(rating,remarks)
    {
      this.$set(this.booking,'rating',rating);
      var pload={bookingId:this.booking.bookingId,rating:rating,remarks:remarks}
      let payload={"action":"rateUser","payload":pload};
      console.log(5466,payload)
      let w= await this.updateDB(payload)
      console.log(5468,w)
      switch (w.errorid)
      {
        case '0':
          if(w.message)
          {
            this.snackbar_color='success';
            this.snackbar_message=w.message;
            this.snackbar=true;
         }
         this.dialog_rating=false;
      }
    },
    async  editVolante(booking)
    {
      var slctb={...booking};
      //slctb.foodStyle=[];
      //slctb.requests=[];
      this.selectedSlotIdEdit=slctb.slotId;
      this.selectedSlotIdEdit_copy=slctb.slotId;
      this.selectedLocationIdEdit=slctb.locationId
      var tmpLocationId=slctb.locationId;
      slctb.locationId=null;

      /*
      if(slctb.children>0)
        slctb.covers=''+slctb.covers+'+'+slctb.children;
      else
        slctb.covers=''+slctb.covers
      */
      
      //var z= await this.getFreeSlots2(booking,'v')
      console.log(5385,slctb)
      slctb.tablesId=['000'];
      this.newVolanteOrEdit='e';
      this.booking={...slctb}
      this.dialog_walkIn=true;
      this.booking.locationId=tmpLocationId
      /*
      var i=this.slots.find(s=>s.slotId=slctb.slotId)
      this.selectedSlot=i;
      this.selectedSlotId=i.slotId
      console.log(5633,slctb,i)
      this.processSlot(i)   
      */   
    },
    setMealDuration(md)
    {
      this.booking.mealDuration=md;
      this.dialog_mealDuration=false;
      console.log(5143,this.booking);
      this.booking.slotId=null;
      this.booking.tablesId=null;
      this.getFreeSlots('v',5145);
    },
    showTooltip(i)
    {
        console.log(5080,i,this.previousConfirmationTooltip[this.previousConfirmationTooltipLast],this.previousConfirmationTooltip[i])
        var vl=this.previousConfirmationTooltip[i];
        //console.log(5082,this.previousConfirmationTooltip.find((p,ii)=>ii==i))
        
        if (this.previousConfirmationTooltipLast==i)
        {
          console.log(5086,i,this.bookings[i])
          this.$set(this.previousConfirmationTooltip, i, !vl)
        }
        else
        {
          console.log(5091)
          this.$set(this.previousConfirmationTooltip, this.previousConfirmationTooltipLast, false)
          this.$set(this.previousConfirmationTooltip, i, !vl)
        }
        console.log(5095,i,this.previousConfirmationTooltip[this.previousConfirmationTooltipLast],this.previousConfirmationTooltip[i])
        this.previousConfirmationTooltipLast=i;
    },
    PDF() {
      const columns = [
        { title: "Ore", dataKey: "time" },
        { title: "PAX", dataKey: "covers" },        
        { title: "Tavoli", dataKey: "tables" },
        { title: "Telefono", dataKey: "phone" },
        { title: "Nome", dataKey: "name" },
        { title: "Note", dataKey: "remarks" }
      ];

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "A4"
      });

      var totalPagesExp = '{total_pages_count_string}'
      console.log(5062,this.date,new Date(this.date).toLocaleDateString('it-IT',{  year: 'numeric',  month: '2-digit',  day: '2-digit',weekday: 'long'}))
      var dateString=new Date(this.date).toLocaleDateString('it-IT',{  year: 'numeric',  month: '2-digit',  day: '2-digit',weekday: 'long'});
      var headerPDF=this.headingPDF;
      // Using autoTable plugin
      console.log(5066,this.headingPDF,headerPDF)
      doc.autoTable({
        columns,
        headStyles: { fillColor: 0 },
        columnStyles: { 0: { cellWidth: 16 },1: { cellWidth: 16 },2: { cellWidth: 40 },3: { cellWidth: 30 },4: { cellWidth: 80 } },
        body: this.itemsPDF,
        theme:"striped",
        margin: { left: 10, top: 25,right:10,bottom:15 },
        willDrawPage: function (data) {
            // Header
            //doc.setTextColor(40) 
            console.log(5109,data); 
            //doc.addImage(imgData, 'JPEG', 10, 7, 59, 17);
            doc.setFontSize(20).text('iBookrestaurant.it',10,21)
            doc.setFontSize(20).text(dateString, 287, 21,null,null,'right');
            doc.setFontSize(28).text(headerPDF, 150, 21.1,null,null,'center');
        },
        didDrawPage: function (data) {
          // Footer
          var str = 'Pagina ' + doc.internal.getNumberOfPages()
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === 'function') {
            str = str + ' di ' + totalPagesExp
          }
          doc.setFontSize(10)
          // jsPDF 1.4+ uses getHeight, <1.4 uses .height
          var pageSize = doc.internal.pageSize
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          doc.text(str, data.settings.margin.left, pageHeight - 10)
          //doc.text(this.headingPDF,150,pageHeight - 10,null,null,'center')
          doc.text("Stampato il " +new Date().toLocaleDateString('it-IT',{  year: 'numeric',  month: '2-digit',  day: '2-digit',}) + ' alle '+ new Date().toLocaleTimeString('it-IT'),287,pageHeight - 10,null,null,'right')
        }
      });
      
        if (typeof doc.putTotalPages === 'function')
        {
            doc.putTotalPages(totalPagesExp)
        }
        var nw=Date.now();
        console.log(5100,nw)
        doc.save('Bookings_'+nw+'.pdf');
        this.statusPDF=1
    },
    async getDataPDF()
    {
        {
            /*
            var date = new Date("Sun May 11,2014");
            var dateString = new Date(date.getTime() - (date.getTimezoneOffset() * 60000 ))
                                .toISOString()
                                .split("T")[0]            
            this.date=dateString;
            this.date='2024-05-05';
            */
            this.loading=true;
            try{
                const payload=JSON.stringify({"payload":{"date": this.date},"action":"bookingsPDF"});
                const res = await this.$http.post('/manage/manage.php', payload );
                console.log(275,res);
                switch (res.data.errorid)
                {
                  case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.itemsPDF=res.data.payloads.bookings
                    this.headingPDF=res.data.payloads.brand
                    console.log(1116,this.itemsPDF)
                    this.PDF()
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },           
    onResize()
    {
      console.log(4746,'Window Resize')
      this.wHeight=window.innerHeight
      this.wWidth= window.innerWidth
      console.log(4746,this.wHeight,this.wWidth)
    },    
    calcWHeight(w)
    {
      var rw=Math.max(this.wHeight-w,450)
      //console.log(5009,rw)
      return rw;
    },
    zoomLevelFull(hallId)
    {
      var mWidth=this.halls.find(h=>h.hallId==hallId).maxWidth+20;
      var isSmall=this.$vuetify.breakpoint.smAndDown?.92:(this.mapWidth / 6)*.92/2;
      var zoomWidth=this.wWidth*isSmall/mWidth;
      var mHeight=this.halls.find(h=>h.hallId==hallId).maxHeight;
      var zoomHeight=(this.calcWHeight(268+95))/mHeight;
      var zl=Math.min(zoomWidth,zoomHeight,1.5)
      //console.log(5020,mWidth,mHeight,zoomWidth,zoomHeight,zl)
      return zl;
    },
  zoomLevel(hallId)
    {
      var mWidth=this.halls.find(h=>h.hallId==hallId).maxWidth;
      //var zoomWidth=this.wWidth*0.56/mWidth;
      var isSmall=this.$vuetify.breakpoint.mdAndDown?.8:(this.mapWidth / 6)*1.05/2;
      var zoomWidth=this.wWidth*isSmall/mWidth;
      var mHeight=this.halls.find(h=>h.hallId==hallId).maxHeight;
      var zoomHeight=(this.calcWHeight(268))/mHeight;
      var zl=Math.min(zoomWidth,zoomHeight,1.5)
      console.log(6105,'mWidth '+mWidth,'mHeight '+mHeight,'zWidth '+zoomWidth,'zHeight '+zoomHeight,'zl '+zl)
      //console.log(5079,this.halls,this.$vuetify.breakpoint.mdAndDown)
      //console.log(5080,hallId,this.wWidth,this.wHeight,isSmall,mWidth,mHeight,zoomWidth,zoomHeight,zl) 
      return zl;     
      //return this.$vuetify.breakpoint.mdAndDown?zoomWidth:zl;
    },
  zoomLeveliManager(hallId)
    {
      var mWidth=this.halls.find(h=>h.hallId==hallId).maxWidth;
      //var zoomWidth=this.wWidth*0.56/mWidth;
      var padding=8+4+8+16+4+8
      var isSmall=this.$vuetify.breakpoint.mdAndDown?1:(this.mapWidth / 6)*.92/2;
      var zoomWidth=(this.wWidth-padding)*isSmall/mWidth;
      var mHeight=this.halls.find(h=>h.hallId==hallId).maxHeight;
      var zoomHeight=(this.calcWHeight(280))/mHeight;
      var zl=Math.min(zoomWidth,zoomHeight,1.5)
      //console.log(6120,'mWidth '+mWidth,'mHeight '+mHeight,'zWidth '+zoomWidth,'zHeight '+zoomHeight,'zl '+zl)
      //console.log(5079,this.halls,this.$vuetify.breakpoint.mdAndDown)
      //console.log(5080,hallId,this.wWidth,this.wHeight,isSmall,mWidth,mHeight,zoomWidth,zoomHeight,zl) 
      return zl;     
      //return this.$vuetify.breakpoint.mdAndDown?zoomWidth:zl;
    },    
  zoomLevelManual(hallId)
    {
      var mWidth=this.halls.find(h=>h.hallId==hallId).maxWidth;
      var padding=8+4+8+16+4+8+48+36
      var isSmall=this.$vuetify.breakpoint.smAndDown?1:(this.mapWidth / 6)*.92/2;
      var zoomWidth=(this.wWidth-padding)*isSmall/mWidth;    
      var mHeight=this.halls.find(h=>h.hallId==hallId).maxHeight;
      var zoomHeightManual=(this.calcWHeight(268+95))/mHeight;
      var zl=Math.min(zoomWidth,zoomHeightManual,1.5)	
      //console.log(6134,'mWidth '+mWidth,'mHeight '+mHeight,'zWidth '+zoomWidth,'zHeightM '+zoomHeightManual,'zl '+zl)
      return zl;
    },    
    async disableCoupon(couponId)
    {
      console.log(5897)
      let payload=JSON.stringify({"action":"disableCoupon","couponId":couponId});
      let endpoint='/manage/manage.php';
      console.log(5900,payload)
      let w= await this.updateDB(payload,endpoint)   
      if(w.errorid=='0')
      {
        console.log(5905)
        this.snackbar_color="success"
        this.snackbar_message =w.message;
        this.snackbar = true;        
      }   

    },
    addMonthFunction(date,months)
    {
      date.setMonth(date.getMonth() + months);
      return date;
    },
    async ShowiManagerMap()
    {
        if (this.showiManagerMap||!this.freeTables_all)
        {
          console.log(6108,this.showiManagerMap,this.freeTables_all);
          //this.item=item;
          //this.booking.date=null;
          this.showManualAssignMap=false;
          //console.log(5022,location,item)
          //this.CL(5016,this.currentValues,this.$refs[location].offsetWidth);
          ////console.log(6506,this.$refs.canvasMap.offsetwidth)
          ////console.log(6507,this.$refs.mainTable)
          //this.CL(5019,this.$refs.canvas_FreeTables.offsetWidth)
          this.canvaWidth=(this.$refs.canvas_FreeTables.offsetWidth*7/12)+20
          //this.CL(5021,this.$refs.canvas_FreeTables.offsetHeight, this.wHeight)
          if(!this.canvaHeight)
          {
            this.canvaHeight=this.wHeight-320
          }
          //this.CL(5023,this.canvaHeight,this.canvaWidth)
          this.bookingId=null;
          //this.canvasAction='canvas_FreeTables_get'
          //this.CL(5025,this.canvasAction)
          console.log(6127)
          this.getFreeSlots('map',5467);
        }
        else
        {
          //this.activeLocationId=null;
        }
        this.showiManagerMap=!this.showiManagerMap;    
        console.log(5939,'KKK',this.showiManagerMap)         
    },
    async ShowManualAssignMap(item)
    {
        this.item=item; //booking
        //console.log(5189,item);
        this.loading_getFreeSlots=true
        this.reopeniManagerMap=this.showiManagerMap
        this.showManualAssignMap=false;    
        this.showiManagerMap=false            
        this.activeLocationId=item.locationId;
        
        this.assignedTablesId=item.tablesId||[];
        //console.log(5179,this.assignedTablesId)
        this.assignedTablesIdTemp=[...this.assignedTablesId];
        //if (!this.freeTables_all)
        {
          //console.log(5198,this.freeTables_all)
          this.getFreeSlots('map',5490);
        }
        
        //var pload={bookingId:item.bookingId,covers:0,children:0,date:item.date,locationId:item.locationId,mealId:item.mealId,requester:'v',reassign:0}
        var pload={"bookingId":item.bookingId,"date":this.date}
        let payload={"action":"getCombinations","payload":pload};
        //console.log(968,payload)
        let w= await this.updateDB(payload)
        this.loading=false;
        this.loading_getFreeSlots=false  
        this.showiManagerMap=false;      
        //console.log(5208,w);
        this.currentCombinations=w.payloads.allCombinations;
        this.validCombinations=w.payloads.allCombinations;    
        this.currentTables=w.payloads.allTables;    
        //console.log(5212,this.currentCombinations) 
        this.loading=false;        
        this.showManualAssignMap=true;                
    },
    async selectTable(b,v=false)
    {
        if (this.settings.level>=50)
        {
          this.showiManagerMap=false;
          this.item=b; // booking
          //console.log(5136,this.item,this.tables);
          this.hideCloseButton=v;
          this.assignedTablesId=b.tablesId||[];
          
          var pload={"bookingId":b.bookingId,"date":this.date}
          let payload={"action":"getCombinations","payload":pload};
          //console.log(968,payload)
          let w= await this.updateDB(payload)
          this.loading=false;        
          console.log(5213,w);
          this.currentCombinations=w.payloads.allCombinations;
          this.currentTables=w.payloads.allTables;
          //this.canvasAction='canvasManualAssign';
          //this.canvasBookingId=b.bookingId;
          //this.canvasSlotId=b.slotId
          //console.log(5562,this.canvasAction)
          this.dialog_selectTable=true;
        }
    },    
    async getFreeSlots(origin=null)
    {
      //console.log(5893,origin,vv)
      this.authenticated=1;
      //console.log(6036,this.booking,this.date);
      var booking=null
      if (this.selectedBooking&&this.newVolanteOrEdit=='e')
      {
        //booking.bookingId=this.selectedBooking.bookingId;
          this.selectedBooking.covers=null;
          this.selectedBooking.children=0
          //booking={...this.selectedBooking};
          booking={...this.booking};
          //booking.covers=null;
          //booking.children=0
          this.selectedBooking=null;
      }
      else
      {
          booking={...this.booking};
      }

      /*
      let booking={...this.booking};
      if (this.selectedBooking&&this.selectedBooking.bookingId)
      {
        booking.bookingId=this.selectedBooking.bookingId;
      }
      */
      delete booking.requests;
      delete booking.foodStyles;
      booking.reassign=0;
      booking.requester=origin?origin:'map';
      if (!booking.date)
      {
        booking.date=this.date;
      }
      const [year, month, day] = booking.date.split('-')
      booking.date=year.toString().length>3?booking.date: `${day}-${month}-${year}`;
      //console.log(7291,booking);
      this.loading_getFreeSlots=true;
      this.dialog_connectionError=false;
      if (!booking.locationId)
      {
        booking.locationId=this.activeLocationId||this.locations[0].locationId;
      }
      var cvrs=null;
      if(booking.covers&&booking.covers.toString().includes('+'))
      {
        cvrs=booking.covers.split('+')
        booking.covers=cvrs[0];
        if (cvrs[1]>0)
        {
          booking.children=cvrs[1];
        }
      }
      /*
      else
      {
        booking.covers="0";
      }
      */

      if (origin=='map')
      {
        console.log(5294,origin)
        booking.covers="0";
        booking.mealDuration=null;
        booking.slot=null;
        booking.slotId=null;
        booking.trackedItems=[];
        booking.tablesId=null;
        delete booking.tables;        
      }
      else
      {
        //console.log(5305,origin,'volante')
        this.isVolante=true;
      }

      //console.log(5279,booking.mealId,this.mealId,this.currentValues.mealId,this.meals,this.meals[0].mealId)
      booking.mealId=booking.mealId?booking.mealId:this.mealId?this.mealId:this.currentValues?this.currentValues.mealId:this.meals[0].mealId;
      /*
      if(this.currentValues)
      {
         booking.mealId=this.currentValues.mealId
      }
      else
      {
        booking.mealId=this.meals[0].mealId
      }
      */
      //this.saveToLocalStorage();      

      this.selectedSlot=null;
      //this.forceTableAllocation=i.unassigned;
      //this.disabledTablesId=null;
      this.booking.tablesId=[];
      this.otherBookingTablesId=null;
      //booking.mealDuration=5400;
      //console.log(7317,booking)
      

      //try{
          const payload=JSON.stringify({"payload": booking,"action":"freeTables_map_get"});
          const res = await this.$http.post('/booking/booking.php', payload );
          console.log(7309,res, new Date());
          this.loading_getFreeSlots= false;
          console.log(5224,this.activeSlotId)
          switch (res.data.errorid)
          {
            case '0':
                sessionStorage.setItem('jwt', res.data.jwt);
                //this.slotsDetails=res.data.slotsDetails;
                this.freeTables_all=res.data.payloads.freeTables;
                if(origin=='v')
                {
                  this.currentCombinations=res.data.payloads.validCombinations;
                }
                this.validCombinations=res.data.payloads.validCombinations;
                //this.activeSlotId=this.slotsDetails[0].slotId;
                //this.halls=res.data.halls;
                //this.meals=res.data.meals;

                //this.freeTables=res.data.payloads.freeTables;
                this.forceTableAllocation=res.data.payloads.forceTableAllocation;
                console.log(5338,this.forceTableAllocation)

                
                if(!this.freeTables_all)
                {
                    //this.snackbar_color='error';
                    //this.snackbar_message='No Free Tables Data';
                    //this.freeTables_all=this.tables;
                    //this.snackbar=true;                  
                }
                if (this.selectedSlotIdEdit)
                {
                  //this.booking.slotId=this.selectedSlotIdEdit;
                  this.selectedSlotIdEdit=null;

                }
                if (this.selectedLocationIdEdit)
                {
                  //this.booking.locationId=this.selectedLocationIdEdit;
                }
                /*
                else
                {
                  this.freeTables_all=res.data.payloads.freeTables;
                }*/
                //this.allRules=res.data.payloads.allRules;
                //return true;                
            break;
            case '0003':
                    this.snackbar_color='error';
                    this.snackbar_message=res.data.message;
                    this.snackbar=true;      
            break;
            case '0007':
              var responsePayload=JSON.parse(res.data.payload)
              this.errorTitle=responsePayload.errorInfo[2];
              this.errorMessage=responsePayload.xdebug_message;
              //console.log(6087,res.data.payload,this.errorMessage,this.errorTitle)
              this.dialog_connectionError=true;
            break;
            case '0006':
                this.$router.push('/auth/login').catch(() => {});
            break;
          }  
      /*} catch(e)
      {
        this.loading= false;
        this.dialog_connectionError=true;
      }*/
    },
    async open_Coupon()
    {
      //console.log(4005,this.selectedBooking)
      this.dialog_coupon=true;
      let payload=JSON.stringify({"action":"getPrizes"});
      let endpoint='/manage/manage.php';
      //console.log(4007,payload)
      let w= await this.updateDB(payload,endpoint)  
      //console.log(5082,w);
      if(w.errorid=='0')
      {
        this.prizes=w.payloads.allPrizes;
      }          
    },
    async swapTables()
    {
      //console.log(4005,this.selectedBooking)
      this.dialog_coupon=true;
      let payload=JSON.stringify({"action":"swapTables","payload":{"source":this.item.bookingId,"destination":this.swappedBooking.bookingId}});
      let endpoint='/booking/booking.php';
      //console.log(4007,payload)
      let w= await this.updateDB(payload,endpoint)  
      //console.log(5082,w);
      this.swappedBooking=null;
      if(w.errorid=='0')
      {
            this.snackbar_color="success"
            this.snackbar_message =w.message;
            this.snackbar = true;
            this.dialog_swapTables=false;
            this.dialog_selectTable=false;
            this.getData();
            this.getFreeSlots(5705);

      }          
    },    
    async sendCoupon()
    {
        //console.log(144,this.editedItem, this.selectedCoupon[0]);
        this.loading_sendCoupon=true;

        let payloads= {};
        payloads.bookingId=this.selectedBooking.bookingId;
        payloads.highRewardDescription=this.highRewardDescription
        payloads.addTripAdvisorButton=this.addTripAdvisorButton
        //ed.prizeSpent=ed.prizeSpent==''?null:ed.prizeSpent;
        payloads.prizeId=this.selectedCoupon[0].prizeId;
        
        let payload={"action":"couponSend","table":"Reviews","payload":payloads};
        //console.log(257,payload)
        let endpoint='/review/review.php';
        let w= await this.updateDB(payload,endpoint)
        this.loading_sendCoupon=false;
        //console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.snackbar_message =w.message;
            this.snackbar = true;
            this.dialog_walkIn=false;
            this.dialog_delete=false;
            this.hash=JSON.stringify(this.editedItem);
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }
        else{
            this.snackbar_color="error";
            this.snackbar_message =w.message;
            this.snackbar = true;
        }   
        //this.editedItem={...this.emptyItem}
    },    
    pages()
    {
      const w=[...new Set(this.captions.map(m=>m.page))];
      //console.log(4053,w)
      return w;
    },
    areas(page)
    {
      const w=[...new Set(this.captions.filter(c=>c.page==page).map(m=>m.area))];
      //console.log(4059,w)
      return w;
    },    
    selectAction()
    {
      //var ft=this.slotsDetails.find(f=>f.slotId==this.booking.slotId).freeTables;
      //var nbt=ft.newBookingTables;
      var actualTables=this.tables.filter(t=> this.booking.tablesId.includes(t.tableId)).map(z=>z.tableName);
      var suggestedTablesId=null;
      if(this.booking.tablesId.length===0)
      {
        suggestedTablesId=this.suggestedTablesIdDefault;
        console.log(5528,this.suggestedTablesIdDefault)
      }
      else
      {
        suggestedTablesId=this.booking.tablesId;
      }
      console.log(5517,suggestedTablesId)
      //console.log(4151,this.tables.filter(t=> this.booking.tablesId.includes(t.tableId)).map(z=>z.name));
      //console.log(4152,this.freeTables,this.booking.slotId)
      //console.log(4153,this.freeTables.find(f=>f.slotId==this.booking.slotId).freeTables.length&&!this.freeTables.find(f=>f.slotId==this.booking.slotId).assigned)
      //console.log(4154,this.freeTables.find(f=>f.slotId==this.booking.slotId).freeTables.length)
      //console.log(4155,!this.freeTables.find(f=>f.slotId==this.booking.slotId).assigned)
      //console.log(4156,this.validCombinations,this.booking,actualTables)
      ////console.log(3976,nbt.filter(e => {return b.includes(e)}).length===nbt.length)
      var w=false;
      if (this.validCombinations)
      {
        w=this.validCombinations.map(e=>e.split('-').filter(e1=>{return actualTables.includes(e1)}).length===actualTables.length).reduce((sum, next) => sum || next, false)
      }
      //if(ft.length&&nbt.filter(e=> {return actualTables.includes(e)}).length==nbt.length)
      //if(this.freeTables.find(f=>f.slotId==this.booking.slotId).freeTables.length&&!this.freeTables.find(f=>f.slotId==this.booking.slotId).assigned)
      //console.log(5052,this.booking.tablesId,this.booking.tables,nbt,w)
      if(!w)
      {
        //console.log(5055)
        this.dialog_permanentSaveWalkInWithTables=true;
        //this.saveWalkIn('',2) // salva combinazione
      }
      else
      {
        this.saveWalkIn('',1,0)
      }
    },
    async saveWalkInSlim()
    {
      //console.log(5454,this.slots)
      var payload=this.walkIn;
      payload.locationId=this.activeLocationId
      payload.hallId=this.activeHallId
      payload.slotId=this.activeSlotId
      payload.mealId=this.slots.find(s=>s.slotId==this.activeSlotId).mealId;
      payload.time=this.slots.find(s=>s.slotId==this.activeSlotId).name;
      payload.date=this.date
      payload.requester='slim'
      payload.origin='/sl'
      payload.sendWAConfirmation=0
      payload.bookingId=null
      payload.children=0
      payload.requests=[]
      payload.foodStyles=[]
      payload.lastName=payload.lastName??'WALK-IN'
      console.log(5415,payload)
      this.isWalkInSlim=true;
      this.walkIn=JSON.parse(JSON.stringify(this.walkInEmpty));
      /*
      this.snackbar_color='success';
      this.snackbar_message=payload;
      this.snackbar_timeout=10000
      this.snackbar=true;
      */
      this.booking={...payload}
      await this.saveWalkIn('',1,1)
      this.isWalkInSlim=false;

    },
    async saveWalkIn(type=null,withTables=0,saveCombination=0)
    {
      console.log(6208,type,withTables,saveCombination)
      console.log(6209,this.booking);
      this.loading_getFreeSlots=1
      let booking={...this.booking};
      var rq=this.booking.requests.filter(r=>r.value==1).map(r => r.requestId)
      var fs=this.booking.foodStyles.filter(r=>r.value==1).map(r => r.requestId)
      console.log(5568,booking,this.suggestedTablesIdDefault)
      if (booking.tablesId&&booking.tablesId.length==0)
      {
        booking.tablesId=[...this.suggestedTablesIdDefault]
        console.log(5572,booking.tablesId)
      }
      console.log(5574,booking.tablesId)
      booking.requests= rq
      booking.foodStyles=fs
      this.dialog_permanentSaveWalkInWithTables=false;

      if(!booking.locationId)
      {
        booking.locationId=this.halls.find(h=>h.hallId===booking.hallId).locationId;
      }
      //const [year, month, day] = booking.date.split('-')
      //booking.date= `${day}-${month}-${year}`
      //booking.tables='["'+this.tables.filter(t=> booking.tablesId.includes(t.tableId)).map(z=>z.name).join('-')+'"]'
      //var isToday= new Date(booking.date).setHours(0,0,0,0)== new Date().setHours(0,0,0,0)

      if (type!='wl'&&withTables>0)
      {
        //console.log(5590,this.tables,this.booking.tablesId)
        //booking.hallId=this.tables.find(t=> booking.tablesId.includes(t.tableId)).map(z=>z.hallId);
        //console.log(5592,this.tables,booking.tablesId,booking.tablesId[0])
        booking.hallId=this.tables.find(t=> booking.tablesId[0].includes(t.tableId)).hallId;
        //var z1=T.find(t=> tablesId[0].includes(t.tableId)).hallId
        booking.tables=this.tables.filter(t=> booking.tablesId.includes(t.tableId)).map(z=>z.tableName);
        booking.tablesString='"'+booking.tables.join('-')+'"';
        booking.manual=1;
        //booking.permanentCombination=withTables
        //console.log(3498,booking)
      }
      else
      {
        booking.tablesId=[];
        booking.tables=[];
      }

      
      this.loading=true;
      this.dialog_waitingListTime=false;
      
      var cvrs=null;
      if(booking.covers&&booking.covers.toString().includes('+'))
      {
        cvrs=booking.covers.split('+')
        booking.covers=cvrs[0];
        if (cvrs[1]>0)
        {
          booking.children=cvrs[1];
        }
      }
      booking.saveCombination=saveCombination;
      booking.action=withTables;
      booking.locale=this.settings.locale;
      booking.WAValidated=1;
      booking.WAConfirmed=1;
      booking.WASent=1;
      //booking.phone=booking.phone?booking.phone:'0000000000';
      booking.origin=booking.isTheFork?'/tf':!booking.phone||booking.phone=='0'?'/wi':'/ad';
      booking.volante=1;
      booking.validated=1;
      booking.waiting=0;
      if(type)
      {
        booking.waitingListTime=type?4:null;
        booking.waiting=1;
      }
      this.loading_book=true;
      var action='saveBooking';
      //let payload={"action":action,"payload":JSON.stringify(booking)}
      let payload={"action":action,"payload":booking}
      console.log(6285,payload,booking)
      let w= await this.updateDB(payload)
      //console.log(3490,w);
      this.loading=false;
      this.loading_book=false;
      this.loading_getFreeSlots=false;
      this.selectedSlotIdEdit_copy=null;
      this.selectedSlotIdEdit=null;
      this.newVolanteOrEdit='n';
      this.freeTables_all=null;
      let z= await this.getData(1666);
      if(w.errorid=='0'&&z)
      {
          //this.dialog_free_tables=false;
          //this.dialog_accomplished_message=w.message;
          //this.dialog_accomplished = true;
          this.snackbar=true;
          this.snackbar_color='success';
          this.snackbar_message=w.message;
          await this.delay(1000);
          this.dialog_walkIn=false;
          this.forceTableAllocation=0;
          this.todayBooking=null;
          this.selectedSlot=null;

          this.reset();
      }				
    },
    freeTableClassVolante(t,b=null)
    {
      //console.log(5888,t,t.tableName,this.activeSlotId,this.freeTables_all,this.assignedTablesId);
      //console.log(6267,t,b,this.freeTables_all,this.activeSlotId)
      var freeTables=b?this.freeTables_all.find(f=>f.slotId===b.slotId):this.activeSlotId?this.freeTables_all.find(f=>f.slotId===this.activeSlotId):null;
      //console.log(6269,freeTables,b,this.slots.find(s=>s.slotId==b.slotId))
      var cla='';
      var isClickable=''
      var isDisabled=false
      var isReserved=false;
      var isSuggested=false;
      //var isAssigned=false;
      if(freeTables)
      {
        isReserved=freeTables.otherBookingTablesId&&freeTables.otherBookingTablesId?.find(z=>z==t.tableId)?true:false;
        isDisabled=freeTables.disabledTablesId&&freeTables.disabledTablesId?.find(k=>k==t.tableId)?true:false;
        //isAssigned=freeTables.otherBookingDetails&&freeTables.otherBookingDetails.find(z=>z===t.tableId).isAssigned;
        //var intercepted=freeTables.otherBookingDetails&&freeTables.otherBookingDetails.find(z=>z.tableId===t.tableId)?freeTables.otherBookingDetails.find(z=>z.tableId===t.tableId):null;
        //isAssigned=intercepted&&intercepted.isAssigned==1?1:0;
        //console.log(6103,isAssigned,freeTables.otherBookingDetails,t.tableId,intercepted);
        //isClickable=(isReserved&&isAssigned)||isDisabled?' disable-events':'';
        isClickable=(isReserved)||isDisabled?' disable-events':'';
        //isClickable=(isReserved)||isDisabled?' ':'';
        //isCurrent=this.assignedTablesId.includes(t.tableId);
        //console.log(5903,b,b.tablesId)
        this.suggestedTablesIdDefault=freeTables.newBookingTablesId;
        this.enableBookWithTables=freeTables.newBookingTablesId?true:false;
        if(freeTables.newBookingTablesId&&b.tablesId&&!b.tablesId.length)
        {
          //this.booking.tablesId=freeTables.newBookingTablesId;
          isSuggested=freeTables.newBookingTablesId.includes(t.tableId);
        }
        else
        {
          //isSuggested=false
        }
        var isSelected=this.booking.tablesId&&this.booking.tablesId.includes(t.tableId)?true:false;
        cla=isDisabled?'error':isSuggested?'info':isReserved?' yellow ':isSelected?'':'success lighten-2';
        //console.log(5917,t.tableName,'disabled:',isDisabled,'reserved:',isReserved,'suggested:',isSuggested,'selected:',isSelected,'active:',this.booking.tablesId)
        //console.log(5474,freeTables.otherBookingTablesId&&freeTables.otherBookingTablesId.filter(zz=> !this.assignedTablesId.includes(zz)).find(z=>z===t.tableId))
        //console.log(5475,t.tableName,cla)
      }
      var tShape=t?t.shape:'';
      cla+=' font-weight-bold black--text table-shape-'+[tShape]+' '+isClickable;
      //console.log(5478,this.slots,b.slotId, this.slots.find(s=>s.slotId===b.slotId))
      //console.log(5479,cla)
      return cla;
    },
    freeTableClassManual(t,b=null)
    {
      var currentSlot=this.freeTables_all?.find(f=>f.slotId===b.slotId)||null;
      //console.log(6782,this.freeTables_all,currentSlot,t.name,b,b.slotId)
      //console.log(6783,this.freeTables_all.filter(x=>x.otherBookingDetails))
      if (currentSlot)
      {
      //b=this.itemS||b;
      //console.log(5541,b,this.itemS) 
      //console.log(5657,currentSlot,t,b,this.activeSlotId,this.freeTables_all,this.assignedTablesId,this.assignedTablesIdTemp);
      //const ranges=A.map(a=>({"slot":a.name,"rFrom":a.rFrom/3600,"rTo":a.rTo/3600,"duration": (a.rTo-a.rFrom)/3600}));
      //console.log(6790,this.freeTables_all,this.freeTables_all.otherBookingDetails,b,b.locationId,this.activeLocationId)
      const OBT=this.freeTables_all.filter(x=>x.otherBookingDetails).map(a=>a.otherBookingDetails.filter(y=>y.locationId==b.locationId).map(z=>
        ({"tableId":z.tableId,
          "covers":z.covers,
          "time":z.time,
          "bookingId":z.bookingId,
          "tableName":z.tableName,
          "tableString":z.tableString,
          "lastName":z.lastName,
          "reFrom":z.reFrom,
          "rFrom":z.rFrom,
          "rTo":z.rTo})
          ));      
      var B= OBT.flat().filter((tag, index, array) => array.findIndex(t => t.bookingId == tag.bookingId && t.tableId==tag.tableId) == index);
      //console.log(6803,OBT,B)
      //const Ranges=this.freeTables_all.map(a=>({"slotId":a.slotId,"slot":a.name,"rFrom":a.rFrom,"rTo":a.rTo,"duration": (a.rTo-a.rFrom)}));
      //var activeSlot=Ranges.find(r=>r.slotId==b.slotId);
      //var r=B.filter(z=>(z.rFrom<activeSlot.rTo&&z.rTo>activeSlot.rFrom)&&z.tableString!='')
      //console.log(5677,t,b,B,activeSlot,Ranges,r,this.assignedTablesIdTemp)
      /*
      
        Var1: rfrom bookingid selezionato;int
        Var2: rto bookiingid selezionato;int
        Var3: rfrom bookingid tavoli assegnati,int 
        Var4: rto bookingid tavlovi assegnati,int

        Confronto1: 0:1
        Confronto2: 0:1

        Confronto1= if Var4>Var1;0:1
        Confronto2= if Var2>Var3,0:1

        Confronto1= null if Var 1>Var3;
        Confronto2= null if Var 3>Var2;       
      */
      var sel_rFrom=b.ETA
      var sel_rTo=b.ETD;
      var tmp=B.filter(x=>x.tableId==t.tableId)
      //console.log(6827,tmp)
      var tmp2=tmp.filter(ass=>ass.tableString!='')
      //var c_0=tmp2.length&&tmp2.find(ass=>sel_rTo>ass.rFrom||sel_rFrom<ass.rTo)?1:0
      var c_1=tmp2.length&&tmp2.find(ass=>ass.rTo>sel_rFrom&&sel_rFrom>ass.rFrom)?1:0
      var c_2=tmp2.length&&tmp2.find(ass=>sel_rTo>ass.rFrom&&ass.rFrom>sel_rFrom)?1:0
      var c_5=tmp2.length&&tmp2.find(ass=>sel_rFrom==ass.rFrom)?1:0
      //var c_3=c_1&&c_2&&c_5?1:0;
      var c_4=c_1||c_2||c_5?1:0;
      var isReserved=c_4;
      //console.log(5737,t.tableName,'sel_rFrom',sel_rFrom,'sel_rTo',sel_rTo,'tmp',tmp,'tmp2',tmp2,'c_0',c_0,'c_1',c_1,'c_2',c_2,'c_5',c_5,'c_1||c_2||c_5=>isReserved',c_4,'c_1&&c_2',c_3,'???',c_0==c_4?1:0)
      var isDisabled=currentSlot.disabledTablesId&&currentSlot.disabledTablesId.find(k=>k==t.tableId)?true:false;
      //var isAssigned=r&&r.tableString!=""&&r.tableId==t.tableId?1:0;
      //var isSuggested=r&&r.tableString!=""?0:1;
      var isCurrent=this.assignedTablesId&&this.assignedTablesId.includes(t.tableId)?1:0;
      //console.log(6840,isCurrent,this.assignedTablesId,t,t.tableId)
      //var isReserved=r.find(rr=>rr.tableId==t.tableId)?1:0;
      //var isSelected=0;
      var isSuggested=tmp.find(t=>t.bookingId==b.bookingId)?1:0;
      
      var wasSelected=this.assignedTablesIdTemp&&this.assignedTablesIdTemp.includes(t.tableId)

      var isClickable=(isDisabled||isReserved)&&!isCurrent&&!wasSelected?' disable-events':'';
      
      //Disabled Suggested 20250512
      //var cla=isDisabled?'error':isSuggested?'info':isReserved&&!isCurrent&&!wasSelected?'warning lighten-3':'green lighten-1';
      //var highlightSuggested=0
      console.log(6761,this.settings.options.highlightSuggested)
      var cla=isDisabled?'error':isReserved&&!isCurrent&&!wasSelected?'warning lighten-3':isSuggested&&this.settings.options.highlightSuggested==='1'?'accent':'green lighten-1';
      console.log(6763,t.tableName,'res',isReserved,'curr',isCurrent,'sugg',isSuggested,'was',wasSelected,'click',isClickable,'cla',cla)
      cla+=' font-weight-bold black--text table-shape-'+[t.shape]+' '+isClickable;
      //console.log(6849,t.tableName,'disabled:',isDisabled,'assigned',isAssigned,'current:',isCurrent,'reserved:',isReserved,'suggested:',isSuggested,'selected:',isSelected)
      //console.log(6850,cla)
      return cla;
    }
    else
      return '';
    },
    freeTableClassManualDetails(t,b=null)
    {
      //console.log(5511,t,b,this.activeSlotId,this.freeTables_all,this.assignedTablesId);
      //console.log(5446,b.slotId)
      var template='';
      if(this.freeTables_all)
      {
        var freeTables=this.freeTables_all.find(f=>f.slotId===b.slotId)
        console.log(7018,freeTables,t,b,b.slotId,t.tableName)
        //var cla='';
        var rotate=0;
        var dIndex=null;
        //var frame=0;
        var redTime='';
        if(freeTables&&freeTables.otherBookingDetails)
        {
          var D=freeTables.otherBookingDetails.filter(o=>o.tableId==t.tableId);
          if (D)
          {
            //rotate=D.filter(d=>d.rTo<=freeTables.rFrom).length>1?1:0;
            rotate=D.length>1?1:0;

            var isN=D.filter(e=>e.rFrom<=freeTables.rFrom&&e.rTo>freeTables.rFrom).slice(-1)[0]
            var isP=D.filter(e=>e.reFrom<=freeTables.rFrom&&e.rFrom>freeTables.rFrom).slice(-1)[0]
            //var isN=D.find(e=>e.rFrom<=freeTables.rFrom&&e.rTo>freeTables.rFrom)
            //var isP=D.find(e=>e.reFrom<=freeTables.rFrom&&e.rFrom>freeTables.rFrom)

            //var dIndex=D.findIndex(d=>d.bookingId==isN.bookingId)
            console.log(5537,t.tableName,isN,isP,D)
            if (isN)
            {
              //console.log(5540,isN);
              //console.log(5541,isN.lastName,isN.covers,isN.time)
              dIndex=D.findIndex(d=>d.bookingId==isN.bookingId)
              //console.log(5635,dIndex);
              if(!isN.ATA)
              {
                  redTime='red--text';
                  //console.log(5646,redTime)
              }             
            }
            if (isP)
            {
              //console.log(5545,isP);
              //console.log(5546,isP.lastName,isP.covers,isP.time)
            }
            rotate=D.length>1&&dIndex==0?1:0;   
            //rotate=0;       
            var zz=isN?isN:isP?isP:null
            
            if (zz&&(isN?.isAssigned||isP?.isAssigned))
            {
              var rotateClass=rotate?' rotateIcon':''
              var lateClass=zz.delay>20&&rotate?'<span style="width: 1px;float: left;margin-left: 13px;padding-top: 9px;" class="lateIcon"></span>':'';
              var time=zz.ATA?'<span>'+zz.ATA.substring(11,16)+'</span>':redTime?'<span class="'+redTime+'">'+zz.time+'</span>':zz.time;
              var lastName=zz.lastName?zz.lastName.substring(0,10):'';
              //console.log(5648,zz,lastName);
              //var iconClass=rotate?'<span class="error--text text-caption"> r'+frame+'</span>':''
              if (isN?.tableString==''&&this.settings.options.highlightSuggested==='0')
                template=lateClass+'<div class="text-h6 font-weight-bold'+rotateClass+'">'+t.tableName+'</div>';
              else              
                template=lateClass+'<div class="text-h6 font-weight-bold'+rotateClass+'">'+t.tableName+'</div><div class="text-lowercase d-none d-sm-flex justify-center">'+lastName+'</div><div class="d-none d-md-flex justify-center">'+time+'-'+zz.covers+'</div>';
            }
            else
            {
              template='<div class="text-h6 font-weight-bold">'+t.tableName+'</div>';
            }
          }
          else
          {
            template='<div class="text-h6 font-weight-bold">'+t.tableName+'</div>';
          }
        }
        else
        {
          template='<div class="text-h6 font-weight-bold">'+t.tableName+'</div>';
        } 
      }
      //console.log(7084,template)
      return template;
    }, 
    freeTableClassiManager(t)
    {
      //console.log(5511,t,b,this.activeSlotId,this.freeTables_all,this.assignedTablesId);
      //console.log(5446,b.slotId)
      var cla='';
      if(this.freeTables_all)
      {
        var freeTables=this.freeTables_all.find(f=>f.slotId===this.activeSlotId)
        //console.log(6736,this.freeTables_all,freeTables)
        var isDisabled=freeTables?.disabledTablesId?.find(k=>k==t.tableId)?true:false;
        //console.log(6738,isDisabled)
        cla=isDisabled?' error ':''
        //console.log(6740,cla)
        if(freeTables&&freeTables.otherBookingDetails)
        {
          var D=freeTables.otherBookingDetails.filter(o=>o.tableId==t.tableId);
          if (D)
          {
            //console.log(5526,'slot.rFrom',freeTables.rFrom/3600,'|slot.rTo',freeTables.rTo/3600)
            //console.log(5527,D.reFrom/3600,D.rFrom/3600,D.rTo/3600)
            //console.log(5528,freeTables.rFrom,freeTables.rTo,D.reFrom,D.rFrom,D.rTo)

            const isNOW=(e)=>e.rFrom<=freeTables.rFrom&&e.rTo>freeTables.rFrom;
            var isNow=D.some(isNOW)
            var isN=D.find(e=>e.rFrom<=freeTables.rFrom&&e.rTo>freeTables.rFrom)
            const isPL=(e)=>e.reFrom<=freeTables.rFrom&&e.rFrom>freeTables.rFrom;
            var isPlaceholder=D.some(isPL)
            var isP=D.find(e=>e.reFrom<=freeTables.rFrom&&e.rFrom>freeTables.rFrom)

            //console.log(5537,isN,isP)
            if (isN)
            {
              //console.log(5540,isN);
              //console.log(5541,isN.lastName,isN.covers,isN.time)
              /*
              var dIndex=D.findIndex(d=>d.bookingId==isN.bookingId)
              if(dIndex==D.length&&!isN.ATA)
              {
                  isNow=false;
              } 
              */           
            }
            if (isP)
            {
              //console.log(5545,isP);
              //console.log(5546,isP.lastName,isP.covers,isP.time)
            }
            var zz=isN?isN:isP?isP:null;
            if (zz)
            {
              //console.log(5549,zz.lastName,zz.covers,zz.time)
            }
            //var isNow=D.rFrom<=freeTables.rFrom&&freeTables.rTo>=D.rFrom?true:false;
            //var isPlaceholder=D&&freeTables.rFrom<D.rFrom?true:false;          
            //console.log(5550,isNow,isPlaceholder)
          }
    
          //cla=isDisabled?'error':isNow?'info lighten-1':isPlaceholder?'warning lighten-3':isNow?'info lighten-1':'success lighten-2';
          cla+=isNow?'info lighten-1 disable-events':isPlaceholder?'warning lighten-2 disable-events black--text':' green ';
          cla+=' font-weight-bold  table-shape-'+[t.shape];
          
          //console.log(5552,t.tableName,'disabled',isDisabled,'placeholder',isPlaceholder,'isNow',isNow)
          //console.log(5462,freeTables.otherBookingTablesId&&freeTables.otherBookingTablesId.filter(zz=> !this.assignedTablesId.includes(zz)).find(z=>z===t.tableId))
          
          //console.log(5555,t.tableName,cla)
        }
        else
        {
          cla=isDisabled?' error disable-events':' green';
        }
        cla+=' black--text font-weight-bold table-shape-'+[t.shape];
      }
      return cla;
    },
    freeTableClassiManagerDetails(t)
    {
      //console.log(5511,t,b,this.activeSlotId,this.freeTables_all,this.assignedTablesId);
      //console.log(5446,b.slotId)
      const headingClass = this.$vuetify.breakpoint.smAndUp ? 'text-h6 font-weight-bold ' : 'font-weight-bold ';
      var template='';
      if(this.freeTables_all)
      {
        var freeTables=this.freeTables_all.find(f=>f.slotId===this.activeSlotId)
        //console.log(6926,freeTables,this.activeSlotId,t)
        //var cla='';
        var rotate=0;
        var dIndex=null;
        //var frame=0;
        var redTime='';
        if(freeTables&&freeTables.otherBookingDetails)
        {
          var D=freeTables.otherBookingDetails.filter(o=>o.tableId==t.tableId);
          if (D)
          {
            //console.log(6939,D)
            D.sort((a,b)=>a.rFrom-b.rFrom)
            //console.log(6941,D)            
            //rotate=D.filter(d=>d.rTo<=freeTables.rFrom).length>1?1:0;
            //rotate=D.length>1?1:0;

            var isN=D.filter(e=>e.rFrom<=freeTables.rFrom&&e.rTo>freeTables.rFrom).slice(-1)[0]
            var isP=D.filter(e=>e.reFrom<=freeTables.rFrom&&e.rFrom>freeTables.rFrom).slice(-1)[0]
            //var isN=D.find(e=>e.rFrom<=freeTables.rFrom&&e.rTo>freeTables.rFrom)
            //var isP=D.find(e=>e.reFrom<=freeTables.rFrom&&e.rFrom>freeTables.rFrom)

            //var dIndex=D.findIndex(d=>d.bookingId==isN.bookingId)
            //console.log(5537,isN,isP)
            if (isN)
            {
              //console.log(5540,isN);
              //console.log(5541,isN.lastName,isN.covers,isN.time)
              dIndex=D.findIndex(d=>d.bookingId==isN.bookingId)
              //console.log(5635,dIndex);
              if(!isN.ATA)
              {
                  redTime='red--text';
                  //console.log(5646,redTime)
              }             
            }
            if (isP)
            {
              //console.log(5545,isP);
              //console.log(5546,isP.lastName,isP.covers,isP.time)
            }
            rotate=D.length>1&&dIndex==0?1:0;          
            var zz=isN?isN:isP?isP:null
            
            if (zz)
            {
              var rotateClass=this.$vuetify.breakpoint.smAndUp &&rotate ? 'rotateIcon' : '';
              //var rotateClass=rotate?' rotateIcon':''
              var lateClass=zz.delay>20&&rotate&&this.$vuetify.breakpoint.smAndUp?'<span style="width: 1px;float: left;margin-left: 13px;padding-top: 9px;" class="lateIcon"></span>':'';
              var time=zz.ATA?'<span>'+zz.ATA.substring(11,16)+'</span>':redTime?'<span class="'+redTime+'">'+zz.time+'</span>':zz.time;
              var lastName=zz.lastName?zz.lastName.substring(0,10):'';
              //console.log(5648,zz,lastName);
              //var iconClass=rotate?'<span class="error--text text-caption"> r'+frame+'</span>':''
              template=lateClass+'<div class="'+headingClass+rotateClass+'">'+t.tableName+'</div><div class="text-lowercase d-none d-sm-flex justify-center">'+lastName+'</div><div class="d-none d-md-flex justify-center">'+time+'-'+zz.covers+'</div>';
            }
            else
            {
              template='<div class="'+headingClass+'">'+t.tableName+'</div>';
            }
          }
          else
          {
            template='<div class="'+headingClass+'">'+t.tableName+'</div>';
          }
        }
        else
        {
          template='<div class="'+headingClass+'">'+t.tableName+'</div>';
        } 
      }
      //console.log(7084,template)
      return template;
    },        
    freeTableClassVolanteDetails(t,b=null)
    {
      //console.log(5511,t,b,this.activeSlotId,this.freeTables_all,this.assignedTablesId);
      //console.log(5446,b.slotId)
      var freeTables=this.freeTables_all.find(f=>f.slotId===b.slotId)
      //console.log(5514,freeTables)
      //var cla='';
      var rotate=0;
      var dIndex=null;
      //var frame=0;
      var redTime='';
      if(freeTables&&freeTables.otherBookingDetails)
      {
        var D=freeTables.otherBookingDetails.filter(o=>o.tableId==t.tableId);
        //console.log(6846,'D',D,t.name)
        if (D)
        {
          //rotate=D.filter(d=>d.rTo<=freeTables.rFrom).length>1?1:0;
          rotate=D.length>1?1:0;

          var isN=D.filter(e=>e.rFrom<=freeTables.rFrom&&e.rTo>freeTables.rFrom).slice(-1)[0]
          var isP=D.filter(e=>e.reFrom<=freeTables.rFrom&&e.rFrom>freeTables.rFrom).slice(-1)[0]
          //var isN=D.find(e=>e.rFrom<=freeTables.rFrom&&e.rTo>freeTables.rFrom)
          //var isP=D.find(e=>e.reFrom<=freeTables.rFrom&&e.rFrom>freeTables.rFrom)

          //var dIndex=D.findIndex(d=>d.bookingId==isN.bookingId)
          //console.log(6858,isN,isP)
          if (isN)
          {
            //console.log(5540,isN);
           // console.log(5541,isN.lastName,isN.covers,isN.time)
            dIndex=D.findIndex(d=>d.bookingId==isN.bookingId)
            //console.log(5635,dIndex);
            if(!isN.ATA)
            {
                redTime='red--text';
                //console.log(5646,redTime)
            }             
          }
          if (isP)
          {
            //console.log(5545,isP);
            //console.log(5546,isP.lastName,isP.covers,isP.time)
          }
          rotate=D.length>1&&dIndex==0?1:0;          
          var zz=isN?isN:isP?isP:null
          var template='';
          //console.log(6910,zz)
          if (zz)
          {
            var rotateClass=rotate?' rotateIcon':''
            var lateClass=zz.delay>20&&rotate?'<span style="width: 1px;float: left;margin-left: 13px;padding-top: 9px;" class="lateIcon"></span>':'';
            var time=zz.ATA?'<span>'+zz.ATA.substring(11,16)+'</span>':redTime?'<span class="'+redTime+'">'+zz.time+'</span>':zz.time;
            var lastName=zz.lastName?zz.lastName.substring(0,10):'';
            //console.log(5648,zz,lastName);
            //var iconClass=rotate?'<span class="error--text text-caption"> r'+frame+'</span>':''
            template=lateClass+'<div class="text-h6 font-weight-bold'+rotateClass+'">'+t.tableName+'</div><div class="text-lowercase d-none d-sm-flex justify-center">'+lastName+'</div><div class="d-none d-md-flex justify-center">'+time+'-'+zz.covers+'</div>';
          }
          else
          {
             template='<div class="text-h6 font-weight-bold">'+t.tableName+'</div>';
          }
        }
        else
        {
          template='<div class="text-h6 font-weight-bold">'+t.tableName+'</div>';
        }
      }
      else
      {
        template='<div class="text-h6 font-weight-bold">'+t.tableName+'</div>';
      } 
      //console.log(5612,template)
      return template;
    },
    freeTableClassAuto(t,b=null)
    {
      //console.log(5445,t,t.shape,this.activeSlotId,this.freeTables_all,this.disabledTables,this.tablesAssigned,this.tablesAssignedDetailed);

      var isDisabled=this.disabledTables.includes(t.tableId)||t.inactive
      var isReserved=this.tablesAssigned.includes(t.tableId)
      var cla=isDisabled?'error':isReserved?'':'success lighten-2';
      cla+=' disable-events font-weight-bold black--text table-shape-'+[t.shape]
      console.log(5542,t.tableName,cla)
      return cla;
    },
    close_dialog_walkIn()
    {
      console.log(7049)
      this.dialog_walkIn=false;
      this.loading=false;
      this.loading_getFreeSlots=false;
      this.showManualAssignMap=false;
      this.showiManagerMap=false;      
      /*
      this.booking.bookingId=null
      this.booking.active=false;
      this.booking.covers=null;
      this.booking.mealId=null;
      this.booking.locationId=null;
      this.booking.slot=null;
      this.booking.firstName=null;
      this.booking.postalCode=null;
      this.booking.birthdate=null;
      this.booking.lastName=null;
      this.booking.mealDuration=null
      this.booking.phone=null;
      this.booking.postalCode=null;
      this.booking.birthdate=null;
      this.booking.bookingId=null      
      this.booking.tablesId=[];
      */
      this.booking.requests.map(m=>m.value=0);
      this.booking.foodStyles.map(m=>m.value=0);
      this.todayBooking=null;
      this.userDetails=null;
      this.selectedSlotIdEdit=null;
      this.selectedSlotIdEdit_copy=null;
      this.refreshTrigger=!this.refreshTrigger;
      this.newVolanteOrEdit='n';
      this.walkIn.tablesId=[];

      this.freeTables_all=null;
      this.userDetails=null;
      this.reset();
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}-${month}-${year}`
    },
    processSlot(i)
    {
      var id=this.utf8_to_b64(this.booking.phone+Date.now());
      console.log(5150,i,id);
      this.selectedSlot=i;
      this.selectedSlotId=i.slotId
      //console.log(5153,this.selectedSlotId);
      //this.forceTableAllocation=i.unassigned;
      
      this.showPrepayment=i.prepayment;
      this.paymentRequired=i.prepayment;
      this.disabledTablesId=i.disabledTablesId;
      this.booking.tablesId=i.newBookingTablesId?i.newBookingTablesId:[];
      this.otherBookingTablesId=i.otherBookingTablesId;
    },
    utf8_to_b64(str) {
      return window.btoa(encodeURIComponent(str));
    },
    async confirmWABooking(confirmed)
    {
        console.log(2877,confirmed,this.booking,this.confirmBookingDetails)
        const WAAction=this.confirmBookingDetails.waiting?(confirmed?'booking_confirmed_from_wl':'booking_denied'):(confirmed?'booking_confirmed':'booking_denied')
        const payload=JSON.stringify({"action":"confirmWaitingListOrManuallyConfirmBooking","payload":{"bookingId": this.confirmBookingDetails.bookingId,"status":confirmed,"WAAction":WAAction,"reservation":this.confirmBookingDetails}})
        const res = await this.$http.post('/booking/booking.php', payload );
        this.loading_checkUser= false;
        this.dialog_confirmWABooking=false;
        this.dialog_confirmConfirm=false;
        switch (res.data.errorid)
        {
          case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              this.confirmBookingDetails=res.data.payloads;
              //console.log(2698,res.data.payloads)
              this.snackbar=true;
              this.snackbar_color='success'
              this.snackbar_message=res.data.message;
              this.getData(3448)
              this.dialog_confirmWABooking=false;
              this.dialog_confirmConfirm=false;
              //return true;
          break;
          case '0007':
            var responsePayload=JSON.parse(res.data.payload)
            this.errorTitle=responsePayload.errorInfo[2];
            this.errorMessage=responsePayload.xdebug_message;
            //console.log(1834,res.data.payload,this.errorMessage,this.errorTitle)
            this.dialog_connectionError=true;
          break;
          case '0006':
              this.$router.push('/auth/login').catch(() => {});
          break;
          case '00014':
              this.snackbar=true;
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.dialog_confirmWABooking=false;
              this.dialog_confirmConfirm=false;              
          break;
        }  
    },
    dialog_userDetailsClose()
    {
      this.dialog_userDetails=false;
      this.userDetails=null;
      this.todayBooking=null;
      //this.booking.lastName=null;
      //this.booking.firstName=null;
    },
    lockAutoAssignment()
    {
      this.autoAssignLocked=!this.autoAssignLocked
    },
    async openWaitingList(item)
    {
      //console.log(2685,this.booking.date,item);
      //this.dialog_confirmWABooking=true;
      //this.loading_checkUser=true;
      //try{
          const payload=JSON.stringify({"action":"confirmBookingDetails","payload":{"bookingId": item.bookingId}});
          const res = await this.$http.post('/booking/booking.php', payload );
          this.loading_checkUser= false;
          switch (res.data.errorid)
          {
            case '0':
                sessionStorage.setItem('jwt', res.data.jwt);
                this.confirmBookingDetails=res.data.payloads;
                this.confirmBookingDetails.bookingId=item.bookingId;
                //this.confirmBookingDetails.bookingId=item.bookingId;
                //this.checkedPhone=res.data.payloads.cnt;
                //console.log(2698,this.confirmBookingDetails)
                this.dialog_confirmWABooking=true;
                //return true;
            break;
            case '0007':
              var responsePayload=JSON.parse(res.data.payload)
              this.errorTitle=responsePayload.errorInfo[2];
              this.errorMessage=responsePayload.xdebug_message;
              //console.log(1834,res.data.payload,this.errorMessage,this.errorTitle)
              this.dialog_connectionError=true;
            break;
            case '0006':
                this.$router.push('/auth/login').catch(() => {});
            break;
          }  
      /*} catch(e)
      {
        //this.loading= false;
      }*/
    },     
    async checkPhoneNumber(item, origin='a'){
      console.log(7389,this.booking.date,item,origin);
      this.loading_checkUser=true;
      this.todayBooking=null;
      //try{
          const payload=JSON.stringify({"action":"checkPhoneNumber","payload":{"phone": item,"countryCode":this.booking.countryCode,"requester":origin}});
          const res = await this.$http.post('/booking/booking.php', payload );
          this.loading_checkUser= false;
          console.log(7032,res)
          switch (res.data.errorid)
          {
            case '0':
                sessionStorage.setItem('jwt', res.data.jwt);
                if(origin=='a')
                {
                  this.userDetails=res.data.payloads;
                  console.log(7485,res.data.payloads.history,this.booking)
                  this.todayBooking=res.data.payloads.history.find(h=>h.active==true&&h.date==this.booking.date)
                // this.todayBooking=this.todayBooking.bookingId==this.booking.bookingId?null:this.todayBooking
                  if (this.todayBooking)
                  {
                    this.todayBooking.fullName=this.userDetails.fullName;
                    this.todayBooking=this.todayBooking.bookingId==this.booking.bookingId?null:this.todayBooking
                  }
                  this.checkedPhone=1;//res.data.payloads.cnt;
                  this.booking.lastName=res.data.payloads.lastName
                  this.booking.firstName=res.data.payloads.firstName
                  this.booking.postalCode=res.data.payloads.postalCode
                  this.booking.birthdate=res.data.payloads.birthdate
                  
                  console.log(6745,this.booking.lastName,this.booking)
                }
                else
                {
                  console.log(7058,res.data.payloads.lastName)
                  this.$set(this.walkIn, 'lastName', res.data.payloads.lastName)
                  this.$set(this.walkIn, 'firsName', res.data.payloads.firstName)
                }
                //return true;
            break;
            case '0011':
              /*
              this.snackbar_color='warning'
              this.snackbar_message='Nessun Dato';
              this.snackbar=true;
              this.booking.firstName=null;
              this.booking.lastName=null;
              this.booking.postalCode=null;
              this.booking.birthdate=null;
              this.booking.countyCode='39'
              this.booking.remarks=null
              */
            break;
            case '0007':
              var responsePayload=JSON.parse(res.data.payload)
              this.errorTitle=responsePayload.errorInfo[2];
              this.errorMessage=responsePayload.xdebug_message;
              //console.log(1834,res.data.payload,this.errorMessage,this.errorTitle)
              this.dialog_connectionError=true;
            break;
            case '0006':
                this.$router.push('/auth/login').catch(() => {});
            break;
          }
          /*  
      } catch(e)
      {
        //this.loading= false;
      }*/
    },    
    async disableDirectBooking()
    {
      
      var table='User_Options';
      var field='disableSameDayDirectBooking';
      
      //this.settings.options.disableSameDayDirectBooking=0;//this.settings.options.disableSameDayDirectBooking=='0'?'1':'0';
      var vv=this.settings.options.disableSameDayDirectBooking;
      console.log(4362,vv);
      this.settings.options.disableSameDayDirectBooking=this.settings.options.disableSameDayDirectBooking==this.dsddb?'0':this.dsddb;
      var vl=this.settings.options.disableSameDayDirectBooking;
      console.log(4363,vl);
      var pload={"optionId":field,"value":vl};  
      //console.log(4364,pload);
      var action='saveItem';
      let payload={"action":action,"table":table,"payload":pload};
      //console.log(4367,payload)
      let rspns= await this.updateDB(payload,'/settings/settings.php')
      this.$store.dispatch("setDisableSameDayDirectBooking", vl);
      console.log(4390,rspns)
      this.dialog_DirectBookingLock=false;
      this.dialog_disableTable=false;
    },
    showCancelledBooking()
    {
      this.showCancelled=!this.showCancelled;
    },
    allowedDates(a) {
      return val => ![a].includes(new Date(val).getDay());
    },
    setCovers(c)
    {
      //console.log(1497,c,this.booking.covers);
      if(c=='C')
      {
        this.booking.covers='';
        this.booking.children=0;
      }
      else
      {
        this.booking.covers=this.booking.covers===null?'':this.booking.covers;
        ////console.log(1505,c,this.covers);
        this.booking.covers+=c.toString();
        ////console.log(1507,c,this.covers);
      }
       this.booking.covers=parseInt(this.booking.covers)>this.max_bookable?this.max_bookable:this.booking.covers;
    },      
    locationDescription(l)
    {
      if (!this.booking.slotId)
      {
        return l.name;//location.name
      }
      else
      {
        console.log(5558,l,this.booking)
        //var z=l.tables.find(t=>t.slotId==this.booking.slotId)
        //console.log(3987,z);
        //return l.name+'<br># ' + (z.availableTables-z.usedTables) +'/'+ z.availableTables;
        return l.name;
      }
    },
    openDialogHelp(h)
    {
      this.helpType=h;
      this.dialog_walkInHelp=true;
    },
    openDialogDetails(item)
    {
      this.checkPhoneNumber(item.phone,'a');
      this.dialog_userDetails=true;
    },
    selectedBookingHasChanged()
    {
      var hasChanged=JSON.stringify(this.selectedBooking)!==this.selectedBooking_hash;
      ////console.log(4365, hasChanged)
      return hasChanged;
    },
    openDialogCoupon(item)
    {
      console.log(6497,item)
      this.couponDetails=JSON.parse(JSON.stringify(item));
      //console.log(6499,this.selectedBooking)
      this.dialog_coupon_details=true
    },
    openDialogEdit(item)
    {
      //if (this.settings.level>50)
      {
        //console.log(3455,item,this.requests);
        //console.log(3455,this.requests,this.foodStyles)
        //this.selectedBooking_hash=JSON.stringify(item);
        var i=JSON.parse(JSON.stringify(item));
        //i.sendWAConfirmation=1;
        i.requests=this.requests.map(el => { i.requests.some(rr=>rr==el.requestId)?el.value=true:el.value=false; return el} )
        i.foodStyles=this.foodStyles.map(fs => { i.foodStyles.some(fss=>fss==fs.requestId)?fs.value=true:fs.value=false; return fs} )
        this.selectedBooking_hash=JSON.stringify(i);
        console.log(6836,i)
        this.editVolante(i)
        /*
        this.selectedBooking=JSON.parse(JSON.stringify(item));
        this.selectedBooking.sendWAConfirmation=1;
        //console.log(3457,this.selectedBooking);
        this.selectedBooking.requests=this.requests.map(el => { this.selectedBooking.requests.some(rr=>rr==el.requestId)?el.value=true:el.value=false; return el} )
        //console.log(3459,this.selectedBooking,this.selectedBooking.requests);
        this.selectedBooking.foodStyles=this.foodStyles.map(fs => { this.selectedBooking.foodStyles.some(fss=>fss==fs.requestId)?fs.value=true:fs.value=false; return fs} )
        this.selectedBooking_hash=JSON.stringify(this.selectedBooking);
        this.editVolante(this.selectedBooking)
        */
      }
    },
    startResetTables(option)
    {
      //console.log(2223,this.oldLocationId)
      if (this.selectedBooking.tables&&this.selectedBooking.tables.length>0)
      {
        this.resetOption=option;
        switch(option)
        {
          case 'location':
            this.resetText='Area'
          break;
          case 'slot':
            this.resetText='Slot'
          break;
          case 'mealDuration':
            this.resetText='Durata Pasto'
          break;
          case 'covers':
            this.resetText="Coperti"
          break;
          case 'children':
            this.resetText="Bambini"
          break;
        }
        this.dialog_resetTables=true;
      }
      else{
        //console.log(967)
      }
    },
    abortResetTables()
    {
      switch(this.resetOption)
      {
        case 'location':
          this.selectedBooking.locationId=this.oldLocationId[1]
        break;
        case 'slot':
          this.selectedBooking.slotId=this.oldSlotId[1]
        break;
        case 'mealDuration':
          this.selectedBooking.mealDuration=this.oldMealDuration[1]
        break;
        case 'covers':
          this.selectedBooking.covers=this.oldCovers[1]
        break;
        case 'children':
          this.selectedBooking.children=this.oldChildren[1]
        break;
      }
      this.dialog_resetTables = false;
    },
    resetTables()
    {
      //console.log(2234,this.oldLocationId)
      
      console.log(6757,JSON.stringify(this.selectedBooking))
      //this.selectedBooking.tables.map( b => delete this.tables.find(t =>t.tableName===b).details)
      this.selectedBooking.tables=null;
      this.selectedBooking.tablesId=null;
      this.selectedBooking.manualAssignement=false;
      this.selectedBooking.AIAssigned=false;
      ////console.log(973,this.selectedBooking,this.bookings,this.tables);
      this.dialog_resetTables=false;
    },

    async openDialog_DisableTables(b,v=false)
    {
        if (this.settings.level>=50)
        {
          this.showiManagerMap=false;
          this.showManualAssignMap=false;
          this.item=b; // booking
          //console.log(5672,this.item,this.tables);
          this.hideCloseButton=v;
           
          var pload={bookingId:null,date:this.date}
          let payload={"action":"getCombinations","payload":pload};
          //console.log(5678,payload)
          let w= await this.updateDB(payload)
          this.loading=false;        
          //console.log(5681,w);
          this.currentTables=w.payloads.allTables;
          this.canvasAction='canvasDisableTables';
          //console.log(5684,this.canvasAction)
          this.dialog_disableTable=true;
        }
    },    
    assignTables(assignedTablesId)
    {
        console.log(5829,this.tables,assignedTablesId);
        this.tablesId=assignedTablesId;
        ////console.log(953,tablesId.map(t => this.tables[t-1].name))
        //this.tablesList=tablesId.map(t => this.tables[t-1].name).join(', ');
        //this.tablesList=assignedTablesId.map(t => this.tables.find(ta => ta.tableId===t).name).join(', ')
        this.tablesList=assignedTablesId.map(t => this.tables.find(ta => ta.tableId===t).tableName).join('-')
        //console.log(4107,this.tablesList,this.tablesId,assignedTablesId);
    },
    async assignTablesSave(saveCombination=0,combinationOnly=0)
    {
      var cToAdd=this.tablesList.split('-')
      console.log(6775,this.item,cToAdd,this.allCombinations,this.tablesList,this.currentTables,this.currentCombinations)
      //var chooseHall=this.currentCombinations.find(c=>c.)
      var newCombination=0;
      if (this.currentCombinations&&cToAdd[0])
      {
        //console.log(5168,cToAdd,this.currentCombinations,this.currentTables)
        let hallId=this.currentTables.find(t=>t.tableName===cToAdd[0].split('-')[0]).hallId;
        let validCombinations=this.currentCombinations.find(c=>c.hallId===hallId).c
        console.log(6782,hallId)
        var max=0;
        var cnt=0;
        var c1=''
        var n1='';
        var cl=0;
        var ctl=0;
        //var xs=0;
        console.log(6790,validCombinations)
        if(validCombinations)
        {
          validCombinations.forEach((c)=>
          {
            cnt=0;
            cl=c.split('-').length;
            cToAdd.forEach(n=>{
              ctl=n.split('-').length
              //console.log(5225,cl,ctl,n,c)
              //if( cl===ctl)
              {
                n1='-'+n+'-';
                c1='-'+c+'-';
                //console.log(5230,n1,c1,(c1).includes((n1))*1)
                
                //if( cl===ctl)
                {
                  cnt+=(c1).includes((n1))
                }
              }
            });
            //console.log(5231,cl,cToAdd.length,ctl)
            if(cl==cToAdd.length)
            {
              max=Math.max(max,cnt)
            }
            //console.log(5234,max,cnt)
          })
        }
        ////console.log(max)
        //console.log(854,cToAdd.length,max,'add?')
        if ((cToAdd.length>max||!validCombinations))
        {
          //console.log('add')
          newCombination=1
        }
        else
        {
          //console.log('noAdd')
          newCombination=0
        }
      }
      //var isSaveCombination=newCombination?1:0; //2 =>saves tableCombination
      console.log(6840,newCombination,this.tablesList)
      if (newCombination&&!saveCombination&&this.tablesList&&!combinationOnly)//if not set saveCombination open popup
      //if (1==2)
      {
        this.dialog_saveCombination=true;
      }
      else
      {
        this.loading=true;
        //console.log(7058,this.item)
        //console.log(1744,this.assignedTablesId,this.tablesList);
        //this.item.tables=this.tablesId.map(t => this.tables[t-1].name);
        ////console.log(1608,JSON.stringify(this.item));
        this.item.tables=this.assignedTablesId.map(t => this.tables.find(ta => ta.tableId===t).tableName);
        console.log(5966,this.assignedTablesId,this.tables)
        var pload={date:this.date,userid:this.item.userId,bookingId:this.item.bookingId,tablesId:this.assignedTablesId,tables:this.item.tables,manual:1,covers:this.item.covers,children:this.item.children,tablesList:this.tablesList,saveCombination:Math.max(newCombination,saveCombination)}
        console.log(7065,pload)
        let payload={"action":"assignTables","payload":pload};
        //console.log(968,payload)
        let w= await this.updateDB(payload)
        this.loading=false;
        this.dialog_saveCombination=false;
        //////console.log(940,w);
        let z= await this.getData(1597);
        //let z= await this.getFreeSlots()
        if(w.errorid=='0'&&z)
        {
            this.dialog_selectTable = false;
            this.snackbar=true;
            this.snackbar_color='success'
            this.snackbar_message=w.message;
            //this.dialog_accomplished_message=w.message;
            //this.dialog_accomplished = true;
        }
        this.activeLocationId=null;
        this.activeHallId=null
          //this.assignedTablesId=[];
        //this.showManualAssignMap=false;
        this.showiManagerMap=false;
        console.log(6329,this.reopeniManagerMap,this.showiManagerMap,this.currentCombinations)
        if (this.reopeniManagerMap)
        {
          //this.showiManagerMap=true;
          console.log(6333,this.reopeniManagerMap,this.showiManagerMap)
        }
      }
    },
    md5(d)
    {
      var MD5=function(d){var r = M(V(Y(X(d),8*d.length)));return r.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_}
      console.log(6540,MD5)
      return MD5;
    },
    async deleteBooking(action='deleteBooking')
    {
      this.loading=true
      ////console.log(1006,this.selectedBooking);
      let payload={"action":action,"payload":JSON.stringify({"bookingId":this.booking.bookingId,"sendWAConfirmation":this.booking.sendWAConfirmation/1,"volante":1})};
      //console.log(1008,payload)
      let w= await this.updateDB(payload)
      ////console.log(1010,w);
      this.loading=false;     
      this.dialog_walkIn=false; 
      this.dialog_confirmDelete=false;
      let z= await this.getData(1688);
      if(w.errorid=='0'&&z)
      {
        //this.dialog_accomplished_message=w.message;            
        //this.dialog_accomplished = true;
        this.snackbar=true;
        this.snackbar_color='success'
        this.snackbar_message=w.message;
      }	
      this.newVolanteOrEdit='n'
      //this.reset();
      this.close_dialog_walkIn()
    },
    preUpdateBooking()
    {
        if (this.selectedBooking.waiting&&this.dialog_unconfirmed_booking_opened==false)
        {
          //this.selectedBooking.sendWAConfirmation=false;
          this.dialog_unconfirmed_booking=true;
          this.dialog_unconfirmed_booking_opened=true;
        }
        else
        {
          this.dialog_unconfirmed_booking_opened=false;
          this.updateBooking();
        }
    },
    async saveNewCombination()
    {
      console.log(7516,this.newCombination,this.selectedBooking.locationId,this.oldCovers[0]+this.oldChildren[0],this.tablesList)
      //const w=this.assignTablesSave(1,2) // save OnlyCombination
      var pload={tablesString:this.tablesList,locationId:this.selectedBooking.locationId, tablesId:this.assignedTablesId,covers:(this.oldCovers[0]+this.oldChildren[0])}
      let payload={"action":"createNewCombination","payload":pload};
      //console.log(968,payload)
      let w= await this.updateDB(payload)
      console.log(7518,w)
      switch (w.errorid)
      {
        case '0':
          if(w.message=='1')
          {
            this.snackbar_color='success';
            this.snackbar_message='Combinazione Salvata';
            this.snackbar=true;
            this.updateBooking();
          }
          else
          {
            this.snackbar_color='warning';
            this.snackbar_message='Salvate + combinazioni: segnalare evento';
            this.snackbar=true; 
            this.updateBooking();           
          }
        break;
        default:
            this.snackbar_color='error';
            this.snackbar_message='Combinazione NON Salvata';
            this.snackbar=true;          
      }
      this.dialog_createCombination=0
    },
    async checkIfCombinationExists()
    {
        console.log(7434,this.oldCovers,this.oldChildren,this.selectedBooking,this.savedTotalCovers)
        var newCovers=this.oldCovers[0]+this.oldChildren[0];
        
        if(this.savedTotalCovers!=newCovers)
        {
          var pload={"bookingId":this.selectedBooking.bookingId,"date":this.date,"covers":newCovers}
          let payload={"action":"getCombinations","payload":pload};
          //console.log(968,payload)
          let w= await this.updateDB(payload)
          console.log(7443,w)
          var combinationExists=w.payloads.allCombinations&&w.payloads.allCombinations.find(c=>c.locationId==this.selectedBooking.locationId).c;
          this.currentTables=w.payloads.allTables; 
          console.log(7445,combinationExists)
        
          if(!combinationExists)
          {
            //halls.filter(h=>h.locationId==selectedBooking.locationId
            console.log(7524,this.halls, this.selectedBooking.locationId)
            this.dialog_createCombination=1
            
          }
          else
          {
            this.updateBooking()
          }
        }
        else
        {
          this.updateBooking()
        }
    },
    async updateBooking()
    {
        //this.snackbar_confirm_cancellation = true
        this.loading_edit=true;
        this.dialog_unconfirmed_booking_opened=false;
        //console.log(5598,this.selectedBooking,this.booking.requests,this.booking.foodStyles)
        let booking={...this.booking};
        var rq=this.booking.requests.filter(r=>r.value==1).map(r => r.requestId)
        var fs=this.booking.foodStyles.filter(r=>r.value==1).map(r => r.requestId)
        
        booking.requests= rq
        booking.foodStyles=fs
        booking.volante=1
        /*
        ////console.log(2196,JSON.stringify(this.selectedBooking));
        this.selectedBooking.requests=this.selectedBooking.requests.filter(r=>r.value==1).map(r => r.requestId)
        this.selectedBooking.foodStyles=this.selectedBooking.foodStyles.filter(r=>r.value==1).map(r => r.requestId)
        this.selectedBooking.volante=1;
        //console.log(2198,JSON.stringify(this.selectedBooking));
        */
        let payload={"action":"updateBooking","payload":booking};
        //console.log(1142,payload)
        let w= await this.updateDB(payload)
        ////console.log(1144,w);
        this.selectedBooking_hash=JSON.stringify(this.booking);
        this.loading_edit=false;
        this.dialog_confirmConfirm=false;
        //if(!this.dialog_unconfirmed_booking)
        {
          this.dialog_walkIn=false;
        }
        this.dialog_unconfirmed_booking=false;

        let z= await this.getData(1710);
        console.log (1147,w,z)
        this.reset();
        if(w.errorid=='0'&&z)
        {
            
            //this.dialog_accomplished_message=w.message;
            //this.dialog_accomplished = true;
            this.snackbar=true;
            this.snackbar_color='success'
            this.snackbar_message=w.message;
        }
        ////console.log(1157,this.selectedBooking.tables)
        if (this.booking.tables&&this.booking.tables.length>0)
        {
          ////console.log(1160,this.selectedBooking);
          //this.assignedTablesId=[];
          this.selectTable(this.booking,true)
        }
    },
    async reviewRequest()
    {
      //console.log(4005,this.selectedBooking)
      this.loadingReviewRequest=true;
      let payload=JSON.stringify({"action":"reviewRequest","bookingId":this.booking.bookingId});
      //console.log(4007,payload)
      let w= await this.updateDB(payload)  
      if(w.errorid=='0')
      {
        this.snackbar_color='success'
        this.snackbar_message=w.message;
        this.snackbar=true;
      }
      this.loadingReviewRequest=false
    },
    async changeStatus(item,action,WA=0)    
    {
      //console.log(3236,item,action)
      this.loadingChangeStatus=true
      this.refreshTrigger=!this.refreshTrigger;
      if ( this.settings.level>=50)
      {
        if(action=='gone'&&this.settings.options.billAmountRequired=='1'&&!item.billAmount)
        {
          //console.log(3241,'here')
          this.item=item;
          //this.item.trackedItems=[];
          //console.log(3555,this.item)
          this.dialog_enterBillAmount=true;
        }
        else
        {
          item.sendWAConfirmation=0;
          console.log(7873,this.item,this.selectedBooking,item);
          if(WA==1)
          {
            item.sendWAConfirmation=this.selectedBooking&&this.selectedBooking.sendWAConfirmation?this.selectedBooking.sendWAConfirmation:(this.item&&this.item.sendWAConfirmation?this.item.sendWAConfirmation:0);
            item.sendWAConfirmation=1
            this.sendWAConfirmationModel=1;
          }

          let payload=JSON.stringify({"action":action,"payload":item});
          console.log(7879,payload)
          let w= await this.updateDB(payload)
          this.loadingChangeStatus=false;
          let z= await this.getData(1779);
          //console.log (1321,z,w.errorid,w.message)
          this.dialog_walkIn=false;
          this.reset();
          //this.close_dialog_walkIn();
          if(w.errorid=='0'&&z==true)
          {
            this.snackbar_color='success'
            this.snackbar_message=w.message;
            this.snackbar=true;
            this.dialog_enterBillAmount=false;
            this.getFreeSlots(7544);
          }
        }
      }
    },
    async openDialog_autoAssign()
    {
      this.tablesAssigned=[];
      
      if(!this.currentTables)
      {
        var pload={bookingId:null,date:this.date}
        let payload={"action":"getCombinations","payload":pload};
        //console.log(968,payload)
        let w= await this.updateDB(payload)
        this.loading=false;        
        //console.log(5141,w);
        this.currentCombinations=w.payloads.allCombinations;
        this.currentTables=w.payloads.allTables;
      }      
      this.dialog_autoAssign=true;
    },
    closeDialog_autoAssign()
    {
      //console.log(4419,'closeDialog_AutoAssign')
      this.loading_simulate=false;
      this.unassignedReservations=[];
      this.assignedHalls=null;
      //this.tablesAssigned=null;
      this.loading_set=false;
      this.dialog_autoAssign = false;
    }, 
    async openDialog_disableTable()
    {
      //this.disabledTables=this.tables.filter(t => t.status!==null).id
      //this.disabledTables=this.tables.filter(t => (t.isDisabled!==null||t.inactive==1)&&t.name ).map(t => t.tableId)
      this.previousDisabledTables=[...this.disabledTables];
      this.disabledTables_hash=JSON.stringify(this.disabledTables)
      ////console.log(1364,this.disabledTables)
      if(!this.currentTables)
      {
        var pload={bookingId:null,date:this.date}
        let payload={"action":"getCombinations","payload":pload};
        //console.log(968,payload)
        let w= await this.updateDB(payload)
        this.loading=false;        
        //console.log(5141,w);
        this.currentCombinations=w.payloads.allCombinations;
        this.currentTables=w.payloads.allTables;
      }
      this.dialog_disableTable=true;
    }, 

    disableTable(t)
    {
        ////console.log(1832,t,i,this.disabledTables);
        if (t.length)
        {
          this.disabledTables.map(t => this.tables.find(ta => ta.tableId===t).isDisabled!=null);
          //this.tables.find(ta => ta.tableId===t.tableId).status='unavailable'
          //this.disabledTablesName.push(t.name);
        }
        ////console.log(1839,t,i,this.disabledTables);
    },
    reserveTable(t)
    {
        //console.log(4326,t,i,this.reservedTables);
        if (t.length)
        {
          this.reservedTables.map(t => this.tables.find(ta => ta.tableId===t).reserved);
          //this.tables.find(ta => ta.tableId===t.tableId).status='unavailable'
          //this.disabledTablesName.push(t.name);
        }
        //console.log(4333,t,i,this.reservedTables);
    },    
    closeDialog_disableTable()
    {
      //console.log(2026,this.disabledTables,this.previousDisabledTables)
      //this.disabledTables=[...this.previousDisabledTables];
      //console.log(2028,this.disabledTables,this.previousDisabledTables)
      this.dialog_disableTable = false;
    },
    openDialog_reserveTable()
    {
      //this.disabledTables=this.tables.filter(t => t.status!==null).id
      //this.disabledTables=this.tables.filter(t => (t.isDisabled!==null||t.inactive==1)&&t.name ).map(t => t.tableId)
      //this.previousDisabledTables=[...this.disabledTables];
      //this.disabledTables_hash=JSON.stringify(this.disabledTables)
      ////console.log(1364,this.disabledTables)
      this.dialog_reserveTable=true;
    },    
    closeDialog_reserveTable()
    {
      //console.log(2026,this.disabledTables,this.previousDisabledTables)
      this.reservedTables=[...this.previousDisabledTables];
      //console.log(2028,this.disabledTables,this.previousDisabledTables)
      this.dialog_reserveTable = false;
    },
    async reserveTableSave(t)
    {
        this.loading=true;
        //console.log(1377,t);
        //let json= this.disabledTables.map(t => { return this.tables[t-1].name})
        ////console.log(1850,JSON.stringify(json))
        //let json= this.disabledTables.map(t => this.tables.find(ta => ta.tableId===t).name);
        ////console.log(1852,JSON.stringify(json))
        ////console.log(1379,json);
        let payload={"action":"reserveTable","payload":{"tableId":t.tableId,"date":this.date}};
        ////console.log(1381,payload)
        let w= await this.updateDB(payload)
        this.loading=false;
        ////console.log(1384,w);
        if(w.errorid=='0')
        {
            //this.dialog_disableTable = false;
            //this.dialog_accomplished_message=w.message;
            //this.dialog_accomplished = true;
            this.snackbar=true;
            this.snackbar_color='success'
            this.snackbar_message=w.message;            
        }
    },     
    async disableTableSave(t) // for grid!
    {
        this.loading=true;
        console.log(1377,t);
        /*
        if (this.disabledTables.includes(t.tableId))
        {
          this.tables.find(t1=>t1.tableId==t.tableId).isDisabled=true;
        }
        else
        {
          this.tables.find(t1=>t1.tableId==t.tableId).isDisabled=false;
        }
        */
        //this.disabledTables.push(t.tableId)
        console.log(1378,this.disabledTables);
        console.log(1379,this.tables);
        //let json= this.disabledTables.map(t => { return this.tables[t-1].name})
        ////console.log(1850,JSON.stringify(json))
        //let json= this.disabledTables.map(t => this.tables.find(ta => ta.tableId===t).name);
        ////console.log(1852,JSON.stringify(json))
        ////console.log(1379,json);
        let payload={"action":"dailyDisableTable","payload":{"tableId":t.tableId,"date":this.date}};
        console.log(1381,payload)
        let w= await this.updateDB(payload)
        this.loading=false;
        ////console.log(1384,w);
        if(w.errorid=='0')
        {
            //this.dialog_disableTable = false;
            //this.dialog_accomplished_message=w.message;
            //this.dialog_accomplished = true;
            this.currentTables.find(t=>t.tableId==w.tableId).color=w.newStatus?'error':'success';
            this.snackbar=true;
            this.snackbar_color='success'
            this.snackbar_message=w.message;            
        }
    }, 
    async updateDB(payload,endpoint='/booking/booking.php')
    {
      try{
            const res = await this.$http.post(endpoint, payload);
            ////console.log(1022,res);
            if (res.data.errorid=='0')
            {
              sessionStorage.setItem('jwt', res.data.jwt);
           }
            else
            {
              //console.log(1222);
              //this.$router.push('/auth/login').catch(() => {});
            }
            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
          this.loading= false;
          this.dialog_connectionError=true;
        }
    },
    getDifference(array1, array2) {
      return array1.filter(object1 => {
        return !array2.some(object2 => {
          return object1.id === object2.id;
        });
      });
    },

    eraseAssignment()
    {
      this.dialog_autoAssignEraseConfirmation=true;
      //this.simulateAssignment('erase');
    },
    selectBookingProps(t){
      const {locationId,hallId,tableId,tableName,xPos,yPos,active} = t;
      return {locationId,hallId,tableId,tableName,xPos,yPos,active};
    },
    buildPanView()
    {
      ////console.log(4815,this.slots,this.assignedHallsSlots)
      this.assignedHallsSlots=[... this.slots.filter(s=>s.mealId==this.mealId)];
      console.log(6699,this.slots,this.assignedHallsSlots)
      var nslot;
      var p;
      for (const k in [0,1,2,3])
      {
        nslot=this.assignedHallsSlots[this.assignedHallsSlots.length-1];
        console.log(6705,nslot,k)
        p=Math.floor((nslot.seconds+1800)/3600)+':'+('00'+(((nslot.seconds+1800)%3600)/60)).slice(-2)
        console.log(6707,p)
        this.assignedHallsSlots.push({name:p,mealId:nslot.mealId,seconds:nslot.seconds+1800})
      }
      console.log(6710,this.assignedHallsSlots)
      /*
      var nslot=this.assignedHallsSlots[this.assignedHallsSlots.length-1];
      ////console.log(4789,nslot)
      var p=Math.floor((nslot.seconds+1800)/3600)+':'+('00'+(((nslot.seconds+1800)%3600)/60)).slice(-2)
      this.assignedHallsSlots.push({name:p,mealId:nslot.mealId,seconds:nslot.seconds+1800})
      nslot=this.assignedHallsSlots[this.assignedHallsSlots.length-1];
      ////console.log(4793,nslot)
      p=Math.floor((nslot.seconds+1800)/3600)+':'+('00'+(((nslot.seconds+1800)%3600)/60)).slice(-2)
      this.assignedHallsSlots.push({name:p,mealId:nslot.mealId,seconds:nslot.seconds+1800})
      */
      var hours=nslot.seconds+3600-this.assignedHallsSlots.filter(s=>s.mealId===this.mealId)[0].seconds;
      var start=this.assignedHallsSlots.filter(s=>s.mealId===this.mealId)[0].seconds;
      /*
      //console.log(4828,this.assignedHallsSlots)
      //console.log(4829,hours,start)
      //console.log(4830,this.disabledTables)
      //console.log(4831,this.reservedTables)
      //console.log(4832,this.tables)
      */
      this.assignedHalls=this.tables.filter(t=>t.tableName).map(this.selectBookingProps).sort((a,b)=>(a.yPos>b.yPos))
      console.log(6606,this.assignedHalls);
      this.assignedHalls.forEach((t) =>
                                          {
                                            t.bookings=[];
                                            var z=this.BOO.filter(b=>b.tablesCombination.some(s=>s===t.tableName)).sort((a,b)=>a.rFrom-b.rFrom)
                                            ////console.log(z)
                                            z.forEach(z1=>{
                                              t.bookings.push({"name":z1.lastName,"covers":z1.covers,"children":z1.children,"begin":((z1.rFrom)-start),"starts":((z1.rFrom)-start)*100/hours,"ends":((z1.rTo)-start)*100/hours,"size":(z1.rTo-z1.rFrom)*100/hours,"duration":(z1.rTo-z1.rFrom)});
                                            })
                                            if (this.disabledTables.some(s=>s===t.tableId))
                                            {
                                              t.bookings.push({"name":"disabled"});   
                                            }
                                            if (this.reservedTables.some(s=>s===t.tableId))
                                            {
                                              t.bookings.push({"name":"reserved"});   
                                            }                                                        
                                            ////console.log(t.name,z)   
                                          }
                                ) 
      console.log(6474,this.assignedHalls);
    },
    async simulateAssignment(sub,reassign=0)
    {
      this.tablesAssigned=[];
      this.assignedHalls=[];
      this.assignedHallsSlots=[];
      this.unassignedReservations=[];
      this.dialog_assignedHalls=false
      //this.loading_simulate=true;
      switch(sub)
      {
        case 'erase_all':
          this.loading_cancelling_all=true;
        break;
        case 'erase':
          this.loading_cancelling_auto=true;
        break;
        default:
          this.loading_simulate=true;
      }
      if (reassign)
      {
        this.boo=JSON.stringify(this.BOO)
      }
      //try{
          const payload=JSON.stringify({"date": this.date,"mealId":this.mealId,"sub":sub,"action":"autoAssign_get","reassign":reassign,"requester":"ndb"});
          const res = await this.$http.post('/manage/manage.php', payload );
          ////console.log(834,res);
          this.loading_simulate=false
          this.loading_cancelling_auto=false;
          this.loading_cancelling_all=false;

            switch (res.data.errorid)
            {
              case '0':
                  if(sub=='test'||sub=='save')
                  {
                    if(!res.data.tablesAssigned.length)
                    {
                          this.snackbar_color='warning';
                          this.snackbar_message='Nessuna Assegnazione';
                          this.snackbar=true;
                          this.loading_simulate=false;
                    }
                    else
                    {
                      sessionStorage.setItem('jwt', res.data.jwt);
                      this.unassignedReservations=res.data.unassigned||[];
                      //this.tablesAssigned=res.data.tablesAssigned||[];
                      //this.disabledTables=res.data.disabledTables||[];
                      //this.alreadyAssigned=res.data.alreadyAssigned||[];
                      this.tablesAssignedDetailed=res.data.tablesAssignedDetailed||[];
                      this.BOO=res.data.BOO;
                      this.buildPanView()
                      if (sub=='test')
                      {
                        if (res.data.tablesAssigned.length&&this.settings.options.detailedAssignment=='00')
                          this.animateAutoAssign(res.data.tablesAssigned)
                        else
                        {
                          this.snackbar_color='success';
                          this.snackbar_message='Assegnazione Terminata';
                          this.snackbar=true;
                          this.loading_simulate=false;
                          this.tablesAssigned=res.data.tablesAssigned;
                        }
                      }
                      else
                      {
                        this.dialog_autoAssign=false;
                        this.dialog_confirmSaveAuto=false;
                        this.dialog_autoAssignEraseConfirmation=false;
                        this.loading_simulate=false;
                        this.getData(4880);                        
                      }
                      //console.log(4850,this.tablesAssignedDetailed)
                    }
                  }
                  else
                  {
                    this.dialog_autoAssign=false;
                    this.dialog_confirmSaveAuto=false;
                    this.dialog_autoAssignEraseConfirmation=false;
                    this.loading_simulate=false;
                    this.getData(4895);
                  }
              break;
              case '0006':
                  this.$router.push('/auth/login').catch(() => {});
              break;
            }
          /*
      } catch(e)
      {
          this.loading_datepicker= false;
          this.loading= false;
          this.dialog_connectionError=true;
      }*/
    },
    async animateAutoAssign(ass)
    {
        if(ass)
        {
          for (const f of ass)
          {
            this.tablesAssigned.push(f);
            await this.delay(50);
            ////console.log(3385,this.autoAssignLocked,!this.tablesAssigned.length,this.unassignedReservations.length)
            if (ass.length==this.tablesAssigned.length)
            {
              //console.log(3388,this.autoAssignLocked,!this.tablesAssigned.length,this.unassignedReservations.length)
              this.loading_simulate=false;
              this.snackbar_color='success';
              this.snackbar_message='Assegnazione Terminata';
              this.snackbar=true;
            }
          }
        }  
    },   
    async getMonthlyBookings()
    {
      if ( this.settings.level>50)
      {
        this.events=[];
        this.eventscolor=[];
        this.dialog_dateWide=true;
        this.loading_datepicker=true;
        
        try{
            const payload=JSON.stringify({"date": this.date,"action":"getMonthlyBookings"});
            const res = await this.$http.post('/manage/manage.php', payload );
            ////console.log(834,res);
            this.loading_datepicker=false
            switch (res.data.errorid)
            {
            case '0':
                sessionStorage.setItem('jwt', res.data.jwt);
                this.events=res.data.events?res.data.events:[];
                
            break;
            case '0006':
                this.$router.push('/auth/login').catch(() => {});
            break;
            }
        } catch(e)
        {
            this.loading_datepicker= false;
            this.loading= false;
            this.dialog_connectionError=true;
        }
      }
    },
    openDialogWalkIn()
    {

        this.activeHallId = null;
        this.showiManagerMap = false;
        this.showManualAssignMap = false;
        this.freeTables_all = null;

      ////console.log(2638,this.settings,JSON.stringify(this.settings))
      this.booking.date=new Date(this.date).toISOString().split('T')[0];
      this.pickedDate=new Date(this.date).toISOString().split('T')[0];
      this.booking.firstName=''
      this.booking.lastName=''
      this.booking.fullName=''
      this.booking.phone=''
      this.booking.remarks=''
      this.booking.covers=null
      this.booking.children=null
      //this.booking.date=new Date().toISOString().split('T')[0];
      console.log(7710,this.booking.date)
      this.canvaWidthVolante=(this.$refs.dialogVolante.offsetWidth*7/12)*.95-20
      this.canvaHeightVolante=(this.$refs.dialogVolante.offsetHeight)-100
      //this.CL(7713,this.canvaWidthVolante,this.canvaHeightVolante,this.canvaWidth,this.canvaHeight)
      this.showiManagerMap=false;
      this.newVolanteOrEdit='n';
      this.dialog_walkIn=true; //dialogVolante
      this.userDetails=null
    },  
    async openDialogPanView()
    {
      this.assignedHalls=[];
      this.assignedHallsSlots=[];
      this.dialog_assignedHalls=false
      this.loading_panView=true;
      const payload=JSON.stringify({"date": this.date,"mealId":this.mealId,"sub":"test","action":"autoAssign_get","reassign":0,"requester":"ndb"});
      const res = await this.$http.post('/manage/manage.php', payload );
      ////console.log(834,res);
      this.loading_simulate=false
      this.loading_panView=false;
      this.loading_cancelling_auto=false;
      this.loading_cancelling_all=false;

        switch (res.data.errorid)
        {
          case '0':
            this.BOO=res.data.BOO;
            this.unassigned=res.data.unassigned;
            this.buildPanView()
            this.dialog_assignedHalls=true;
          break;
        case '0006':
            this.$router.push('/auth/login').catch(() => {});
        break;            
        }
    },
    DateToFormattedString(d) {                                         
        var yyyy = d.getFullYear().toString();                                    
        var mm = (d.getMonth()+1).toString(); // getMonth() is zero-based         
        var dd  = d.getDate().toString();             
        return yyyy + '-' + (mm[1]?mm:"0"+mm[0]) + '-' + (dd[1]?dd:"0"+dd[0]);
    },
    fdate(d)
    {
      console.log(8756,d)
      return new Date(d).toLocaleDateString("it-IT",{weekday: "long",  month: "long",  day: "numeric",})+ ' - '+new Date(d).toLocaleTimeString("it-IT")
    },
    GetDate(days, resetToToday = false) {
      const dateOptions = { month: 'long', day: 'numeric', weekday: 'long' };
      const dateOptions2 = { month: 'short', day: 'numeric', weekday: 'short' };

      // If resetToToday is true, force base date to current time (new Date())
      let result = (resetToToday || this.date == null) ? new Date() : new Date(this.date);

      if (!resetToToday) {
        result.setDate(result.getDate() + days);
      }

      this.isWalkInSlim = false;
      this.date = this.DateToFormattedString(result);
      this.$store.dispatch('setDate', this.date);
      this.dateString = result.toLocaleDateString('it-IT', dateOptions);
      this.dateString2 = result.toLocaleDateString('it-IT', dateOptions2);

      this.loading = true;
      this.getData(1996);
    },     
    GetDate_old(days)
    {
      const dateOptions = { month: 'long', day: 'numeric',weekday: 'long' };
      const dateOptions2 = { month: 'short', day: 'numeric',weekday: 'short' };
      var result = this.date==null?new Date():new Date(this.date);
      result.setDate(result.getDate() + days)
      this.isWalkInSlim=false;
      //this.showiManagerMap=0;
      //result.setHours(result.getHours())
      this.date= this.DateToFormattedString(result);//result.toISOString().split('T')[0];
      this.$store.dispatch("setDate",this.date);
      this.dateString=result.toLocaleDateString('it-IT', dateOptions);
      this.dateString2=result.toLocaleDateString('it-IT', dateOptions2);
      ////console.log(809,this.date,this.dateString)
      this.loading=true;
      this.getData(1996)
      //this.getFreeSlots()
    },
    async getData(row=null)
    {
      //console.log(6137,row,this.date);
      this.loading=true;
      const jwt=row=='jwt'?0:1;
      //this.showiManagerMap=0;
      //this.showManualAssignMap=0;
      this.dialog_connectionError=false;
      this.bookings_previous=this.bookings?JSON.parse(JSON.stringify(this.bookings)):null;
      //try{
          const payload=JSON.stringify({"date": this.date,"action":"getBookings","jwt":jwt});
          const res = await this.$http.post('/manage/manage.php', payload );
          //console.log(6144,res, new Date());
          this.loading= false;
          switch (res.data.errorid)
          {
            case '0':
                document.title = this.settings.brand+' | '+this.page;
                sessionStorage.setItem('jwt', res.data.jwt);
                //console.log(6151,res.data.payloads.expired)
                this.expired=res.data.payloads.expired;
                this.snackbar_expired=this.expired.showAlert&&this.settings.level>=50
                this.addressBookCount=res.data.payloads.addressBook.addressCount
                /*
                if(res.data.payloads.expired.expired==1)
                {
                  this.snackbar_color='error';
                  this.snackbar_message='modulo scaduto';
                  this.snackbar=true;
                }*/


                this.bookings=res.data.payloads.bookings?res.data.payloads.bookings:[];
                this.previousConfirmationTooltip=Array(this.bookings.length).fill(false)
                console.log(8014,this.previousConfirmationTooltip)
                /*
                if (this.bookings_previous)
                {
                  this.rowToBlink=this.getDifference(this.bookings, this.bookings_previous)
                  //console.log(1999,this.bookings,this.bookings_previous,this.rowToBlink)
                }
                */

                this.tables=res.data.payloads.tables;
                this.shifts=res.data.payloads.shifts;
                this.halls=res.data.payloads.halls;
                this.locations=res.data.payloads.locations;
                this.disabledTables=this.tables.filter(t => (t.isDisabled!==null||t.inactive==1)&&t.name ).map(t => t.tableId)
                this.reservedTables=this.tables.filter(t => (t.reserved)&&t.tableName ).map(t => t.tableId)
                this.slots=res.data.payloads.slots;
                this.covers=res.data.payloads.locations[0].covers;
                this.meals=res.data.payloads.meals;
                this.foodStyles=res.data.payloads.foodStyles?[...res.data.payloads.foodStyles]:[];
                this.requests=res.data.payloads.requests?[...res.data.payloads.requests]:[];
                this.userRatings=res.data.payloads.userRatings;
                this.mealDurations=res.data.payloads.mealDurations;
                this.trackedItems=res.data.payloads.trackedItems;
                
                //console.log(6417,this.activeLocationId)
                var p=null;
                p={"action":"meals","pl":this.meals};
                this.$store.dispatch("synchro",p);
                p={"action":"slots","pl":this.slots};
                this.$store.dispatch("synchro",p);
                p={"action":"halls","pl":this.halls};
                this.$store.dispatch("synchro",p);

                //this.$store.dispatch("setTBM", res.data.payloads.TBM);
                


                if (!this.booking.foodStyles)
                {
                  this.booking.foodStyles=this.foodStyles;
                  this.booking.requests=this.requests;//[...res.data.manage.requests];
                }
                
                this.captions=res.data.payloads.captions;

                if(res.data.payloads.currentValues&&!this.mealId)
                {
                  this.mealId=this.meals.length==1?this.meals[0].mealId:res.data.payloads.currentValues.mealId;
                  this.mealFilter=this.mealId;
                  //this.activeSlotId=res.data.payloads.currentValues.slotId;
                  this.currentValues=res.data.payloads.currentValues;
                  //console.log(6216,this.mealId,this.activeSlot)
                  p={"action":"currentValues","pl":res.data.payloads.currentValues};
                  this.$store.dispatch("synchro",p);
                }
                console.log(6472,this.activeSlotId)

                console.log(8705,this.settings.level,this.settings.username,this.settings.avatar)
                //this.settings.username=JSON.parse(sessionStorage.getItem('settings')).username;
                //this.settings.level=parseInt(JSON.parse(sessionStorage.getItem('settings')).level);
                //this.settings.avatar=JSON.parse(sessionStorage.getItem('settings')).avatar;
                console.log(8708,this.settings.level,this.settings.username,this.settings.avatar)
                this.oldHash=this.resHash;
                this.resHash=res.data.payloads.resHash;
                this.activeLocationId=null;
                this.activeHallId=null
                this.statusPDF=0
                //console.log(6909,'resHash:'+this.resHash+' - oldHash:'+this.oldHash)
                if(this.oldHash!=this.resHash)
                {
                  console.log(7918)
                  this.getFreeSlots('map',8200)
                }                
            break;
            case '0007':
              var responsePayload=JSON.parse(res.data.payload)
              this.errorTitle=responsePayload.errorInfo[2];
              this.errorMessage=responsePayload.xdebug_message;
              //console.log(6231,res.data.payload,this.errorMessage,this.errorTitle)
              this.dialog_connectionError=true;
            break;
            case '0006':
                this.$router.push('/auth/login').catch(() => {});
            break;
          }/*  
      } catch(e)
      {
        this.loading= false;
        this.dialog_connectionError=true;
      }*/
      //console.log(6243,this.$refs)
      return true;
    },    
    reset()
    {
        //this.booking={locationId:null,hallId:null,mealId:null,slotId:null,bookingId:null,countryCode:39,covers:null,children:null,date:null,lastName:null,firstName:null,requests:[],foodStyles:[],phone:null,time:null,optIn:false,tables:[],tablesId:[],waitingListTime:null,sendWAConfirmation:1};
        this.booking=JSON.parse(JSON.stringify(this.emptyBooking))
        this.booking.requests=[...this.requests];
        this.booking.foodStyles=[...this.foodStyles];
        this.selectedSlotIdEdit=null;
        this.selectedSlotIdEdit_copy=null;
        //console.log(2175,this.booking.requests,this.requests,this.booking.foodStyles)
        /*this.requests.map(o => {o.value=o.requestId=='chairs'?0:false});
        this.covers=null;       
        this.time=null;
        this.slotId=null;
        this.area=null;
        this.locationId=null;
        this.fullname=null;
        this.phone=null;
        this.remarks=null;*/
       
    },
    itemClass: function (item) {
        var clr;
        var c=(item.seconds/1800)%2;
        ////console.log(5068,item,item.slid,'=>',c)
        if (this.rowToBlink.some(k =>k===item.bookingId))
        { 
          clr = 'blink';
        }
        else if (item)
        {
          if(this.$vuetify.theme.dark)
          {
            clr=c==0?'blue-grey darken-4':(c==1?'blue-grey darken-3':(c==2?'blue-grey darken-2':'blue-grey darken-1'))
          }
          else
          {
            clr=c==0?'blue-grey lighten-3':(c==1?'blue-grey lighten-4':(c==2?'blue-grey lighten-2':'blue-grey lighten-1'))
            //clr=item.slid % 4?'blue-grey ':(item.slid % 3?(item.slid % 2?'blue-grey black--text lighten-5':'blue-grey lighten-3'):'blue-grey lighten-1')
          }
          ////console.log(1629,clr)
          /*
          2025.05.12
          var notAssignable=this.freeTables_all&&this.freeTables_all[0]?.unassignedBookings.find(f=>f.bookingId==item.bookingId)
          console.log(8536,notAssignable)
          if(notAssignable)
          {
            clr='red darken-2';
          }
          */
        }
        return clr;
    },
    itemClass_editButton: function (item) {
      var clr=''
      //console.log(8666,item,item.bookingId)
      if(item)
      {
        var notAssignable=this.freeTables_all?.[0]?.unassignedBookings?.find(f=>f.bookingId==item.bookingId)
        //clr=notAssignable&&item.tables?.length==0?'error':item.arrived?'info':''
        clr=notAssignable&&!item.tables?'error':item.arrived?'info':''
        //console.log(8671,notAssignable,clr)
      }
      return clr;
    },    
	pollData () {
      var delay=localStorage.getItem('dev')?500000000000:parseInt(this.settings.options.refreshRate)*1000;
      this.polling = setInterval(() => {
        console.log(8837,'polldata',this.showManualAssignMap,this.showiManagerMap,this.dialog_walkIn)
        if((!this.showManualAssignMap&&!this.showiManagerMap)&&!this.dialog_walkIn)
        {
          console.log(8840,'fetching data from polling')
          this.getData('jwt')
        }
      }, delay)
    },
    blink(item) {
      //if (this.rowToBlink.map(r => item.id==r)) return 'blink';
      if (this.rowToBlink.some(k =>k===item.id)) return 'blink';
      //rows.map(r => i.some(k => k===r.id))
      return '';
    },
    delay(milliseconds){
        return new Promise(resolve => {
            setTimeout(resolve, milliseconds);
        });
    }
  },
  beforeDestroy () {
    clearInterval(this.polling)
  },

};
</script>
<style>
  .v-data-table-header__sort-badge, .v-data-table-header__icon{
    font-size:12px!important
  }
  .wide_dp .v-btn{
    margin: 10px 0!important;
    padding: 15px!important;
  }
  .wide_dp .v-btn .v-btn__content{
    font-size: 1.5rem!important;
    line-height: 2rem!important;
  }
  .wide_dp .v-btn .v-date-picker-table__events{
    margin-bottom: -3px!important;
    color: #42a5f5!important;
    font-weight:900;
  }
  .v-dialog{
  margin:0!important
  }
  .v-pagination__navigation{
    margin: .3rem 3px;
  }
  .v-pagination__item{
    margin: .3rem 3px;
  }
</style>

<style>
.col-20 {
    -ms-flex: 0 0 5%;
    flex: 0 0 5%;
    max-width: 5%;
}
.blink {
  animation: blinking ease-out 1s 2;
  animation-iteration-count: infinite;
}
.no-uppercase {
     text-transform: unset !important;
}
.disable-events {
  pointer-events: none
}
.transparent-bg{
  background:transparent!important;
}
.centered-input input {
  text-align: center!important
}
.rotateIcon{
    width:100px;
    display:block;
    height:30px;
    background:transparent;
    color:black;
    text-decoration:none;
}
.rotateIcon:after{
  font-family: "Material Design Icons";
  content: "\F1999";
  display: inline-block;
  padding-right: 3px;
  margin-top: -5px;
  vertical-align: middle;
  font-weight: 900;
}
.lateIcon{
    width:100px;
    display:block;
    height:30px;
    background:transparent;
    color:red;
    text-decoration:none;
}
.lateIcon:after{
  font-family: "Material Design Icons";
  content: "\F0026";
  display: inline-block;
  padding-right: 3px;
  margin-top: -5px;
  vertical-align: middle;
  font-weight: 900;
}

.kaki{
  background-color:darkkhaki!important;
}

@keyframes blinking {
  0% {
    background-color: #06c3d1;
  }
  100% {
    background-color: #fff;
  }
}
</style>

<style scoped>
.v-btn.table-shape-squared{
    border-radius: 0px !important;
}
.v-btn.table-shape-rounded{
    border-radius: 10px !important;
}
.v-btn.table-shape-round{
    border-radius: 50% !important;
}
.text-mini{
    font-size: .65rem !important;
}
.text-micro{
    font-size: .55rem !important;
}
.v-data-table-header th {
  white-space: nowrap;
}
</style>